import * as React from "react";
import wrapIcon from "../utils/wrapIcon";

const ColumnEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.5c0-.28.22-.5.5-.5H4a2 2 0 012 2v10a2 2 0 01-2 2h-.5a.5.5 0 010-1H4a1 1 0 001-1V5a1 1 0 00-1-1h-.5a.5.5 0 01-.5-.5zM9 4a1 1 0 00-1 1v10a1 1 0 001 1h.47l-.04.16-.21.84H9a2 2 0 01-2-2V5c0-1.1.9-2 2-2h2a2 2 0 012 2v6.94l-1 1V5a1 1 0 00-1-1H9zm6 1v4.94l-1 1V5c0-1.1.9-2 2-2h.5a.5.5 0 010 1H16a1 1 0 00-1 1zm-4.02 10.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const ColumnEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnEditRegularIcon({}), 'ColumnEditRegular');

const ColumnTripleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3a1 1 0 00-1 1v12a1 1 0 001 1h2a1 1 0 001-1V4a1 1 0 00-1-1H4zm5 0a1 1 0 00-1 1v12a1 1 0 001 1h2a1 1 0 001-1V4a1 1 0 00-1-1H9zm5 0a1 1 0 00-1 1v12a1 1 0 001 1h2a1 1 0 001-1V4a1 1 0 00-1-1h-2z",
    fill: primaryFill
  }));
};

export const ColumnTripleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnTripleFilledIcon({}), 'ColumnTripleFilled');

const ColumnTripleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm3 0H4v12h2V4zm2 0a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H9a1 1 0 01-1-1V4zm3 0H9v12h2V4zm3-1a1 1 0 00-1 1v12a1 1 0 001 1h2a1 1 0 001-1V4a1 1 0 00-1-1h-2zm0 1h2v12h-2V4z",
    fill: primaryFill
  }));
};

export const ColumnTripleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnTripleRegularIcon({}), 'ColumnTripleRegular');

const ColumnTripleEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3a1 1 0 00-1 1v12a1 1 0 001 1h2a1 1 0 001-1V4a1 1 0 00-1-1H4zm5 0a1 1 0 00-1 1v12a1 1 0 001 1h.22l.21-.84a3.2 3.2 0 01.84-1.49L12 12.94V4a1 1 0 00-1-1H9zm8 1v5c-.69.03-1.37.31-1.9.84l-2.1 2.1V4a1 1 0 011-1h2a1 1 0 011 1zm-6.02 11.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const ColumnTripleEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnTripleEditFilledIcon({}), 'ColumnTripleEditFilled');

const ColumnTripleEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm3 0H4v12h2V4zm2 0a1 1 0 011-1h2a1 1 0 011 1v8.94l-1 1V4H9v12h.47l-.04.16-.21.84H9a1 1 0 01-1-1V4zm9 0v5c-.34.02-.68.1-1 .23V4h-2v6.94l-1 1V4a1 1 0 011-1h2a1 1 0 011 1zm-6.02 11.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const ColumnTripleEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnTripleEditRegularIcon({}), 'ColumnTripleEditRegular');

const CommentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h10.8C16.84 3 18 4.15 18 5.57v6.7a2.58 2.58 0 01-2.6 2.57h-4.59L6.8 17.8zm-.6-.8z",
    fill: primaryFill
  }));
};

export const CommentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentFilledIcon({}), 'CommentFilled');

const CommentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.48 13.84h4.92c.9 0 1.6-.71 1.6-1.56V5.57C17 4.7 16.3 4 15.4 4H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16zM6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h10.8C16.84 3 18 4.15 18 5.57v6.7a2.58 2.58 0 01-2.6 2.57h-4.59L6.8 17.8z",
    fill: primaryFill
  }));
};

export const CommentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentRegularIcon({}), 'CommentRegular');

const CommentAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm-.5 7.5c1.33 0 2.55-.47 3.5-1.26v2.54a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h5a5.5 5.5 0 004.9 8z",
    fill: primaryFill
  }));
};

export const CommentAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentAddFilledIcon({}), 'CommentAddFilled');

const CommentAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm2 8.78V10.4c.36-.18.7-.4 1-.66v2.54a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h5c-.16.32-.3.65-.4 1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56z",
    fill: primaryFill
  }));
};

export const CommentAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentAddRegularIcon({}), 'CommentAddRegular');

const CommentArrowLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 6h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2zM14.5 11c1.33 0 2.55-.47 3.5-1.26v2.54a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h5a5.5 5.5 0 004.9 8z",
    fill: primaryFill
  }));
};

export const CommentArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentArrowLeftFilledIcon({}), 'CommentArrowLeftFilled');

const CommentArrowLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 6h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2zM17 12.28V10.4c.36-.18.7-.4 1-.66v2.54a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h5c-.16.32-.3.65-.4 1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56z",
    fill: primaryFill
  }));
};

export const CommentArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentArrowLeftRegularIcon({}), 'CommentArrowLeftRegular');

const CommentArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 6.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zM10.5 6a.5.5 0 000 1h4.8l-1.65 1.65a.5.5 0 00.7.7l2.5-2.5a.5.5 0 000-.7l-2.5-2.5a.5.5 0 00-.7.7L15.29 6H10.5zm3 7c1.75 0 3.33-.69 4.5-1.81v1.09a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h3.42a6.5 6.5 0 005.48 10z",
    fill: primaryFill
  }));
};

export const CommentArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentArrowRightFilledIcon({}), 'CommentArrowRightFilled');

const CommentArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 6.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zM10.5 6a.5.5 0 000 1h4.8l-1.65 1.65a.5.5 0 00.7.7l2.5-2.5a.5.5 0 000-.7l-2.5-2.5a.5.5 0 00-.7.7L15.29 6H10.5zm6.5 6.28v-.3c.36-.23.7-.5 1-.79v1.09a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h3.42c-.2.32-.38.65-.52 1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56z",
    fill: primaryFill
  }));
};

export const CommentArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentArrowRightRegularIcon({}), 'CommentArrowRightRegular');

const CommentCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 6.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-2.15-2.35a.5.5 0 00-.7 0L12.5 7.79l-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 000-.7zM13.5 13c1.75 0 3.33-.69 4.5-1.81v1.09a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h3.42a6.5 6.5 0 005.48 10z",
    fill: primaryFill
  }));
};

export const CommentCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentCheckmarkFilledIcon({}), 'CommentCheckmarkFilled');

const CommentCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 6.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-2.15-2.35a.5.5 0 00-.7 0L12.5 7.79l-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 000-.7zm.15 8.13v-.3c.36-.23.7-.5 1-.79v1.09a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h3.42c-.2.32-.38.65-.52 1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56z",
    fill: primaryFill
  }));
};

export const CommentCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentCheckmarkRegularIcon({}), 'CommentCheckmarkRegular');

const CommentDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L15.21 5.5l1.14-1.15zM14.5 11c1.33 0 2.55-.47 3.5-1.26v2.54a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h5a5.5 5.5 0 004.9 8z",
    fill: primaryFill
  }));
};

export const CommentDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentDismissFilledIcon({}), 'CommentDismissFilled');

const CommentDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-3.8 0l1.15-1.15a.5.5 0 00-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L15.21 5.5zm1.8 6.78V10.4c.36-.18.7-.4 1-.66v2.54a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h5c-.16.32-.3.65-.4 1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56z",
    fill: primaryFill
  }));
};

export const CommentDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentDismissRegularIcon({}), 'CommentDismissRegular');

const CommentEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.4 17.6a1 1 0 001.4.2L8 16.9l.05-.25.37-1.5a3.2 3.2 0 01.84-1.48l4.83-4.83A2.87 2.87 0 0118 8.7V5.57A2.58 2.58 0 0015.4 3H4.6A2.58 2.58 0 002 5.57v6.7a2.58 2.58 0 002.6 2.57h.6v2.17c0 .22.07.42.2.6zm9.4-8.05l-4.82 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.07 1.07l1.5-.37c.39-.1.74-.3 1.02-.58l4.83-4.83a1.87 1.87 0 10-2.64-2.64z",
    fill: primaryFill
  }));
};

export const CommentEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentEditFilledIcon({}), 'CommentEditFilled');

const CommentEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 8.13V5.57C17 4.7 16.3 4 15.4 4H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l2.17-1.6-.31 1.25-.05.26-1.21.9a1 1 0 01-1.4-.2.98.98 0 01-.2-.6v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h10.8C16.84 3 18 4.15 18 5.57v3.12c-.3-.26-.64-.44-1-.56zm-2.2 1.42l-4.82 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.07 1.07l1.5-.37c.39-.1.74-.3 1.02-.58l4.83-4.83a1.87 1.87 0 10-2.64-2.64z",
    fill: primaryFill
  }));
};

export const CommentEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentEditRegularIcon({}), 'CommentEditRegular');

const CommentErrorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 3a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.25zM18 9.73A5.5 5.5 0 019.6 3h-5A2.58 2.58 0 002 5.57v6.7a2.58 2.58 0 002.6 2.57h.6v2.17c0 .22.07.42.2.6a1 1 0 001.4.2l4.01-2.97h4.59c1.44 0 2.6-1.15 2.6-2.56V9.74z",
    fill: primaryFill
  }));
};

export const CommentErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentErrorFilledIcon({}), 'CommentErrorFilled');

const CommentErrorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 3a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.25zM17 10.4v1.88c0 .85-.7 1.56-1.6 1.56h-4.92L6.21 17H6.2v-3.16H4.6c-.9 0-1.6-.71-1.6-1.56V5.57C3 4.7 3.7 4 4.6 4h4.6c.1-.35.24-.68.4-1h-5A2.58 2.58 0 002 5.57v6.7a2.58 2.58 0 002.6 2.57h.6v2.17c0 .22.07.42.2.6a1 1 0 001.4.2l4.01-2.97h4.59c1.44 0 2.6-1.15 2.6-2.56V9.74c-.3.26-.64.48-1 .66z",
    fill: primaryFill
  }));
};

export const CommentErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentErrorRegularIcon({}), 'CommentErrorRegular');

const CommentLightningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.12-3a.5.5 0 00-.47.33l-.88 2.5A.5.5 0 0013 6h.78l-.51 1.87a.5.5 0 00.9.4l2.25-3.5A.5.5 0 0016 4h-.75l.28-.84a.5.5 0 00-.47-.66h-1.18zm.62 8.5c1.33 0 2.55-.47 3.5-1.26v2.54a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h5a5.5 5.5 0 004.9 8z",
    fill: primaryFill
  }));
};

export const CommentLightningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentLightningFilledIcon({}), 'CommentLightningFilled');

const CommentLightningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.12-3a.5.5 0 00-.47.33l-.88 2.5A.5.5 0 0013 6h.78l-.51 1.87a.5.5 0 00.9.4l2.25-3.5A.5.5 0 0016 4h-.75l.28-.84a.5.5 0 00-.47-.66h-1.18zM17 12.28V10.4c.36-.18.7-.4 1-.66v2.54a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h5c-.16.32-.3.65-.4 1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56z",
    fill: primaryFill
  }));
};

export const CommentLightningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentLightningRegularIcon({}), 'CommentLightningRegular');

const CommentMentionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 2a3 3 0 101.28 5.71.5.5 0 01.44.9A4 4 0 1119 5v.51a1.5 1.5 0 01-2.65.97A2 2 0 0113 5a2 2 0 013.04-1.7.5.5 0 01.96.2v2a.5.5 0 101 0V5a3 3 0 00-3-3zm-1 3a1 1 0 102 0 1 1 0 00-2 0zm1 5c1.13 0 2.16-.37 3-1v3.28a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3h5.82A4.98 4.98 0 0015 10z",
    fill: primaryFill
  }));
};

export const CommentMentionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMentionFilledIcon({}), 'CommentMentionFilled');

const CommentMentionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 2a3 3 0 101.28 5.71.5.5 0 01.44.9A4 4 0 1119 5v.51a1.5 1.5 0 01-2.65.97A2 2 0 0113 5a2 2 0 013.04-1.7.5.5 0 01.96.2v2a.5.5 0 101 0V5a3 3 0 00-3-3zm-1 3a1 1 0 102 0 1 1 0 00-2 0zm4 7.28V9a5 5 0 01-1 .58v2.7c0 .85-.7 1.56-1.6 1.56h-4.92L6.21 17H6.2v-3.16H4.6c-.9 0-1.6-.71-1.6-1.56V5.57C3 4.7 3.7 4 4.6 4h5.5c.07-.35.18-.68.32-1H4.6A2.58 2.58 0 002 5.57v6.7a2.58 2.58 0 002.6 2.57h.6v2.17c0 .22.07.42.2.6a1 1 0 001.4.2l4.01-2.97h4.59c1.44 0 2.6-1.15 2.6-2.56z",
    fill: primaryFill
  }));
};

export const CommentMentionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMentionRegularIcon({}), 'CommentMentionRegular');

const CommentMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2a2.5 2.5 0 00-2.46 2.03C4.2 4 4.34 4 4.5 4h8A3.5 3.5 0 0116 7.5v5.45a2.5 2.5 0 002-2.45V6a4 4 0 00-4-4H6.5zm-2 3A2.5 2.5 0 002 7.5v6A2.5 2.5 0 004.5 16H5v1.03a1 1 0 001.58.81L9.16 16h3.34a2.5 2.5 0 002.5-2.5v-6A2.5 2.5 0 0012.5 5h-8z",
    fill: primaryFill
  }));
};

export const CommentMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMultipleFilledIcon({}), 'CommentMultipleFilled');

const CommentMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2a2.5 2.5 0 00-2.46 2.04A2.5 2.5 0 002 6.5v7A2.5 2.5 0 004.5 16H5v1.03a1 1 0 001.58.81L9.16 16h4.34a2.5 2.5 0 002.5-2.5v-.55a2.5 2.5 0 002-2.45v-5A3.5 3.5 0 0014.5 2h-8zm7 13H8.84L6 17.03V15H4.5A1.5 1.5 0 013 13.5v-7C3 5.67 3.67 5 4.5 5h9c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5zm0-11H5.09c.2-.58.76-1 1.41-1h8A2.5 2.5 0 0117 5.5v5c0 .65-.42 1.2-1 1.41V6.5A2.5 2.5 0 0013.5 4z",
    fill: primaryFill
  }));
};

export const CommentMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMultipleRegularIcon({}), 'CommentMultipleRegular');

const CommentMultipleCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2a2.5 2.5 0 00-2.46 2.03C4.2 4 4.34 4 4.5 4h8A3.5 3.5 0 0116 7.5v1.7c.74.22 1.42.58 2 1.06V6a4 4 0 00-4-4H6.5zM15 7.5v1.52A5.5 5.5 0 009.2 16h-.04l-2.58 1.84A1 1 0 015 17.03V16h-.5A2.5 2.5 0 012 13.5v-6A2.5 2.5 0 014.5 5h8A2.5 2.5 0 0115 7.5zm4 7a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-2.15-1.85c.2.2.2.5 0 .7l-3 3a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 2.65-2.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const CommentMultipleCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMultipleCheckmarkFilledIcon({}), 'CommentMultipleCheckmarkFilled');

const CommentMultipleCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2a2.5 2.5 0 00-2.46 2.04A2.5 2.5 0 002 6.5v7A2.5 2.5 0 004.5 16H5v1.03a1 1 0 001.58.81L9.16 16h.05c-.1-.32-.16-.66-.19-1h-.18L6 17.03V15H4.5A1.5 1.5 0 013 13.5v-7C3 5.67 3.67 5 4.5 5h9c.83 0 1.5.67 1.5 1.5v2.52c.34.03.68.1 1 .19V6.5A2.5 2.5 0 0013.5 4H5.09c.2-.58.76-1 1.41-1h8A2.5 2.5 0 0117 5.5v4.1c.36.18.7.4 1 .66V5.5A3.5 3.5 0 0014.5 2h-8zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const CommentMultipleCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMultipleCheckmarkRegularIcon({}), 'CommentMultipleCheckmarkRegular');

const CommentMultipleLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2a2.5 2.5 0 00-2.46 2.03C4.2 4 4.34 4 4.5 4h8A3.5 3.5 0 0116 7.5V11h.5c.49 0 .95.1 1.38.28.08-.24.12-.5.12-.78V6a4 4 0 00-4-4H6.5zM15 7.5V11h-2.5a3.5 3.5 0 00-3.16 5h-.18l-2.58 1.84A1 1 0 015 17.03V16h-.5A2.5 2.5 0 012 13.5v-6A2.5 2.5 0 014.5 5h8A2.5 2.5 0 0115 7.5zM12.5 12a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const CommentMultipleLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMultipleLinkFilledIcon({}), 'CommentMultipleLinkFilled');

const CommentMultipleLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2a2.5 2.5 0 00-2.46 2.04A2.5 2.5 0 002 6.5v7A2.5 2.5 0 004.5 16H5v1.03a1 1 0 001.58.81L9.16 16h.18a3.48 3.48 0 01-.3-1h-.2L6 17.03V15H4.5A1.5 1.5 0 013 13.5v-7C3 5.67 3.67 5 4.5 5h9c.83 0 1.5.67 1.5 1.5V11h1V6.5A2.5 2.5 0 0013.5 4H5.09c.2-.58.76-1 1.41-1h8A2.5 2.5 0 0117 5.5v5c0 .18-.03.36-.1.52.35.04.67.13.98.26.08-.24.12-.5.12-.78v-5A3.5 3.5 0 0014.5 2h-8zm6 10a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const CommentMultipleLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMultipleLinkRegularIcon({}), 'CommentMultipleLinkRegular');

const CommentNoteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.5 1c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-6zm1 5h4a.5.5 0 010 1h-4a.5.5 0 010-1zM12 3.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zM4.6 3H9v4.5a2.5 2.5 0 002.5 2.5h6c.17 0 .34-.02.5-.05v2.33a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3z",
    fill: primaryFill
  }));
};

export const CommentNoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentNoteFilledIcon({}), 'CommentNoteFilled');

const CommentNoteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.5 1c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-6zm1 5h4a.5.5 0 010 1h-4a.5.5 0 010-1zM12 3.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zM4.6 3H9v1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56V10h.5c.17 0 .34-.02.5-.05v2.33a2.58 2.58 0 01-2.6 2.56h-4.59L6.8 17.8a1 1 0 01-1.4-.2.98.98 0 01-.2-.59v-2.17h-.6A2.58 2.58 0 012 12.28V5.57A2.58 2.58 0 014.6 3z",
    fill: primaryFill
  }));
};

export const CommentNoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentNoteRegularIcon({}), 'CommentNoteRegular');

const CommentOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l.76.77C2.35 4.09 2 4.79 2 5.57v6.7a2.58 2.58 0 002.6 2.57h.6v2.17c0 .22.07.42.2.6a1 1 0 001.4.2l4.01-2.97h3.33l3 3.01a.5.5 0 00.71-.7l-2.3-2.31L3.82 3.12l-.97-.97zM18 12.28c0 .97-.55 1.81-1.35 2.25L5.12 3H15.4C16.84 3 18 4.15 18 5.57v6.7z",
    fill: primaryFill
  }));
};

export const CommentOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentOffFilledIcon({}), 'CommentOffFilled');

const CommentOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l.76.77C2.35 4.09 2 4.79 2 5.57v6.7a2.58 2.58 0 002.6 2.57h.6v2.17c0 .22.07.42.2.6a1 1 0 001.4.2l4.01-2.97h3.33l3 3.01a.5.5 0 00.71-.7l-2.3-2.31L3.82 3.12l-.97-.97zm10.29 11.7h-2.66L6.21 17H6.2v-3.16H4.6c-.9 0-1.6-.71-1.6-1.56V5.57c0-.5.24-.95.62-1.24l9.52 9.51zM17 12.27c0 .69-.46 1.28-1.11 1.49l.76.76A2.56 2.56 0 0018 12.28V5.57A2.58 2.58 0 0015.4 3H5.12l1 1h9.28c.9 0 1.6.71 1.6 1.57v6.7z",
    fill: primaryFill
  }));
};

export const CommentOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentOffRegularIcon({}), 'CommentOffRegular');

const CommunicationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 11a6.5 6.5 0 1111.1 4.6.75.75 0 101.06 1.05 8 8 0 10-11.33 0A.75.75 0 005.4 15.6 6.48 6.48 0 013.5 11zm3 0a3.5 3.5 0 115.98 2.47.75.75 0 101.06 1.06A4.99 4.99 0 0010 6a5 5 0 00-3.54 8.53.75.75 0 001.06-1.06A3.49 3.49 0 016.5 11zM10 9a2 2 0 100 4 2 2 0 000-4z",
    fill: primaryFill
  }));
};

export const CommunicationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommunicationFilledIcon({}), 'CommunicationFilled');

const CommunicationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 4a7 7 0 00-4.95 11.95.5.5 0 01-.7.7 8 8 0 1111.32 0 .5.5 0 01-.72-.7A7 7 0 0010 4zm0 3a4 4 0 00-2.83 6.82.5.5 0 11-.71.71A4.99 4.99 0 0110 6a5 5 0 013.54 8.53.5.5 0 01-.71-.7A3.99 3.99 0 0010 7zm0 2a2 2 0 100 4 2 2 0 000-4zm-1 2a1 1 0 112 0 1 1 0 01-2 0z",
    fill: primaryFill
  }));
};

export const CommunicationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommunicationRegularIcon({}), 'CommunicationRegular');

const CommunicationPersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 4.5a6.5 6.5 0 00-4.6 11.1.75.75 0 11-1.06 1.05 8 8 0 1113.63-6.35 3 3 0 00-1.76-1.21A6.5 6.5 0 0010 4.5zm4.64 4.63a5 5 0 10-8.18 5.4.75.75 0 001.06-1.06 3.5 3.5 0 115.81-3.54 3 3 0 011.3-.8zM8 11a2 2 0 114 0 2 2 0 01-4 0zm9.5 1a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CommunicationPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommunicationPersonFilledIcon({}), 'CommunicationPersonFilled');

const CommunicationPersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 11a7 7 0 0113.79-1.7c.48.22.88.57 1.18 1a8 8 0 10-13.63 6.35.5.5 0 00.7-.7A6.98 6.98 0 013 11zm11.64-1.87a5 5 0 10-8.18 5.4.5.5 0 00.7-.7A3.99 3.99 0 0110 7a4 4 0 013.74 2.57c.27-.2.57-.35.9-.44zM8 11a2 2 0 114 0 2 2 0 01-4 0zm2-1a1 1 0 100 2 1 1 0 000-2zm7.5 2a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CommunicationPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommunicationPersonRegularIcon({}), 'CommunicationPersonRegular');

const CompassNorthwestFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.06 9A8 8 0 0110 2v1.5a.5.5 0 001 0V2.06A8 8 0 0117.94 9H16.5a.5.5 0 000 1H18a8 8 0 01-7 7.94V16.5a.5.5 0 00-1 0V18a8 8 0 01-8-8h1.5a.5.5 0 000-1H2.06zm10.1.48a3 3 0 00-1.65-1.6l-3.49-1.4a.42.42 0 00-.54.54l1.4 3.49a3 3 0 001.6 1.65l3.73 1.6c.34.14.7-.2.55-.55l-1.6-3.73z",
    fill: primaryFill
  }));
};

export const CompassNorthwestFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CompassNorthwestFilledIcon({}), 'CompassNorthwestFilled');

const CompassNorthwestRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.42 6.1A1 1 0 006.1 7.42l1.48 3.26a3.5 3.5 0 001.74 1.74l3.26 1.48a1 1 0 001.32-1.32l-1.48-3.26a3.5 3.5 0 00-1.74-1.74L7.42 6.1zm-.41.9l3.26 1.49c.55.25.99.7 1.24 1.24L12.99 13l-3.26-1.48c-.55-.25-.99-.7-1.24-1.24L7.01 7zM10 2a8 8 0 100 16 8 8 0 000-16zm0 1v1.5a.5.5 0 001 0V3.07A7 7 0 0116.93 9H15.5a.5.5 0 000 1H17a7 7 0 01-6 6.93V15.5a.5.5 0 00-1 0V17a7 7 0 01-7-7h1.5a.5.5 0 000-1H3.07A7 7 0 0110 3z",
    fill: primaryFill
  }));
};

export const CompassNorthwestRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CompassNorthwestRegularIcon({}), 'CompassNorthwestRegular');

const ComposeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.78 3.28a.75.75 0 10-1.06-1.06l-7.5 7.5L9 11l1.28-.22 7.5-7.5zM5.75 3A2.75 2.75 0 003 5.75v8.5A2.75 2.75 0 005.75 17h8.5A2.75 2.75 0 0017 14.25v-5.5a.75.75 0 00-1.5 0v5.5c0 .69-.56 1.25-1.25 1.25h-8.5c-.69 0-1.25-.56-1.25-1.25v-8.5c0-.69.56-1.25 1.25-1.25h5.5a.75.75 0 000-1.5h-5.5z",
    fill: primaryFill
  }));
};

export const ComposeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ComposeFilledIcon({}), 'ComposeFilled');

const ComposeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.85 2.85a.5.5 0 00-.7-.7l-8 8L9 11l.85-.15 8-8zM5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-6a.5.5 0 00-1 0v6c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 14.5v-9C4 4.67 4.67 4 5.5 4h6a.5.5 0 000-1h-6z",
    fill: primaryFill
  }));
};

export const ComposeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ComposeRegularIcon({}), 'ComposeRegular');

const ConferenceRoomFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.19 2.11a.5.5 0 01.41-.1l7 1.5c.23.05.4.25.4.5v12a.5.5 0 01-.4.48l-7 1.5a.5.5 0 01-.6-.49v-15c0-.15.07-.3.19-.39zm3.31 7.9a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM8 3H3.5a.5.5 0 00-.5.5V16.5c0 .27.22.5.5.5H8V3z",
    fill: primaryFill
  }));
};

export const ConferenceRoomFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConferenceRoomFilledIcon({}), 'ConferenceRoomFilled');

const ConferenceRoomRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.49 10a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.6 2.01a.5.5 0 00-.6.5V17.5a.5.5 0 00.6.5l7-1.51A.5.5 0 0017 16V4a.5.5 0 00-.4-.49l-7-1.5zm.4 14.87V3.12l6 1.29V15.6l-6 1.28zM8 17v-1H4V4h4V3H3.5a.5.5 0 00-.5.5v13c0 .27.22.5.5.5H8z",
    fill: primaryFill
  }));
};

export const ConferenceRoomRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConferenceRoomRegularIcon({}), 'ConferenceRoomRegular');

const ConnectorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3a.5.5 0 00-.5.5v2.8L2.15 8.14A.5.5 0 002 8.5v5c0 .28.22.5.5.5H4v2.5a.5.5 0 001 0V14h1v2.5a.5.5 0 001 0V14h1.5a.5.5 0 00.5-.5v-5a.5.5 0 00-.15-.35L7 6.29V3.5a.5.5 0 00-.5-.5h-2zm11 14a.5.5 0 00.5-.5v-2.8l1.85-1.85a.5.5 0 00.15-.35v-5a.5.5 0 00-.5-.5H17V3.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5V6h-.5a.5.5 0 00-.5.5v5c0 .13.05.26.15.35L13 13.71v2.79c0 .28.22.5.5.5h2zM13 6V4h3v2h-3z",
    fill: primaryFill
  }));
};

export const ConnectorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConnectorFilledIcon({}), 'ConnectorFilled');

const ConnectorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5a.5.5 0 00-1 0v2.8L2.15 8.14A.5.5 0 002 8.5v5c0 .28.22.5.5.5H4v2.5a.5.5 0 001 0V14h1v2.5a.5.5 0 001 0V14h1.5a.5.5 0 00.5-.5v-5a.5.5 0 00-.15-.35L7 6.29V3.5a.5.5 0 00-1 0v3c0 .13.05.26.15.35L8 8.71V13H3V8.7l1.85-1.85A.5.5 0 005 6.5v-3zm10 13v-3a.5.5 0 01.15-.35L17 11.29V7h-5v4.3l1.85 1.85c.1.09.15.22.15.35v3a.5.5 0 01-1 0v-2.8l-1.85-1.85a.5.5 0 01-.15-.35v-5c0-.28.22-.5.5-.5h.5V3.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5V6h.5c.28 0 .5.22.5.5v5a.5.5 0 01-.15.35L16 13.71v2.79a.5.5 0 01-1 0zM13 6h3V4h-3v2z",
    fill: primaryFill
  }));
};

export const ConnectorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConnectorRegularIcon({}), 'ConnectorRegular');

const ContactCardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v9c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-13zm3 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-1.55.75h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4.3 4.3 0 01-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8 0-.52.42-.94.95-.94zM11 8.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm.5 2.5h3a.5.5 0 010 1h-3a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const ContactCardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardFilledIcon({}), 'ContactCardFilled');

const ContactCardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 8.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-4 3.2c0-.53.42-.95.95-.95h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4.3 4.3 0 01-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8zM11.5 8a.5.5 0 000 1h3a.5.5 0 000-1h-3zm0 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM2 5.75C2 4.78 2.78 4 3.75 4h12.5c.97 0 1.75.78 1.75 1.75v8.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 16 2 15.22 2 14.25v-8.5zM3.75 5a.75.75 0 00-.75.75v8.5c0 .41.34.75.75.75h12.5c.41 0 .75-.34.75-.75v-8.5a.75.75 0 00-.75-.75H3.75z",
    fill: primaryFill
  }));
};

export const ContactCardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardRegularIcon({}), 'ContactCardRegular');

const ContactCardGroupFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 4A2.5 2.5 0 002 6.5v7A2.5 2.5 0 004.5 16h11a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015.5 4h-11zM12 8.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm.5 2.5h3a.5.5 0 010 1h-3a.5.5 0 010-1zM4 10.75c0-.41.34-.75.75-.75h3a.75.75 0 01.75.75v.81c-.02.16-.1.58-.5.92-.33.29-.86.52-1.75.52C4 13 4 11.5 4 11.5v-.75zM6.25 9a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm4.25-1a1 1 0 11-2 0 1 1 0 012 0zm-1.07 3.98a2.26 2.26 0 00.07-.41V10.75c0-.27-.06-.52-.17-.75H10a1 1 0 011 1c0 .83-.67 1.5-1.5 1.5h-.26c.1-.2.16-.37.2-.52z",
    fill: primaryFill
  }));
};

export const ContactCardGroupFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardGroupFilledIcon({}), 'ContactCardGroupFilled');

const ContactCardGroupRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 8.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm-8-.75c0-.41.34-.75.75-.75h3a.75.75 0 01.75.75v.81c-.02.16-.1.58-.5.92-.33.29-.86.52-1.75.52C4 13 4 11.5 4 11.5v-.75zM6.25 9a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm4.25-1a1 1 0 11-2 0 1 1 0 012 0zm-1.07 3.98c-.03.15-.1.33-.2.52h.27c.83 0 1.5-.67 1.5-1.5a1 1 0 00-1-1h-.67c.11.23.17.48.17.75V11.57a1.84 1.84 0 01-.07.4zM4.5 4A2.5 2.5 0 002 6.5v7A2.5 2.5 0 004.5 16h11a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015.5 4h-11zM3 6.5C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 13.5v-7z",
    fill: primaryFill
  }));
};

export const ContactCardGroupRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardGroupRegularIcon({}), 'ContactCardGroupRegular');

const ContactCardLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5C2 4.67 2.67 4 3.5 4h13c.83 0 1.5.67 1.5 1.5v5.84a3.49 3.49 0 00-1.5-.34h-4a3.5 3.5 0 00-3.16 5H3.5A1.5 1.5 0 012 14.5v-9zm3 3a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm4 3.2a.95.95 0 00-.95-.95h-3.1a.95.95 0 00-.95.95c0 .85.58 1.58 1.4 1.79l.06.01c.68.18 1.4.18 2.08 0l.06-.01c.82-.2 1.4-.94 1.4-1.8zM11.5 8a.5.5 0 000 1h3a.5.5 0 000-1h-3zm1 4a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-3.5 2a.5.5 0 000 1h4a.5.5 0 000-1h-4z",
    fill: primaryFill
  }));
};

export const ContactCardLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardLinkFilledIcon({}), 'ContactCardLinkFilled');

const ContactCardLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-1.55.75a.95.95 0 00-.95.95c0 .85.58 1.58 1.4 1.79l.06.01c.68.18 1.4.18 2.08 0l.06-.01c.82-.2 1.4-.94 1.4-1.8a.95.95 0 00-.95-.94h-3.1zM12 8.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM4.75 4C3.78 4 3 4.78 3 5.75v8.5c0 .97.78 1.75 1.75 1.75h5.59a3.47 3.47 0 01-.3-1H4.75a.75.75 0 01-.75-.75v-8.5c0-.41.34-.75.75-.75h12.5c.41 0 .75.34.75.75v5.29c.35.05.69.15 1 .3V5.75C19 4.78 18.22 4 17.25 4H4.75zm8.75 8a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H17a.5.5 0 000 1h.5a2.5 2.5 0 000-5H17zm-3.5 2a.5.5 0 000 1h4a.5.5 0 000-1h-4z",
    fill: primaryFill
  }));
};

export const ContactCardLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardLinkRegularIcon({}), 'ContactCardLinkRegular');

const ContactCardRibbonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v9c0 .83.67 1.5 1.5 1.5H13v-.35a3.98 3.98 0 01-.87-3.65h-.63a.5.5 0 010-1h1.04A4 4 0 0118 9.54V5.5c0-.83-.67-1.5-1.5-1.5h-13zm3 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm1.55.75c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4.3 4.3 0 01-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8 0-.52.42-.94.95-.94h3.1zM11 8.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm8 4.5a3 3 0 11-6 0 3 3 0 016 0zm-1 3.46a3.98 3.98 0 01-4 0v2.29c0 .2.21.31.38.22L16 18l1.62.97c.17.1.38-.03.38-.22v-2.29z",
    fill: primaryFill
  }));
};

export const ContactCardRibbonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardRibbonFilledIcon({}), 'ContactCardRibbonFilled');

const ContactCardRibbonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 8.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-4 3.2c0-.53.42-.95.95-.95h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4.3 4.3 0 01-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8zM11.5 8a.5.5 0 000 1h3a.5.5 0 000-1h-3zm0 3a.5.5 0 000 1h.63c.09-.35.23-.7.4-1H11.5zm-7.75 4h8.79c.13.23.28.45.46.65V16H3.75C2.78 16 2 15.22 2 14.25v-8.5C2 4.78 2.78 4 3.75 4h12.5c.97 0 1.75.78 1.75 1.75v3.79c-.3-.18-.65-.32-1-.41V5.75a.75.75 0 00-.75-.75H3.75a.75.75 0 00-.75.75v8.5c0 .41.34.75.75.75zM19 13a3 3 0 11-6 0 3 3 0 016 0zm-1 3.46a3.98 3.98 0 01-4 0v2.29c0 .2.21.31.38.22L16 18l1.62.97c.17.1.38-.03.38-.22v-2.29z",
    fill: primaryFill
  }));
};

export const ContactCardRibbonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardRibbonRegularIcon({}), 'ContactCardRibbonRegular');

const ContentSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 5.25A2.75 2.75 0 015.25 2.5h9.5a2.75 2.75 0 012.75 2.75v4.64c-.46-.3-.96-.53-1.5-.68V7H4v7.75c0 .69.56 1.25 1.25 1.25h3.96c.15.54.38 1.04.68 1.5H5.25a2.75 2.75 0 01-2.75-2.75v-9.5zM9 14.5v-6a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v6c0 .28.22.5.5.5h3a.5.5 0 00.5-.5zM6 14V9h2v5H6zm4-5.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5zm2.07 2.94a2 2 0 01-1.43 2.48l-.47.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const ContentSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContentSettingsFilledIcon({}), 'ContentSettingsFilled');

const ContentSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5A2.5 2.5 0 0014.5 3h-9zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5zm5 3v6a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-6c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5zM6 9v5h2V9H6zm4-.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5zm2.07 2.94a2 2 0 01-1.43 2.48l-.47.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const ContentSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContentSettingsRegularIcon({}), 'ContentSettingsRegular');

const ContentViewFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 7H6v2h8V7zm-2 5h2v1h-2v-1zM6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zM5 7a1 1 0 011-1h8a1 1 0 011 1v2a1 1 0 01-1 1H6a1 1 0 01-1-1V7zm7 4h2a1 1 0 011 1v1a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1a1 1 0 011-1zm-7 .5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm.5 1.5h4a.5.5 0 010 1h-4a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const ContentViewFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContentViewFilledIcon({}), 'ContentViewFilled');

const ContentViewRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 7a1 1 0 011-1h8a1 1 0 011 1v2a1 1 0 01-1 1H6a1 1 0 01-1-1V7zm9 0H6v2h8V7zm-2 4a1 1 0 00-1 1v1a1 1 0 001 1h2a1 1 0 001-1v-1a1 1 0 00-1-1h-2zm0 1h2v1h-2v-1zm-7-.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm.5 1.5a.5.5 0 000 1h4a.5.5 0 000-1h-4zM3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm3-2a2 2 0 00-2 2v8c0 1.1.9 2 2 2h8a2 2 0 002-2V6a2 2 0 00-2-2H6z",
    fill: primaryFill
  }));
};

export const ContentViewRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContentViewRegularIcon({}), 'ContentViewRegular');

const ContentViewGalleryFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 7H6v2h3V7zM3 6a3 3 0 013-3h6v14H6a3 3 0 01-3-3V6zm2 1v2a1 1 0 001 1h3a1 1 0 001-1V7a1 1 0 00-1-1H6a1 1 0 00-1 1zm.5 4a.5.5 0 000 1h4a.5.5 0 000-1h-4zM5 13.5c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5zm8 3.5h1a3 3 0 003-3v-1h-4v4zm4-5V8h-4v4h4zm0-5V6a3 3 0 00-3-3h-1v4h4z",
    fill: primaryFill
  }));
};

export const ContentViewGalleryFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContentViewGalleryFilledIcon({}), 'ContentViewGalleryFilled');

const ContentViewGalleryRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6a1 1 0 00-1 1v2a1 1 0 001 1h3a1 1 0 001-1V7a1 1 0 00-1-1H6zm0 1h3v2H6V7zm-1 4.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm.5 1.5a.5.5 0 000 1h4a.5.5 0 000-1h-4zM3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm8 10V4H6a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5zm3 0a2 2 0 002-2v-1h-4v3h2zm2-9V6a2 2 0 00-2-2h-2v3h4zm0 5V8h-4v4h4z",
    fill: primaryFill
  }));
};

export const ContentViewGalleryRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContentViewGalleryRegularIcon({}), 'ContentViewGalleryRegular');

const ContractDownLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.7 8l4.15-4.15a.5.5 0 00-.7-.7L12 7.29V3.5a.5.5 0 00-1 0v5c0 .28.22.5.5.5h5a.5.5 0 000-1h-3.8zM6 4a2 2 0 00-2 2v4h4a2 2 0 012 2v4h4a2 2 0 002-2v-2.5a.5.5 0 011 0V14a3 3 0 01-3 3H6a3 3 0 01-3-3V6a3 3 0 013-3h2.5a.5.5 0 010 1H6z",
    fill: primaryFill
  }));
};

export const ContractDownLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContractDownLeftFilledIcon({}), 'ContractDownLeftFilled');

const ContractDownLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.7 8l4.15-4.15a.5.5 0 00-.7-.7L12 7.29V3.5a.5.5 0 00-1 0v5c0 .28.22.5.5.5h5a.5.5 0 000-1h-3.8zM4 6c0-1.1.9-2 2-2h2.5a.5.5 0 000-1H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-2.5a.5.5 0 00-1 0V14a2 2 0 01-2 2h-4v-4a2 2 0 00-2-2H4V6zm0 5h4a1 1 0 011 1v4H6a2 2 0 01-2-2v-3z",
    fill: primaryFill
  }));
};

export const ContractDownLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContractDownLeftRegularIcon({}), 'ContractDownLeftRegular');

const ControlButtonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v6.5A2.75 2.75 0 0115.25 16H4.75A2.75 2.75 0 012 13.25v-6.5zM6 7a2 2 0 00-2 2v2c0 1.1.9 2 2 2h.5a.5.5 0 000-1H6a1 1 0 01-1-1V9a1 1 0 011-1h.5a.5.5 0 000-1H6zm3 .5a.5.5 0 00-1 0V9h-.5a.5.5 0 000 1H8v1.75c0 .69.56 1.25 1.25 1.25h.25a.5.5 0 000-1h-.25a.25.25 0 01-.25-.25V10h.5a.5.5 0 000-1H9V7.5zm7 0a.5.5 0 00-1 0v5a.5.5 0 001 0v-5zm-4 3c0-.28.22-.5.5-.5h1a.5.5 0 000-1h-1c-.83 0-1.5.67-1.5 1.5v2a.5.5 0 001 0v-2z",
    fill: primaryFill
  }));
};

export const ControlButtonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ControlButtonFilledIcon({}), 'ControlButtonFilled');

const ControlButtonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 7a2 2 0 00-2 2v2c0 1.1.9 2 2 2h.5a.5.5 0 000-1H6a1 1 0 01-1-1V9a1 1 0 011-1h.5a.5.5 0 000-1H6zm3 .5a.5.5 0 00-1 0V9h-.5a.5.5 0 000 1H8v1.75c0 .69.56 1.25 1.25 1.25h.25a.5.5 0 000-1h-.25a.25.25 0 01-.25-.25V10h.5a.5.5 0 000-1H9V7.5zm7 0a.5.5 0 00-1 0v5a.5.5 0 001 0v-5zm-4 3c0-.28.22-.5.5-.5h1a.5.5 0 000-1h-1c-.83 0-1.5.67-1.5 1.5v2a.5.5 0 001 0v-2zM4.75 4A2.75 2.75 0 002 6.75v6.5A2.75 2.75 0 004.75 16h10.5A2.75 2.75 0 0018 13.25v-6.5A2.75 2.75 0 0015.25 4H4.75zM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H4.75C3.78 15 3 14.22 3 13.25v-6.5z",
    fill: primaryFill
  }));
};

export const ControlButtonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ControlButtonRegularIcon({}), 'ControlButtonRegular');

const ConvertRangeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v2c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H5zm12.5 5c.28 0 .5.22.5.5v2a2.5 2.5 0 01-2.5 2.5h-1.8l1.15 1.15a.5.5 0 01-.7.7l-2-2a.5.5 0 010-.7l2-2a.5.5 0 01.7.7L13.71 11h1.79c.83 0 1.5-.67 1.5-1.5v-2c0-.28.22-.5.5-.5zm-5.62 3H5a2 2 0 00-2 2v4c0 1.1.9 2 2 2h8a2 2 0 002-2v-1.09a1.5 1.5 0 01-1.56-.35l-2-2a1.5 1.5 0 010-2.12l.44-.44zM6.5 14c0-.28.22-.5.5-.5h4a.5.5 0 010 1H7a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const ConvertRangeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConvertRangeFilledIcon({}), 'ConvertRangeFilled');

const ConvertRangeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v2c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H5zM4 4a1 1 0 011-1h8a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V4zm3 9.5a.5.5 0 000 1h4a.5.5 0 000-1H7zm4.88-3.5H5a2 2 0 00-2 2v4c0 1.1.9 2 2 2h8a2 2 0 002-2v-1.09a1.5 1.5 0 01-1 0V16a1 1 0 01-1 1H5a1 1 0 01-1-1v-4a1 1 0 011-1h6.09c.07-.2.19-.4.35-.56l.44-.44zM18 7.5a.5.5 0 00-1 0v2c0 .83-.67 1.5-1.5 1.5h-1.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L13.71 12h1.79A2.5 2.5 0 0018 9.5v-2z",
    fill: primaryFill
  }));
};

export const ConvertRangeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConvertRangeRegularIcon({}), 'ConvertRangeRegular');

const CookiesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 019.87-7.78.5.5 0 01.24.85 2 2 0 00.95 3.38c.26.06.44.29.44.55A2 2 0 0017 8.32a.5.5 0 01.87.24A8 8 0 112 10zm5-2a1 1 0 10-2 0 1 1 0 002 0zm3 3a1 1 0 100-2 1 1 0 000 2zm3 3a1 1 0 10-2 0 1 1 0 002 0zm-6 0a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const CookiesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CookiesFilledIcon({}), 'CookiesFilled');

const CookiesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 9a1 1 0 100-2 1 1 0 000 2zm4 2a1 1 0 100-2 1 1 0 000 2zm3 3a1 1 0 11-2 0 1 1 0 012 0zm-6 0a1 1 0 100-2 1 1 0 000 2zm3-12a8 8 0 107.87 6.56.5.5 0 00-.87-.24A2 2 0 0113.5 7c0-.26-.18-.5-.44-.55a2 2 0 01-.95-3.38.5.5 0 00-.24-.85A8.02 8.02 0 0010 2zm-7 8a7 7 0 017.87-6.95 2.99 2.99 0 001.65 4.29 3 3 0 004.47 2.26l.01.4a7 7 0 11-14 0z",
    fill: primaryFill
  }));
};

export const CookiesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CookiesRegularIcon({}), 'CookiesRegular');

const CopyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4c0-1.1.9-2 2-2h6a2 2 0 012 2v10a2 2 0 01-2 2H8a2 2 0 01-2-2V4zM4 6a2 2 0 011-1.73V14.5A2.5 2.5 0 007.5 17h6.23A2 2 0 0112 18H7.5A3.5 3.5 0 014 14.5V6z",
    fill: primaryFill
  }));
};

export const CopyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopyFilledIcon({}), 'CopyFilled');

const CopyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 2a2 2 0 00-2 2v10c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H8zM7 4a1 1 0 011-1h6a1 1 0 011 1v10a1 1 0 01-1 1H8a1 1 0 01-1-1V4zM4 6a2 2 0 011-1.73V14.5A2.5 2.5 0 007.5 17h6.23A2 2 0 0112 18H7.5A3.5 3.5 0 014 14.5V6z",
    fill: primaryFill
  }));
};

export const CopyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopyRegularIcon({}), 'CopyRegular');

const CopyAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4c0-1.1.9-2 2-2h6a2 2 0 012 2v5.2A5.5 5.5 0 009.2 16H8a2 2 0 01-2-2V4zm4.26 14a5.5 5.5 0 01-.66-1H7.5A2.5 2.5 0 015 14.5V4.27A2 2 0 004 6v8.5A3.5 3.5 0 007.5 18h2.76zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const CopyAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopyAddFilledIcon({}), 'CopyAddFilled');

const CopyAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 2a2 2 0 00-2 2v10c0 1.1.9 2 2 2h1.2c-.08-.32-.15-.66-.18-1H8a1 1 0 01-1-1V4a1 1 0 011-1h6a1 1 0 011 1v5.02c.34.03.68.1 1 .19V4a2 2 0 00-2-2H8zm-.5 15h2.1c.18.36.4.7.66 1H7.5A3.5 3.5 0 014 14.5V6a2 2 0 011-1.73V14.5A2.5 2.5 0 007.5 17zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const CopyAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopyAddRegularIcon({}), 'CopyAddRegular');

const CopyArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4c0-1.1.9-2 2-2h6a2 2 0 012 2v5.2A5.5 5.5 0 009.2 16H8a2 2 0 01-2-2V4zm4.26 14a5.5 5.5 0 01-.66-1H7.5A2.5 2.5 0 015 14.5V4.27A2 2 0 004 6v8.5A3.5 3.5 0 007.5 18h2.76zm4.24-8a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const CopyArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopyArrowRightFilledIcon({}), 'CopyArrowRightFilled');

const CopyArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 2a2 2 0 00-2 2v10c0 1.1.9 2 2 2h1.2c-.08-.32-.15-.66-.18-1H8a1 1 0 01-1-1V4a1 1 0 011-1h6a1 1 0 011 1v5.02c.34.03.68.1 1 .19V4a2 2 0 00-2-2H8zm-.5 15h2.1c.18.36.4.7.66 1H7.5A3.5 3.5 0 014 14.5V6a2 2 0 011-1.73V14.5A2.5 2.5 0 007.5 17zm7-7a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const CopyArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopyArrowRightRegularIcon({}), 'CopyArrowRightRegular');

const CopySelectFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 3a1 1 0 00-1 1v.5a.5.5 0 01-1 0V4c0-1.1.9-2 2-2h.5a.5.5 0 010 1H8zm-1 9a1 1 0 001 1h.5a.5.5 0 010 1H8a2 2 0 01-2-2v-.5a.5.5 0 011 0v.5zm0-5.5a.5.5 0 00-1 0v3a.5.5 0 001 0v-3zM16 3a1 1 0 011 1v.5a.5.5 0 001 0V4a2 2 0 00-2-2h-.5a.5.5 0 000 1h.5zm0 10a1 1 0 001-1v-.5a.5.5 0 011 0v.5a2 2 0 01-2 2h-.5a.5.5 0 010-1h.5zm1.5-7a.5.5 0 00-.5.5v3a.5.5 0 001 0v-3a.5.5 0 00-.5-.5zm-7-4a.5.5 0 000 1h3a.5.5 0 000-1h-3zM10 13.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM4 6h1v6.5A2.5 2.5 0 007.5 15H14v1a2 2 0 01-2 2H5.5A3.5 3.5 0 012 14.5V8c0-1.1.9-2 2-2z",
    fill: primaryFill
  }));
};

export const CopySelectFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopySelectFilledIcon({}), 'CopySelectFilled');

const CopySelectRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 3a1 1 0 00-1 1v.5a.5.5 0 01-1 0V4c0-1.1.9-2 2-2h.5a.5.5 0 010 1H8zm-1 9a1 1 0 001 1h.5a.5.5 0 010 1H8a2 2 0 01-2-2v-.5a.5.5 0 011 0v.5zm0-5.5a.5.5 0 00-1 0v3a.5.5 0 001 0v-3zM16 3a1 1 0 011 1v.5a.5.5 0 001 0V4a2 2 0 00-2-2h-.5a.5.5 0 000 1h.5zm0 10a1 1 0 001-1v-.5a.5.5 0 011 0v.5a2 2 0 01-2 2h-.5a.5.5 0 010-1h.5zm1.5-7a.5.5 0 00-.5.5v3a.5.5 0 001 0v-3a.5.5 0 00-.5-.5zm-7-4a.5.5 0 000 1h3a.5.5 0 000-1h-3zM10 13.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM4 6h1v1H4a1 1 0 00-1 1v6.5A2.5 2.5 0 005.5 17H12a1 1 0 001-1v-1h1v1a2 2 0 01-2 2H5.5A3.5 3.5 0 012 14.5V8c0-1.1.9-2 2-2z",
    fill: primaryFill
  }));
};

export const CopySelectRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopySelectRegularIcon({}), 'CopySelectRegular');

const CouchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 6.5V8h.29c1.25 0 2.3.85 2.62 2h6.19c.3-1.15 1.36-2 2.61-2H16V6.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 5 4 5.67 4 6.5zM3.5 15h13c.83 0 1.5-.67 1.5-1.5v-2.68c0-1-.81-1.82-1.82-1.82h-.47c-.94 0-1.71.77-1.71 1.71 0 .16-.13.29-.29.29H6.3a.29.29 0 01-.29-.29C6 9.77 5.23 9 4.29 9h-.47C2.82 9 2 9.81 2 10.82v2.68c0 .83.67 1.5 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CouchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CouchFilledIcon({}), 'CouchFilled');

const CouchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6.5v1.52c1.03.14 1.84.95 1.98 1.98h6.04A2.32 2.32 0 0115 8.02V6.5a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5zM4 8.02V6.5C4 5.67 4.67 5 5.5 5h9c.83 0 1.5.67 1.5 1.5v1.52c1.13.13 2 1.1 2 2.26v3.22c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 13.5v-3.22c0-1.17.87-2.13 2-2.26zM15.32 9c-.73 0-1.32.59-1.32 1.32 0 .37-.3.68-.68.68H6.68a.68.68 0 01-.68-.68C6 9.59 5.41 9 4.68 9h-.4C3.58 9 3 9.57 3 10.28v3.22c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-3.22c0-.7-.57-1.28-1.28-1.28h-.4z",
    fill: primaryFill
  }));
};

export const CouchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CouchRegularIcon({}), 'CouchRegular');

const CreditCardPersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75V7H2v-.25zM2 8h13.5a3 3 0 00-2.23 5.01c-1.1.1-2 .92-2.22 1.99h-6.3A2.75 2.75 0 012 12.25V8zm15.5 3a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 16.75 12 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CreditCardPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CreditCardPersonFilledIcon({}), 'CreditCardPersonFilled');

const CreditCardPersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75V8H3v4.25c0 .97.78 1.75 1.75 1.75h6.75c-.22.3-.38.63-.45 1h-6.3A2.75 2.75 0 012 12.25v-5.5zM4.75 5C3.78 5 3 5.78 3 6.75V7h14v-.25C17 5.78 16.22 5 15.25 5H4.75zm12.75 6a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 16.75 12 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CreditCardPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CreditCardPersonRegularIcon({}), 'CreditCardPersonRegular');

const CreditCardToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75V7H2v-.25zM2 8v4.25A2.75 2.75 0 004.75 15H9v-1.5a2.5 2.5 0 012.04-2.46A2.5 2.5 0 0113.5 9h2a2.5 2.5 0 012.46 2.04l.04.01V8H2zm10 4v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm3.5-1h-2a.5.5 0 00-.5.5v.5h3v-.5a.5.5 0 00-.5-.5zm1.5 5.5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const CreditCardToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CreditCardToolboxFilledIcon({}), 'CreditCardToolboxFilled');

const CreditCardToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 002 6.75v5.5A2.75 2.75 0 004.75 15H9v-1H4.75C3.78 14 3 13.22 3 12.25V8h14v1.5c.5.37.84.91.96 1.54l.04.01v-4.3A2.75 2.75 0 0015.25 4H4.75zM17 7H3v-.25C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75V7zm-5 5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm3.5-1h-2a.5.5 0 00-.5.5v.5h3v-.5a.5.5 0 00-.5-.5zm1.5 5.5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const CreditCardToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CreditCardToolboxRegularIcon({}), 'CreditCardToolboxRegular');

const CropFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2.75a.75.75 0 00-1.5 0V4.5H2.75a.75.75 0 000 1.5H4.5v6.75a2.75 2.75 0 002.75 2.75H14v1.75a.75.75 0 001.5 0V15.5h1.75a.75.75 0 000-1.5h-10C6.56 14 6 13.44 6 12.75v-10zm8 4.5V13h1.5V7.25a2.75 2.75 0 00-2.75-2.75H7V6h5.75c.69 0 1.25.56 1.25 1.25z",
    fill: primaryFill
  }));
};

export const CropFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CropFilledIcon({}), 'CropFilled');

const CropRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2.5a.5.5 0 00-1 0V5H2.5a.5.5 0 000 1H5v6.5A2.5 2.5 0 007.5 15H14v2.5a.5.5 0 001 0V15h2.5a.5.5 0 000-1h-10A1.5 1.5 0 016 12.5v-10zm8 5V13h1V7.5A2.5 2.5 0 0012.5 5H7v1h5.5c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CropRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CropRegularIcon({}), 'CropRegular');

const CropInterimFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 4h3a2 2 0 001.77 1.99l.47 4.16A2 2 0 0011 12H6a2 2 0 00-1.24-1.85L5.23 6A2 2 0 007 4zm6.23 6.01l-.47-4.16A2 2 0 1010.26 3H6.74a2 2 0 10-2.5 2.85L3.78 10A2 2 0 105.73 13h5.54a2 2 0 101.96-2.99zm.74-2.4A4.5 4.5 0 119.65 15h.85a.5.5 0 000-1h-2a.5.5 0 00-.5.5v2a.5.5 0 001 0v-.72A5.48 5.48 0 0018.5 12a5.5 5.5 0 00-4.65-5.43l.12 1.03z",
    fill: primaryFill
  }));
};

export const CropInterimFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CropInterimFilledIcon({}), 'CropInterimFilled');

const CropInterimRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 5a1 1 0 100-2 1 1 0 000 2zm-2-1H7a2 2 0 01-1.77 1.99l-.47 4.16A2 2 0 016 12h5a2 2 0 011.24-1.85L11.77 6A2 2 0 0110 4zm1.27 9H5.73a2 2 0 11-1.96-2.99l.47-4.16A2 2 0 116.74 3h3.53a2 2 0 112.5 2.85l.46 4.16A2 2 0 1111.27 13zM3 12a1 1 0 102 0 1 1 0 00-2 0zm2-9a1 1 0 100 2 1 1 0 000-2zm7 9a1 1 0 102 0 1 1 0 00-2 0zm1.97-4.4A4.5 4.5 0 119.65 15h.85a.5.5 0 000-1h-2a.5.5 0 00-.5.5v2a.5.5 0 001 0v-.72A5.48 5.48 0 0018.5 12a5.5 5.5 0 00-4.65-5.43l.12 1.03z",
    fill: primaryFill
  }));
};

export const CropInterimRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CropInterimRegularIcon({}), 'CropInterimRegular');

const CropInterimOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.02 3.73l-.87-.88a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-1.2-1.2A5.47 5.47 0 019 15.78v.72a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-.85a4.49 4.49 0 005.56.92l-1.94-1.94L13 14a2 2 0 01-1.73-1H5.73a2 2 0 11-1.96-2.99l.47-4.16a2 2 0 01-1.22-2.12zm8 8L5.27 5.98h-.04l-.47 4.17A2 2 0 016 12h5c0-.1 0-.18.02-.27zm.75-5.74l.46 4.12 2.63 2.63A2 2 0 0013.23 10l-.47-4.16A2 2 0 1010.26 3H6.74a2 2 0 00-2.47-.86l2.6 2.6A2 2 0 007 4h3a2 2 0 001.77 1.99zm4.92 8.58l.72.72a5.5 5.5 0 00-3.56-8.72l.12 1.03a4.5 4.5 0 012.72 6.97z",
    fill: primaryFill
  }));
};

export const CropInterimOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CropInterimOffFilledIcon({}), 'CropInterimOffFilled');

const CropInterimOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.02 3.73l-.87-.88a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-1.2-1.2A5.47 5.47 0 019 15.78v.72a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-.85a4.49 4.49 0 005.56.92l-1.94-1.94L13 14a2 2 0 01-1.73-1H5.73a2 2 0 11-1.96-2.99l.47-4.16a2 2 0 01-1.22-2.12zm8 8L5.27 5.98a2 2 0 01-.04 0l-.47 4.17A2 2 0 016 12h5c0-.1 0-.18.02-.27zm.75-5.74l.46 4.12 2.63 2.63A2 2 0 0013.23 10l-.47-4.16A2 2 0 1010.26 3H6.74a2 2 0 00-2.47-.86l.87.87a1 1 0 01.86.86l.87.87A2 2 0 007 4h3a2 2 0 001.77 1.99zm4.92 8.58l.72.72a5.5 5.5 0 00-3.56-8.72l.12 1.03a4.5 4.5 0 012.72 6.97zM12 5a1 1 0 110-2 1 1 0 010 2zm-9 7a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const CropInterimOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CropInterimOffRegularIcon({}), 'CropInterimOffRegular');

const CubeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.7 2.48a3.5 3.5 0 012.6 0l5.76 2.3c.57.23.94.78.94 1.4v7.64a1.5 1.5 0 01-.94 1.4l-5.76 2.3a3.5 3.5 0 01-2.6 0l-5.76-2.3a1.5 1.5 0 01-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3zm-3 3.56a.5.5 0 10-.4.92l4.2 1.86v4.68a.5.5 0 001 0V8.82l4.2-1.86a.5.5 0 10-.4-.92L10 7.95l-4.3-1.9z",
    fill: primaryFill
  }));
};

export const CubeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeFilledIcon({}), 'CubeFilled');

const CubeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.7 6.04a.5.5 0 10-.4.92l4.2 1.86v4.68a.5.5 0 001 0V8.82l4.2-1.86a.5.5 0 10-.4-.92L10 7.95l-4.3-1.9zm5.6-3.56a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3a3.5 3.5 0 002.6 0l5.76-2.3c.57-.23.94-.78.94-1.4V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.76 2.3a.5.5 0 01.31.47v7.64a.5.5 0 01-.31.47l-5.76 2.3a2.5 2.5 0 01-1.86 0l-5.76-2.3a.5.5 0 01-.31-.47V6.18c0-.2.12-.4.31-.47l5.76-2.3z",
    fill: primaryFill
  }));
};

export const CubeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeRegularIcon({}), 'CubeRegular');

const CubeAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.7 2.48a3.5 3.5 0 012.6 0l5.76 2.3c.57.23.94.78.94 1.4v4.08a5.48 5.48 0 00-7.5.47v-1.9l4.2-1.87a.5.5 0 10-.4-.92L10 7.95l-4.3-1.9a.5.5 0 10-.4.9l4.2 1.88v3.38a5.48 5.48 0 00.58 5.56 3.5 3.5 0 01-1.38-.25l-5.76-2.3a1.5 1.5 0 01-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3zM17 18.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5a.5.5 0 00-.15-.35z",
    fill: primaryFill
  }));
};

export const CubeAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeAddFilledIcon({}), 'CubeAddFilled');

const CubeAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.07 16.59c.13.05.26.1.4.12.16.38.36.73.6 1.06a3.5 3.5 0 01-1.37-.25l-5.76-2.3a1.5 1.5 0 01-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3a3.5 3.5 0 012.6 0l5.76 2.3c.57.23.94.78.94 1.4v4.08a5.5 5.5 0 00-1-.66V6.18a.5.5 0 00-.31-.47l-5.76-2.3a2.5 2.5 0 00-1.86 0l-5.76 2.3a.5.5 0 00-.31.47v7.64c0 .2.12.4.31.47l5.76 2.3zM5.7 6.04a.5.5 0 10-.4.92l4.2 1.87v3.38a5.5 5.5 0 011-1.48v-1.9l4.2-1.87a.5.5 0 10-.4-.92L10 7.95l-4.3-1.9zM17 18.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5a.5.5 0 00-.15-.35z",
    fill: primaryFill
  }));
};

export const CubeAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeAddRegularIcon({}), 'CubeAddRegular');

const CubeLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.7 2.48a3.5 3.5 0 012.6 0l5.76 2.3c.57.23.94.78.94 1.4v5.85a3.54 3.54 0 00-.5-.03h-4a3.5 3.5 0 00-2.73 5.68c-.69.16-1.41.1-2.07-.16l-5.76-2.3a1.5 1.5 0 01-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3zm-3 3.56a.5.5 0 10-.4.92l4.2 1.86v4.68a.5.5 0 001 0V8.82l4.2-1.86a.5.5 0 10-.4-.92L10 7.95l-4.3-1.9zM13.5 13a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 100 1h.5a1.5 1.5 0 010 3H17a.5.5 0 100 1h.5a2.5 2.5 0 000-5H17zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const CubeLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeLinkFilledIcon({}), 'CubeLinkFilled');

const CubeLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.04 6.3a.5.5 0 01.66-.26L10 7.95l4.3-1.9a.5.5 0 11.4.9l-4.2 1.87v4.68a.5.5 0 01-1 0V8.82L5.3 6.96a.5.5 0 01-.26-.66zM8.7 2.48a3.5 3.5 0 012.6 0l5.76 2.3c.57.23.94.78.94 1.4v5.85a3.54 3.54 0 00-.5-.03H17V6.18a.5.5 0 00-.31-.47l-5.76-2.3a2.5 2.5 0 00-1.86 0L3.31 5.7a.5.5 0 00-.31.47v7.64c0 .2.12.4.31.47l5.76 2.3c.37.15.77.2 1.16.17.13.33.31.65.54.92-.69.16-1.41.1-2.07-.16l-5.76-2.3a1.5 1.5 0 01-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3zM13.5 13a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 100 1h.5a1.5 1.5 0 010 3H17a.5.5 0 100 1h.5a2.5 2.5 0 000-5H17zm-3.5 2a.5.5 0 100 1h4a.5.5 0 000-1h-4z",
    fill: primaryFill
  }));
};

export const CubeLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeLinkRegularIcon({}), 'CubeLinkRegular');

const CubeMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.2 2.51a5 5 0 013.6 0l4.24 1.64c.58.22.96.77.96 1.4v.14a2.5 2.5 0 00-.6-.34l-4.96-1.9a4 4 0 00-2.88 0L3.6 5.35c-.22.09-.42.2-.6.34v-.14c0-.63.38-1.18.96-1.4L8.21 2.5zm2.88 1.87a3 3 0 00-2.16 0l-4.96 1.9A1.5 1.5 0 003 7.69v6.63c0 .62.38 1.18.96 1.4l4.96 1.91a3 3 0 002.16 0l4.96-1.9c.58-.23.96-.79.96-1.4V7.68a1.5 1.5 0 00-.96-1.4l-4.96-1.91zM6.04 8.3a.5.5 0 01.66-.26L10 9.46l3.3-1.42a.5.5 0 01.4.92l-3.2 1.37v3.17a.5.5 0 11-1 0v-3.17L6.3 8.96a.5.5 0 01-.26-.66z",
    fill: primaryFill
  }));
};

export const CubeMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeMultipleFilledIcon({}), 'CubeMultipleFilled');

const CubeMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.2 2.51a5 5 0 013.6 0l4.24 1.64c.58.22.96.77.96 1.4v.14a2.5 2.5 0 00-.6-.34l-4.96-1.9a4 4 0 00-2.88 0L3.6 5.34c-.22.09-.42.2-.6.34v-.14c0-.63.38-1.18.96-1.4L8.21 2.5zm-2.16 5.8a.5.5 0 01.66-.27L10 9.46l3.3-1.42a.5.5 0 01.4.92l-3.2 1.37v3.17a.5.5 0 01-1 0v-3.17L6.3 8.96a.5.5 0 01-.26-.66zm2.88-3.93a3 3 0 012.16 0l4.96 1.9c.58.23.96.79.96 1.4v6.63a1.5 1.5 0 01-.96 1.4l-4.96 1.91a3 3 0 01-2.16 0l-4.96-1.9a1.5 1.5 0 01-.96-1.4V7.68c0-.62.38-1.18.96-1.4l4.96-1.91zm1.8.93a2 2 0 00-1.44 0L4.32 7.22a.5.5 0 00-.32.47v6.62c0 .21.13.4.32.47l4.96 1.9a2 2 0 001.44 0l4.96-1.9a.5.5 0 00.32-.47V7.7a.5.5 0 00-.32-.47l-4.96-1.9z",
    fill: primaryFill
  }));
};

export const CubeMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeMultipleRegularIcon({}), 'CubeMultipleRegular');

const CubeQuickFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.81 4.67a1.5 1.5 0 011.38 0l3 1.54c.5.25.81.77.81 1.33v3.92a1.5 1.5 0 01-.81 1.33l-3 1.54a1.5 1.5 0 01-1.38 0l-3-1.54A1.5 1.5 0 019 11.46V7.54c0-.56.31-1.08.81-1.33l3-1.54zm-1.76 3.1a.5.5 0 00.23.68L13 9.3v2.19a.5.5 0 101 0V9.3l1.72-.85a.5.5 0 10-.44-.9l-1.78.9-1.78-.9a.5.5 0 00-.67.23zM3.5 6a.5.5 0 000 1h4a.5.5 0 000-1h-4zm-1 3a.5.5 0 000 1h4a.5.5 0 000-1h-4zm1 3a.5.5 0 000 1h4a.5.5 0 000-1h-4z",
    fill: primaryFill
  }));
};

export const CubeQuickFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeQuickFilledIcon({}), 'CubeQuickFilled');

const CubeQuickRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.27 5.56a.5.5 0 01.46 0l3 1.54a.5.5 0 01.27.44v3.92a.5.5 0 01-.27.44l-3 1.54a.5.5 0 01-.46 0l-3-1.54a.5.5 0 01-.27-.44V7.54c0-.18.1-.36.27-.44l3-1.54zm.92-.9a1.5 1.5 0 00-1.38 0l-3 1.55c-.5.26-.81.77-.81 1.33v3.92c0 .56.31 1.07.81 1.33l3 1.54c.43.22.95.22 1.38 0l3-1.54c.5-.26.81-.77.81-1.33V7.54a1.5 1.5 0 00-.81-1.33l-3-1.54zM3 6.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5zm-1 3c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5zm1 3c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm8.05-4.72a.5.5 0 01.67-.23l1.78.9 1.78-.9a.5.5 0 11.44.9L14 9.3v2.19a.5.5 0 11-1 0V9.3l-1.72-.85a.5.5 0 01-.23-.67z",
    fill: primaryFill
  }));
};

export const CubeQuickRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeQuickRegularIcon({}), 'CubeQuickRegular');

const CubeRotateFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.53 2.63c.93-.43 2-.43 2.94 0l4.66 2.15c.53.24.87.78.87 1.36V8h-1a1.5 1.5 0 00-.81 2.76A10.54 10.54 0 019.99 12c-2.1 0-3.92-.5-5.18-1.24A1.5 1.5 0 004 8H3V6.14c0-.58.34-1.12.87-1.36l4.66-2.15zM6.7 6.54a.5.5 0 00-.4.92l3.2 1.37v1.67a.5.5 0 101 0V8.83l3.2-1.37a.5.5 0 10-.4-.92L10 7.96 6.7 6.54zm8.8 2.96c0-.28.22-.5.5-.5h2.5a.5.5 0 01.5.5V12a.5.5 0 01-1 0v-.98a6.2 6.2 0 01-1.64 1.37A12.4 12.4 0 0110 14a12.4 12.4 0 01-6.36-1.61A6.2 6.2 0 012 11.02V12a.5.5 0 01-1 0V9.5a.5.5 0 01.5-.5H4a.5.5 0 010 1H2.48a4.12 4.12 0 00.92 1 6.57 6.57 0 00.76.54c.4.25.87.47 1.37.67 1.27.5 2.8.8 4.47.8s3.2-.3 4.47-.8a8.67 8.67 0 002.13-1.2 5.24 5.24 0 00.92-1H16a.5.5 0 01-.5-.5zM10 15c-2.66 0-5.16-.67-7-1.83v.7c0 .58.34 1.1.87 1.35l4.66 2.15c.93.43 2 .43 2.94 0l4.66-2.15c.53-.24.87-.77.87-1.36v-.69A13.32 13.32 0 0110 15z",
    fill: primaryFill
  }));
};

export const CubeRotateFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeRotateFilledIcon({}), 'CubeRotateFilled');

const CubeRotateRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.95 3.53a2.5 2.5 0 012.1 0L15.7 5.7a.5.5 0 01.29.45V8h1V6.14a1.5 1.5 0 00-.87-1.36l-4.66-2.15a3.5 3.5 0 00-2.94 0L3.87 4.78A1.5 1.5 0 003 6.14V8h1V6.14c0-.2.11-.37.29-.45l4.66-2.16zM3.4 11a6.46 6.46 0 00.76.54A11.4 11.4 0 0010 13a11.4 11.4 0 006-1.56 6.46 6.46 0 001-.8c.2-.21.38-.42.52-.64H16a.5.5 0 010-1h2.5a.5.5 0 01.5.5V12a.5.5 0 01-1 0v-.98a6.2 6.2 0 01-1.64 1.37l-.36.21c-1.6.87-3.7 1.4-6 1.4a12.67 12.67 0 01-6.36-1.61A6.2 6.2 0 012 11.02V12a.5.5 0 01-1 0V9.5a.5.5 0 01.5-.5H4a.5.5 0 010 1H2.48a4.12 4.12 0 00.92 1zm.6 2.72v.14c0 .2.11.37.29.45l4.66 2.16c.67.3 1.43.3 2.1 0l4.66-2.16a.5.5 0 00.29-.45v-.14a10 10 0 001-.55v.7a1.5 1.5 0 01-.87 1.35l-4.66 2.15c-.93.43-2 .43-2.94 0l-4.66-2.15A1.5 1.5 0 013 13.86v-.69c.31.2.65.39 1 .55zM6.04 6.8a.5.5 0 01.66-.26L10 7.96l3.3-1.42a.5.5 0 01.4.92l-3.2 1.37V11a.5.5 0 11-1 0V8.83L6.3 7.46a.5.5 0 01-.26-.66z",
    fill: primaryFill
  }));
};

export const CubeRotateRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeRotateRegularIcon({}), 'CubeRotateRegular');

const CubeSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.7 2.48a3.5 3.5 0 012.6 0l5.76 2.3c.57.23.94.78.94 1.4v4.08a5.48 5.48 0 00-7.5.47v-1.9l4.2-1.87a.5.5 0 10-.4-.92L10 7.95l-4.3-1.9a.5.5 0 10-.4.9l4.2 1.87v3.39a5.48 5.48 0 00.58 5.56 3.5 3.5 0 01-1.38-.25l-5.76-2.3a1.5 1.5 0 01-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3zM10 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const CubeSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeSyncFilledIcon({}), 'CubeSyncFilled');

const CubeSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.7 6.04a.5.5 0 10-.4.92l4.2 1.86v3.39a5.5 5.5 0 011-1.48v-1.9l4.2-1.87a.5.5 0 10-.4-.92L10 7.95l-4.3-1.9zM9.07 16.6c.13.05.26.1.4.12.16.38.36.73.6 1.06a3.5 3.5 0 01-1.37-.25l-5.76-2.3a1.5 1.5 0 01-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3a3.5 3.5 0 012.6 0l5.76 2.3c.57.23.94.78.94 1.4v4.08a5.5 5.5 0 00-1-.66V6.18a.5.5 0 00-.31-.47l-5.76-2.3a2.5 2.5 0 00-1.86 0l-5.76 2.3a.5.5 0 00-.31.47v7.64c0 .2.12.4.31.47l5.76 2.3zM10 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const CubeSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeSyncRegularIcon({}), 'CubeSyncRegular');

const CubeTreeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.57 2.07c.28-.09.58-.09.86 0l2.85.85a1 1 0 01.72.95v4.26a1 1 0 01-.72.96l-2.79.83a.5.5 0 01.01.08v1H12a2 2 0 012 2v.05a2.5 2.5 0 11-1 0V13a1 1 0 00-1-1H8a1 1 0 00-1 1v.05a2.5 2.5 0 11-1 0V13c0-1.1.9-2 2-2h1.5v-1a.5.5 0 010-.08l-2.78-.83A1 1 0 016 8.13V3.87a1 1 0 01.72-.95l2.85-.85zm-.91 2.46a.5.5 0 00-.32.95l1.16.38V7a.5.5 0 001 0V5.86l1.16-.38a.5.5 0 10-.32-.95L10 4.97l-1.34-.44z",
    fill: primaryFill
  }));
};

export const CubeTreeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeTreeFilledIcon({}), 'CubeTreeFilled');

const CubeTreeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.66 4.53a.5.5 0 00-.32.95l1.16.38V7a.5.5 0 001 0V5.86l1.16-.38a.5.5 0 10-.32-.95L10 4.97l-1.34-.44zm1.77-2.46a1.5 1.5 0 00-.86 0l-2.86.85a.99.99 0 00-.71.95v4.26c0 .44.3.83.72.96l2.79.83a.5.5 0 00-.01.08v1H8a2 2 0 00-2 2v.05a2.5 2.5 0 101 0V13a1 1 0 011-1h4a1 1 0 011 1v.05a2.5 2.5 0 101 0V13a2 2 0 00-2-2h-1.5v-1a.5.5 0 000-.08l2.78-.83a1 1 0 00.72-.96V3.87a1 1 0 00-.72-.95l-2.85-.85zm-.57.95a.5.5 0 01.28 0l2.86.85v4.26l-2.86.85a.5.5 0 01-.28 0L7 8.13V3.87l2.86-.85zM5 15.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm8.5-1.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    fill: primaryFill
  }));
};

export const CubeTreeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeTreeRegularIcon({}), 'CubeTreeRegular');

const CurrencyDollarEuroFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2a.75.75 0 00-.75.75v.33A3.5 3.5 0 002 6.5v.28c0 1.47.85 2.8 2.17 3.42l.58.27v4.87a2 2 0 01-1.25-1.86V12.4a.75.75 0 00-1.5 0v1.08a3.5 3.5 0 002.75 3.42v.35a.75.75 0 001.5 0v-.35A3.5 3.5 0 009 13.48v-.27c0-1.46-.84-2.8-2.17-3.42l-.58-.27V4.64A2 2 0 017.5 6.5v1.1a.75.75 0 001.5 0V6.5a3.5 3.5 0 00-2.75-3.42v-.33A.75.75 0 005.5 2zm-2 4.5a2 2 0 011.25-1.86v4.18A2.28 2.28 0 013.5 6.78V6.5zm2.75 8.84v-4.16a2.27 2.27 0 011.25 2.03v.27a2 2 0 01-1.25 1.86zM12.5 10c0-.34.02-.66.06-.98h1.7a.75.75 0 000-1.5h-1.38A6.1 6.1 0 0113.61 6c.67-1 1.52-1.5 2.36-1.5.3 0 .63.1.86.25a.75.75 0 00.84-1.24 3.1 3.1 0 00-1.7-.51c-1.49 0-2.75.9-3.6 2.16a7.8 7.8 0 00-1.05 2.36h-.57a.75.75 0 000 1.5h.3a10.02 10.02 0 00-.05 1h-.25a.75.75 0 100 1.5h.37a8.2 8.2 0 001.25 3.32c.85 1.26 2.11 2.16 3.6 2.16.54 0 1.2-.14 1.72-.52a.75.75 0 10-.87-1.22c-.21.15-.53.24-.85.24-.84 0-1.69-.5-2.36-1.5a6.6 6.6 0 01-.97-2.48h1.61a.75.75 0 100-1.5H12.5V10z",
    fill: primaryFill
  }));
};

export const CurrencyDollarEuroFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CurrencyDollarEuroFilledIcon({}), 'CurrencyDollarEuroFilled');

const CurrencyDollarEuroRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2a.5.5 0 00-.5.5v.54c-1.7.24-3 1.7-3 3.46v.13c0 1.43.84 2.73 2.14 3.31l.86.38v5.62a2.5 2.5 0 01-2-2.45v-.99a.5.5 0 10-1 0v.99a3.5 3.5 0 003 3.46v.55a.5.5 0 001 0v-.55c1.7-.24 3-1.7 3-3.46v-.12c0-1.43-.84-2.72-2.14-3.3L6 9.66V4.06A2.5 2.5 0 018 6.5v1a.5.5 0 001 0v-1a3.5 3.5 0 00-3-3.46V2.5a.5.5 0 00-.5-.5zM3 6.5c0-1.2.86-2.22 2-2.45v5.18l-.45-.2A2.63 2.63 0 013 6.63V6.5zm3 9.44v-5.17l.45.2A2.62 2.62 0 018 13.37v.12a2.5 2.5 0 01-2 2.45zM12 10c0-.34.02-.68.06-1h1.44a.5.5 0 100-1h-1.26c.21-.89.57-1.67 1.01-2.3.77-1.1 1.78-1.7 2.85-1.7.39 0 .81.11 1.12.31a.5.5 0 10.55-.84A3.15 3.15 0 0016.1 3c-1.48 0-2.76.85-3.66 2.12-.57.8-1 1.79-1.23 2.88h-.71a.5.5 0 100 1h.55a9.7 9.7 0 00-.05 1h-.5a.5.5 0 000 1h.55c.16 1.5.65 2.84 1.39 3.88A4.55 4.55 0 0016.1 17c.54 0 1.17-.13 1.68-.48a.5.5 0 00-.56-.82c-.3.2-.72.3-1.12.3-1.07 0-2.08-.6-2.85-1.7a7.19 7.19 0 01-1.2-3.3h1.45a.5.5 0 000-1H12z",
    fill: primaryFill
  }));
};

export const CurrencyDollarEuroRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CurrencyDollarEuroRegularIcon({}), 'CurrencyDollarEuroRegular');

const CurrencyDollarRupeeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.25 2.75a.75.75 0 10-1.5 0v.33A3.5 3.5 0 002 6.5v.28c0 1.47.85 2.8 2.17 3.42l.58.27v4.87a2 2 0 01-1.25-1.86V12.4a.75.75 0 00-1.5 0v1.08a3.5 3.5 0 002.75 3.42v.35a.75.75 0 001.5 0v-.35A3.5 3.5 0 009 13.48v-.27c0-1.46-.84-2.8-2.17-3.42l-.58-.27V4.64A2 2 0 017.5 6.5v1.1a.75.75 0 001.5 0V6.5a3.5 3.5 0 00-2.75-3.42v-.33zm-1.5 1.9v4.17A2.28 2.28 0 013.5 6.78V6.5a2 2 0 011.25-1.86zm1.5 6.53a2.27 2.27 0 011.25 2.03v.27a2 2 0 01-1.25 1.86v-4.16zM10.75 3a.75.75 0 000 1.5h2.75c.88 0 1.65.5 2.02 1.25h-4.77a.75.75 0 000 1.5h4.94A2.25 2.25 0 0113.5 9h-2.75a.75.75 0 00-.57 1.24l6.5 7.5a.75.75 0 101.14-.98l-5.43-6.26h1.11c1.9 0 3.47-1.42 3.72-3.25h.03a.75.75 0 000-1.5h-.13a3.74 3.74 0 00-.62-1.25h.75a.75.75 0 000-1.5h-6.5z",
    fill: primaryFill
  }));
};

export const CurrencyDollarRupeeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CurrencyDollarRupeeFilledIcon({}), 'CurrencyDollarRupeeFilled');

const CurrencyDollarRupeeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2c.28 0 .5.22.5.5v.54c1.7.24 3 1.7 3 3.46v1a.5.5 0 01-1 0v-1a2.5 2.5 0 00-2-2.45v5.63l.86.38A3.62 3.62 0 019 13.36v.13a3.5 3.5 0 01-3 3.46v.55a.5.5 0 01-1 0v-.55a3.5 3.5 0 01-3-3.46v-.99a.5.5 0 111 0v.99a2.5 2.5 0 002 2.45v-5.62l-.86-.38A3.63 3.63 0 012 6.63V6.5a3.5 3.5 0 013-3.46V2.5c0-.28.22-.5.5-.5zM3 6.5v.13c0 1.03.6 1.97 1.55 2.4l.45.2V4.05A2.5 2.5 0 003 6.5zm3 9.44a2.5 2.5 0 002-2.45v-.12c0-1.04-.6-1.97-1.55-2.4l-.45-.2v5.17zM10 3.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm0-3c0-.28.22-.5.5-.5h3a3.5 3.5 0 110 7h-1.9l6.28 7.17a.5.5 0 01-.76.66l-7-8A.5.5 0 0110.5 9h3a2.5 2.5 0 000-5h-3a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const CurrencyDollarRupeeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CurrencyDollarRupeeRegularIcon({}), 'CurrencyDollarRupeeRegular');

const CursorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.64 2.29A1 1 0 005 3.06v14a1 1 0 001.76.65l3.52-4.07c.28-.33.7-.52 1.13-.52h5.6a1 1 0 00.63-1.77l-11-9.06z",
    fill: primaryFill
  }));
};

export const CursorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorFilledIcon({}), 'CursorFilled');

const CursorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.06a1 1 0 011.64-.77l11 9.06a1 1 0 01-.63 1.77h-5.6c-.43 0-.85.19-1.13.52L6.76 17.7A1 1 0 015 17.06v-14zm12 9.06L6 3.06v14l3.52-4.08a2.5 2.5 0 011.9-.86H17z",
    fill: primaryFill
  }));
};

export const CursorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorRegularIcon({}), 'CursorRegular');

const CursorClickFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 2c.28 0 .5.22.5.5v2a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5zM3.61 3.61c.2-.2.51-.2.7 0l1.42 1.42a.5.5 0 11-.7.7L3.6 4.32a.5.5 0 010-.7zm7.78 0c.2.2.2.51 0 .7L9.97 5.74a.5.5 0 11-.7-.7l1.41-1.42c.2-.2.51-.2.7 0zM2 7.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm5.5.53v9.26c0 .45.54.67.85.36l2.56-2.56a2 2 0 011.42-.59h3.23a.5.5 0 00.31-.9L8.31 7.65a.5.5 0 00-.81.4z",
    fill: primaryFill
  }));
};

export const CursorClickFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorClickFilledIcon({}), 'CursorClickFilled');

const CursorClickRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 2c.28 0 .5.22.5.5v2a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5zM3.61 3.61c.2-.2.51-.2.7 0l1.42 1.42a.5.5 0 11-.7.7L3.6 4.32a.5.5 0 010-.7zm7.78 0c.2.2.2.51 0 .7L9.97 5.74a.5.5 0 11-.7-.7l1.41-1.42c.2-.2.51-.2.7 0zM2 7.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm6.64-.2A1 1 0 007 8.07v9.1a1 1 0 001.75.66l2.03-2.32c.28-.32.7-.51 1.13-.51h3.2a1 1 0 00.65-1.77L8.64 7.3zM8 17.17v-9.1L15.12 14H11.9c-.72 0-1.4.31-1.88.85L8 17.17z",
    fill: primaryFill
  }));
};

export const CursorClickRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorClickRegularIcon({}), 'CursorClickRegular');

const CursorHoverFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v7c0 1.1.9 2 2 2h5v-4.5a1.5 1.5 0 012.56-1.06l5 5c.11.11.2.24.28.38A2 2 0 0018 13V6a2 2 0 00-2-2H4zm6.85 6.15a.5.5 0 00-.85.35v7a.5.5 0 00.91.29l1.57-2.25 2.94.45a.5.5 0 00.43-.84l-5-5zM11 15.9v-4.2l3.07 3.06-1.74-.26a.5.5 0 00-.49.2l-.84 1.2z",
    fill: primaryFill
  }));
};

export const CursorHoverFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorHoverFilledIcon({}), 'CursorHoverFilled');

const CursorHoverRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v7a2 2 0 01-1.16 1.82 1.5 1.5 0 00-.28-.38l-.45-.45A1 1 0 0017 13V6a1 1 0 00-1-1H4a1 1 0 00-1 1v7a1 1 0 001 1h5v1H4a2 2 0 01-2-2V6zm8.85 4.15a.5.5 0 00-.85.35v7a.5.5 0 00.91.29l1.57-2.25 2.94.45a.5.5 0 00.43-.84l-5-5zM11 15.9v-4.2l3.07 3.06-1.74-.26a.5.5 0 00-.49.2l-.84 1.2z",
    fill: primaryFill
  }));
};

export const CursorHoverRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorHoverRegularIcon({}), 'CursorHoverRegular');

const CursorHoverOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L3.39 4.1A2 2 0 002 6v7c0 1.1.9 2 2 2h5v-4.5c0-.23.05-.45.15-.65l.85.86v6.79a.5.5 0 00.91.29l1.57-2.25 2.78.43 1.89 1.88a.5.5 0 00.7-.7l-8-8-7-7zm11.22 12.62l-1.74-.26a.5.5 0 00-.49.2l-.84 1.2v-4.2l3.07 3.06zm2.84.01A2 2 0 0018 13V6a2 2 0 00-2-2H6.12l10.79 10.78z",
    fill: primaryFill
  }));
};

export const CursorHoverOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorHoverOffFilledIcon({}), 'CursorHoverOffFilled');

const CursorHoverOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L3.39 4.1A2 2 0 002 6v7c0 1.1.9 2 2 2h5v-1H4a1 1 0 01-1-1V6a1 1 0 011-1h.3l5.7 5.7v6.8a.5.5 0 00.91.29l1.57-2.25 2.78.43 1.89 1.88a.5.5 0 00.7-.7l-15-15zm11.22 12.62l-1.74-.26a.5.5 0 00-.49.2l-.84 1.2v-4.2l3.07 3.06zm2.84.01A2 2 0 0018 13V6a2 2 0 00-2-2H6.12l1 1H16a1 1 0 011 1v7a1 1 0 01-.89 1l.8.78z",
    fill: primaryFill
  }));
};

export const CursorHoverOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorHoverOffRegularIcon({}), 'CursorHoverOffRegular');

const CutFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.88 3.16l-3.1 4.77-.9-1.38 2.74-4.2a.75.75 0 011.26.8zm-2.38 8.6a3.24 3.24 0 014.5 2.99 3.25 3.25 0 11-5.72-2.11L10 10.66l-1.28 1.98a3.25 3.25 0 11-1.21-.88l1.6-2.47-3.99-6.13a.75.75 0 011.26-.82l6.12 9.41zm.2 1.6a1.75 1.75 0 10.01-.02l-.02.02zM6.24 13a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5z",
    fill: primaryFill
  }));
};

export const CutFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CutFilledIcon({}), 'CutFilled');

const CutRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.92 2.23a.5.5 0 00-.84.54L9.4 9.43l-1.92 2.96a3 3 0 10.78.64L10 10.35l1.74 2.68a3 3 0 10.78-.64L5.92 2.23zM14 17a2 2 0 110-4 2 2 0 010 4zM4 15a2 2 0 114 0 2 2 0 01-4 0zm7.2-6.49l-.6-.92 3.48-5.36a.5.5 0 01.84.54l-3.73 5.74z",
    fill: primaryFill
  }));
};

export const CutRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CutRegularIcon({}), 'CutRegular');

const DarkThemeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3.5a6.5 6.5 0 110 13v-13zM10 2a8 8 0 100 16 8 8 0 000-16z",
    fill: primaryFill
  }));
};

export const DarkThemeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DarkThemeFilledIcon({}), 'DarkThemeFilled');

const DarkThemeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a7 7 0 110 14V3zm0-1a8 8 0 100 16 8 8 0 000-16z",
    fill: primaryFill
  }));
};

export const DarkThemeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DarkThemeRegularIcon({}), 'DarkThemeRegular');

const DataAreaFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 2.49a.5.5 0 00-1 .01v15c0 .28.22.5.5.5h15a.5.5 0 100-1H3V2.49zM16 16V5.5a.5.5 0 00-.81-.39L10.45 8.9l-3.2-1.83a.5.5 0 00-.45-.03L4 8.3V16h12z",
    fill: primaryFill
  }));
};

export const DataAreaFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataAreaFilledIcon({}), 'DataAreaFilled');

const DataAreaRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 2.5a.5.5 0 10-1 0v15c0 .28.22.5.5.5h15a.5.5 0 100-1H16V5.5a.5.5 0 00-.81-.39L10.45 8.9l-3.2-1.83a.5.5 0 00-.45-.03L3 8.74V2.5zm0 7.32l3.97-1.76 3.28 1.87c.18.1.4.09.56-.04L15 6.54V17H3V9.82z",
    fill: primaryFill
  }));
};

export const DataAreaRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataAreaRegularIcon({}), 'DataAreaRegular');

const DataBarHorizontalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 2a2 2 0 100 4h5a2 2 0 100-4H4zm0 6a2 2 0 100 4h8a2 2 0 100-4H4zm0 6a2 2 0 100 4h12a2 2 0 100-4H4z",
    fill: primaryFill
  }));
};

export const DataBarHorizontalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarHorizontalFilledIcon({}), 'DataBarHorizontalFilled');

const DataBarHorizontalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h5a2 2 0 110 4H4a2 2 0 01-2-2zm2-1a1 1 0 000 2h5a1 1 0 000-2H4zm-2 7c0-1.1.9-2 2-2h8a2 2 0 110 4H4a2 2 0 01-2-2zm2-1a1 1 0 000 2h8a1 1 0 100-2H4zm-2 7c0-1.1.9-2 2-2h12a2 2 0 110 4H4a2 2 0 01-2-2zm2-1a1 1 0 100 2h12a1 1 0 100-2H4z",
    fill: primaryFill
  }));
};

export const DataBarHorizontalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarHorizontalRegularIcon({}), 'DataBarHorizontalRegular');

const DataBarVerticalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v10a2 2 0 104 0V5a2 2 0 00-2-2zm5 3a2 2 0 00-2 2v7a2 2 0 104 0V8a2 2 0 00-2-2zm5 3a2 2 0 00-2 2v4a2 2 0 104 0v-4a2 2 0 00-2-2z",
    fill: primaryFill
  }));
};

export const DataBarVerticalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarVerticalFilledIcon({}), 'DataBarVerticalFilled');

const DataBarVerticalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v10a2 2 0 104 0V5a2 2 0 00-2-2zM4 5a1 1 0 012 0v10a1 1 0 11-2 0V5zm4 3a2 2 0 114 0v7a2 2 0 11-4 0V8zm2-1a1 1 0 00-1 1v7a1 1 0 102 0V8a1 1 0 00-1-1zm3 4a2 2 0 114 0v4a2 2 0 11-4 0v-4zm2-1a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1z",
    fill: primaryFill
  }));
};

export const DataBarVerticalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarVerticalRegularIcon({}), 'DataBarVerticalRegular');

const DataBarVerticalAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18a2 2 0 01-2-2V4a2 2 0 114 0v5.6a5.5 5.5 0 00-1.76 8.39L10 18zm4.5-9c1.33 0 2.55.47 3.5 1.26V8a2 2 0 10-4 0v1.02l.5-.02zM2 16a2 2 0 104 0v-4a2 2 0 10-4 0v4zm17-1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const DataBarVerticalAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarVerticalAddFilledIcon({}), 'DataBarVerticalAddFilled');

const DataBarVerticalAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18a2 2 0 01-2-2V4a2 2 0 114 0v5.6c-.36.18-.7.4-1 .66V4a1 1 0 10-2 0v12a1 1 0 00.55.9c.19.38.42.75.7 1.09L10 18zm8-10v2.26a5.5 5.5 0 00-1-.66V8a1 1 0 10-2 0v1.02a5.57 5.57 0 00-1 0V8a2 2 0 114 0zM2 16a2 2 0 104 0v-4a2 2 0 10-4 0v4zm2 1a1 1 0 01-1-1v-4a1 1 0 112 0v4a1 1 0 01-1 1zm15-2.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const DataBarVerticalAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarVerticalAddRegularIcon({}), 'DataBarVerticalAddRegular');

const DataFunnelFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h12a2 2 0 110 4H4a2 2 0 01-2-2zm2 6c0-1.1.9-2 2-2h8a2 2 0 110 4H6a2 2 0 01-2-2zm4 4a2 2 0 100 4h4a2 2 0 100-4H8z",
    fill: primaryFill
  }));
};

export const DataFunnelFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataFunnelFilledIcon({}), 'DataFunnelFilled');

const DataFunnelRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h12a2 2 0 110 4H4a2 2 0 01-2-2zm2-1a1 1 0 000 2h12a1 1 0 100-2H4zm0 7c0-1.1.9-2 2-2h8a2 2 0 110 4H6a2 2 0 01-2-2zm2-1a1 1 0 000 2h8a1 1 0 100-2H6zm2 5a2 2 0 100 4h4a2 2 0 100-4H8zm-1 2a1 1 0 011-1h4a1 1 0 110 2H8a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const DataFunnelRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataFunnelRegularIcon({}), 'DataFunnelRegular');

const DataHistogramFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 4.5c0-.83-.67-1.5-1.5-1.5h-1C8.67 3 8 3.67 8 4.5V17h4V4.5zM13 6v11h3.5a.5.5 0 00.5-.5V8a2 2 0 00-2-2h-2zM5 9h2v8H3.5a.5.5 0 01-.5-.5V11c0-1.1.9-2 2-2z",
    fill: primaryFill
  }));
};

export const DataHistogramFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataHistogramFilledIcon({}), 'DataHistogramFilled');

const DataHistogramRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 5v11h4V5a1 1 0 00-1-1H9a1 1 0 00-1 1zM7 9V5c0-1.1.9-2 2-2h2a2 2 0 012 2v1h2a2 2 0 012 2v8.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V11c0-1.1.9-2 2-2h2zm0 7v-6H5a1 1 0 00-1 1v5h3zm6 0h3V8a1 1 0 00-1-1h-2v9z",
    fill: primaryFill
  }));
};

export const DataHistogramRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataHistogramRegularIcon({}), 'DataHistogramRegular');

const DataLineFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a2.5 2.5 0 01-3.44 2.32l-1.29 1.92A2.5 2.5 0 0111.5 14a2.5 2.5 0 01-2.05-1.08L6.95 14A2.51 2.51 0 014.5 17a2.5 2.5 0 112.05-3.92L9.05 12a2.51 2.51 0 013.4-2.83l1.28-1.92A2.5 2.5 0 0115.5 3 2.5 2.5 0 0118 5.5z",
    fill: primaryFill
  }));
};

export const DataLineFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataLineFilledIcon({}), 'DataLineFilled');

const DataLineRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 4a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM13 5.5a2.5 2.5 0 111.56 2.32l-1.29 1.92A2.5 2.5 0 0111.5 14a2.5 2.5 0 01-2.05-1.08L6.95 14A2.51 2.51 0 014.5 17a2.5 2.5 0 112.05-3.92L9.05 12A2.51 2.51 0 0111.5 9c.33 0 .65.07.94.18l1.29-1.92A2.5 2.5 0 0113 5.5zm-3 6a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm-7 3a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z",
    fill: primaryFill
  }));
};

export const DataLineRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataLineRegularIcon({}), 'DataLineRegular');

const DataPieFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 4.07c.55-.08 1 .38 1 .93v6h6c.55 0 1 .45.93 1A7 7 0 118 4.07zM17.06 10c.5 0 .93-.37.94-.86V9a7 7 0 00-7.14-7c-.5.01-.86.44-.86.94V9a1 1 0 001 1h6.06z",
    fill: primaryFill
  }));
};

export const DataPieFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataPieFilledIcon({}), 'DataPieFilled');

const DataPieRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 12a1 1 0 01-1-1V5.08A6 6 0 1014.92 12H9zM8 4.07c.55-.08 1 .38 1 .93v6h6c.55 0 1 .45.93 1A7 7 0 118 4.07zM11 9V3a6 6 0 016 6h-6zm6.06 1c.5 0 .93-.37.94-.86V9a7 7 0 00-7.14-7c-.5.01-.86.44-.86.94V9a1 1 0 001 1h6.06z",
    fill: primaryFill
  }));
};

export const DataPieRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataPieRegularIcon({}), 'DataPieRegular');

const DataScatterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 2.5a.5.5 0 00-1 0v15c0 .28.22.5.5.5h15a.5.5 0 000-1H3V2.5zM7.5 10a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM17 5.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM12.5 15a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    fill: primaryFill
  }));
};

export const DataScatterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataScatterFilledIcon({}), 'DataScatterFilled');

const DataScatterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 2.5a.5.5 0 00-1 0v15c0 .28.22.5.5.5h15a.5.5 0 000-1H3V2.5zm3 5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM7.5 5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm7-1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM12 5.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm-1 7a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm1.5-2.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z",
    fill: primaryFill
  }));
};

export const DataScatterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataScatterRegularIcon({}), 'DataScatterRegular');

const DataSunburstFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.94 3.13a.5.5 0 01-.2.68A7.03 7.03 0 003.8 6.73a.5.5 0 01-.89-.46 8.03 8.03 0 013.35-3.35.5.5 0 01.67.21zm6.12 0a.5.5 0 01.67-.2 8.03 8.03 0 013.35 3.34.5.5 0 01-.89.46 7.03 7.03 0 00-2.92-2.92.5.5 0 01-.21-.68zm-9.93 9.93a.5.5 0 01.68.2 7.03 7.03 0 002.92 2.93.5.5 0 01-.46.89 8.03 8.03 0 01-3.35-3.35.5.5 0 01.21-.67zm13.74 0a.5.5 0 01.2.67 8.03 8.03 0 01-3.34 3.35.5.5 0 11-.46-.89 7.03 7.03 0 002.92-2.92.5.5 0 01.68-.21zM10 5.5c-.15 0-.3 0-.45.02a.5.5 0 11-.1-1L10 4.5a5.5 5.5 0 015.25 3.85.5.5 0 11-.96.3A4.5 4.5 0 0010 5.5zm-2.6.2a.5.5 0 01-.1.7 4.5 4.5 0 00-1.2 5.85.5.5 0 01-.86.5A5.48 5.48 0 016.7 5.6a.5.5 0 01.7.1zm7.52 5.32a.5.5 0 01.33.63 5.5 5.5 0 01-8 3.11.5.5 0 01.5-.86 4.5 4.5 0 006.54-2.55.5.5 0 01.63-.33zM10 13a3 3 0 100-6 3 3 0 000 6z",
    fill: primaryFill
  }));
};

export const DataSunburstFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataSunburstFilledIcon({}), 'DataSunburstFilled');

const DataSunburstRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.94 3.13a.5.5 0 01-.2.68A7.03 7.03 0 003.8 6.73a.5.5 0 01-.89-.46 8.03 8.03 0 013.35-3.35.5.5 0 01.67.21zm6.12 0a.5.5 0 01.67-.2 8.03 8.03 0 013.35 3.34.5.5 0 01-.89.46 7.03 7.03 0 00-2.92-2.92.5.5 0 01-.21-.68zm-9.93 9.93a.5.5 0 01.68.2 7.03 7.03 0 002.92 2.93.5.5 0 01-.46.89 8.03 8.03 0 01-3.35-3.35.5.5 0 01.21-.67zm13.74 0a.5.5 0 01.2.67 8.03 8.03 0 01-3.34 3.35.5.5 0 11-.46-.89 7.03 7.03 0 002.92-2.92.5.5 0 01.68-.21zM10 5.5c-.15 0-.3 0-.45.02a.5.5 0 11-.1-1L10 4.5a5.5 5.5 0 015.25 3.85.5.5 0 11-.96.3A4.5 4.5 0 0010 5.5zm-2.6.2a.5.5 0 01-.1.7 4.5 4.5 0 00-1.2 5.85.5.5 0 01-.86.5A5.48 5.48 0 016.7 5.6a.5.5 0 01.7.1zm7.52 5.32a.5.5 0 01.33.63 5.5 5.5 0 01-8 3.11.5.5 0 01.5-.86 4.5 4.5 0 006.54-2.55.5.5 0 01.63-.33zM8 10a2 2 0 114 0 2 2 0 01-4 0zm2-3a3 3 0 100 6 3 3 0 000-6z",
    fill: primaryFill
  }));
};

export const DataSunburstRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataSunburstRegularIcon({}), 'DataSunburstRegular');

const DataTreemapFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 3H6a3 3 0 00-3 3v8a3 3 0 003 3h1V3zm1 14h6a3 3 0 003-3v-1H8v4zm9-5V6a3 3 0 00-3-3H8v9h9z",
    fill: primaryFill
  }));
};

export const DataTreemapFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataTreemapFilledIcon({}), 'DataTreemapFilled');

const DataTreemapRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zm1 1v12H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2h1zm1 12v-3h8v1a2 2 0 01-2 2H8zm8-4H8V4h6a2 2 0 012 2v6z",
    fill: primaryFill
  }));
};

export const DataTreemapRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataTreemapRegularIcon({}), 'DataTreemapRegular');

const DataTrendingFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 16.25c0 .41-.34.75-.75.75H4.75C3.78 17 3 16.22 3 15.25V3.75a.75.75 0 011.5 0v11.5c0 .14.11.25.25.25h11.5c.41 0 .75.34.75.75zm-5-10.5c0-.41.34-.75.75-.75h3.5c.41 0 .75.34.75.75v3.5a.75.75 0 01-1.5 0V7.56l-3.97 3.97a.75.75 0 01-1.06 0L9 10.06l-2.22 2.22a.75.75 0 01-1.06-1.06l2.75-2.75a.75.75 0 011.06 0L11 9.94l3.44-3.44h-1.69a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const DataTrendingFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataTrendingFilledIcon({}), 'DataTrendingFilled');

const DataTrendingRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 16.5a.5.5 0 01-.5.5h-12A1.5 1.5 0 013 15.5v-12a.5.5 0 011 0v12c0 .28.22.5.5.5h12c.28 0 .5.22.5.5zm-5-11c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v4a.5.5 0 01-1 0V6.7l-4.65 4.65a.5.5 0 01-.7 0L9 9.71l-3.15 3.14a.5.5 0 01-.7-.7l3.5-3.5a.5.5 0 01.7 0L11 10.29 15.3 6h-2.8a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DataTrendingRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataTrendingRegularIcon({}), 'DataTrendingRegular');

const DataUsageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm5 7c.28 0 .5.22.5.5v3a.5.5 0 01-1 0v-3c0-.28.22-.5.5-.5zM6 8.5a.5.5 0 011 0v5a.5.5 0 01-1 0v-5zM13.5 6c.28 0 .5.22.5.5v7a.5.5 0 01-1 0v-7c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const DataUsageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageFilledIcon({}), 'DataUsageFilled');

const DataUsageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 10a.5.5 0 00-.5.5v3a.5.5 0 001 0v-3a.5.5 0 00-.5-.5zM6 8.5a.5.5 0 011 0v5a.5.5 0 01-1 0v-5zM13.5 6a.5.5 0 00-.5.5v7a.5.5 0 001 0v-7a.5.5 0 00-.5-.5zM3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm1 0v10a1 1 0 001 1h10a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1z",
    fill: primaryFill
  }));
};

export const DataUsageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageRegularIcon({}), 'DataUsageRegular');

const DataUsageEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 2a2 2 0 00-2 2v10c0 1.1.9 2 2 2h5.48c.15-.5.42-.96.8-1.33l1.84-1.85a.5.5 0 01-.12-.32v-7a.5.5 0 011 0v6.44l2.1-2.1c.27-.27.57-.47.9-.6V4a2 2 0 00-2-2H4zm5 7c.28 0 .5.22.5.5v3a.5.5 0 01-1 0v-3c0-.28.22-.5.5-.5zM5 7.5a.5.5 0 011 0v5a.5.5 0 01-1 0v-5zm5.98 7.88l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.82 4.83a2.2 2.2 0 01-1.03.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const DataUsageEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageEditFilledIcon({}), 'DataUsageEditFilled');

const DataUsageEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 15h5.99c-.23.3-.4.64-.51 1H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2h10a2 2 0 012 2v5.23c-.33.14-.63.34-.9.61l-.1.1V4a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1zm8-9.5a.5.5 0 011 0v6.44l-.88.88a.5.5 0 01-.12-.32v-7zm-7 2a.5.5 0 011 0v5a.5.5 0 01-1 0v-5zM9 9a.5.5 0 00-.5.5v3a.5.5 0 001 0v-3A.5.5 0 009 9zm1.98 6.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.82 4.83a2.2 2.2 0 01-1.03.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const DataUsageEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageEditRegularIcon({}), 'DataUsageEditRegular');

const DataUsageSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6a3 3 0 013-3h8a3 3 0 013 3v3.2a5.5 5.5 0 00-3 0V6.5a.5.5 0 00-1 0v3.1a5.5 5.5 0 00-2.5 2.6v-1.7a.5.5 0 00-1 0v3a.5.5 0 00.52.5 5.5 5.5 0 00.58 3H5a3 3 0 01-3-3V6zm3.5 2a.5.5 0 00-.5.5v5a.5.5 0 001 0v-5a.5.5 0 00-.5-.5zm6.57 3.44a2 2 0 01-1.43 2.48l-.47.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const DataUsageSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageSettingsFilledIcon({}), 'DataUsageSettingsFilled');

const DataUsageSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a3 3 0 00-3 3v8a3 3 0 003 3h4.6a5.5 5.5 0 01-.4-1H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h8a2 2 0 012 2v3.02a5.5 5.5 0 011 .19V6a3 3 0 00-3-3H5zm4.02 11a5.5 5.5 0 01.48-1.8v-1.7a.5.5 0 00-1 0v3a.5.5 0 00.52.5zm3.38-4.58l.6-.21V6.5a.5.5 0 00-1 0v3.1c.13-.06.26-.13.4-.18zM5.5 8a.5.5 0 00-.5.5v5a.5.5 0 001 0v-5a.5.5 0 00-.5-.5zm6.57 3.44a2 2 0 01-1.43 2.48l-.47.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const DataUsageSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageSettingsRegularIcon({}), 'DataUsageSettingsRegular');

const DataUsageToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 2a2 2 0 00-2 2v10c0 1.1.9 2 2 2h5v-2.5c0-.17.02-.34.05-.5H9a.5.5 0 01-.5-.5v-3a.5.5 0 011 0V12c.37-.5.91-.84 1.54-.96A2.5 2.5 0 0112 9.5v-4a.5.5 0 011 0v3.55c.16-.03.33-.05.5-.05h2c.17 0 .34.02.5.05V4a2 2 0 00-2-2H4zm1 5.5a.5.5 0 011 0v5a.5.5 0 01-1 0v-5zm7 4.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0V16z",
    fill: primaryFill
  }));
};

export const DataUsageToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageToolboxFilledIcon({}), 'DataUsageToolboxFilled');

const DataUsageToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 9a.5.5 0 00-.5.5v3a.5.5 0 00.55.5c.08-.37.23-.71.45-1V9.5A.5.5 0 009 9zm-5 6h5v1H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2h10a2 2 0 012 2v5.05a2.51 2.51 0 00-.5-.05H15V4a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1zm9-9.5v3.55c-.37.07-.7.23-1 .45v-4a.5.5 0 011 0zm-8 2a.5.5 0 011 0v5a.5.5 0 01-1 0v-5zm7 4.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0V16z",
    fill: primaryFill
  }));
};

export const DataUsageToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageToolboxRegularIcon({}), 'DataUsageToolboxRegular');

const DataWaterfallFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M1 3.5c0-.28.22-.5.5-.5H7a2 2 0 012 2v4.5h6c1.04 0 2 .74 2 1.8V16h1.5a.5.5 0 010 1H13c-1.04 0-2-.74-2-1.8v-4.7H5a2 2 0 01-2-2V4H1.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DataWaterfallFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataWaterfallFilledIcon({}), 'DataWaterfallFilled');

const DataWaterfallRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M1 3.5c0-.28.22-.5.5-.5H7a2 2 0 012 2v4.5h6c1.04 0 2 .74 2 1.8V16h1.5a.5.5 0 010 1H13c-1.04 0-2-.74-2-1.8v-4.7H5a2 2 0 01-2-2V4H1.5a.5.5 0 01-.5-.5zM4 4v4.5a1 1 0 001 1h3V5a1 1 0 00-1-1H4zm12 12v-4.7c0-.38-.38-.8-1-.8h-3v4.7c0 .38.38.8 1 .8h3z",
    fill: primaryFill
  }));
};

export const DataWaterfallRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataWaterfallRegularIcon({}), 'DataWaterfallRegular');

const DataWhiskerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a.5.5 0 000 1h1v1h-.5C4.67 4 4 4.67 4 5.5V10h5V5.5C9 4.67 8.33 4 7.5 4H7V3h1a.5.5 0 000-1H5zm7 2a.5.5 0 000 1h1v1h-.5c-.83 0-1.5.67-1.5 1.5V9h5V7.5c0-.83-.67-1.5-1.5-1.5H14V5h1a.5.5 0 000-1h-3zM4.5 15.5c0 .28.22.5.5.5h3a.5.5 0 000-1H7v-1h.5c.83 0 1.5-.67 1.5-1.5V11H4v1.5c0 .83.67 1.5 1.5 1.5H6v1H5a.5.5 0 00-.5.5zM12 18a.5.5 0 010-1h1v-1h-.5a1.5 1.5 0 01-1.5-1.5V10h5v4.5c0 .83-.67 1.5-1.5 1.5H14v1h1a.5.5 0 010 1h-3z",
    fill: primaryFill
  }));
};

export const DataWhiskerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataWhiskerFilledIcon({}), 'DataWhiskerFilled');

const DataWhiskerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a.5.5 0 000 1h1v1h-.5C4.67 4 4 4.67 4 5.5v7c0 .83.67 1.5 1.5 1.5H6v1H5a.5.5 0 000 1h3a.5.5 0 000-1H7v-1h.5c.83 0 1.5-.67 1.5-1.5v-7C9 4.67 8.33 4 7.5 4H7V3h1a.5.5 0 000-1H5zm0 10.5V11h3v1.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5zm0-7c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5V10H5V5.5zM12 4a.5.5 0 000 1h1v1h-.5c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5h.5v1h-1a.5.5 0 000 1h3a.5.5 0 000-1h-1v-1h.5c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5H14V5h1a.5.5 0 000-1h-3zm3 5h-3V7.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5V9zm-3 1h3v4.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5V10z",
    fill: primaryFill
  }));
};

export const DataWhiskerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataWhiskerRegularIcon({}), 'DataWhiskerRegular');

const DatabaseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3zm4.69.02c.47-.24.93-.54 1.31-.9V15c0 1.66-2.69 3-6 3s-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98z",
    fill: primaryFill
  }));
};

export const DatabaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseFilledIcon({}), 'DatabaseFilled');

const DatabaseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22C6.98 2.28 8.43 2 10 2c1.57 0 3.02.29 4.1.78C15.12 3.24 16 3.99 16 5v10c0 1-.88 1.76-1.9 2.22-1.08.5-2.53.78-4.1.78-1.57 0-3.02-.29-4.1-.78C4.88 16.76 4 16.01 4 15V5zm1 0c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69s2.77-.27 3.68-.69C14.64 5.88 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.19 9.19 0 0010 3c-1.46 0-2.77.27-3.68.69C5.36 4.12 5 4.63 5 5zm10 1.7c-.27.2-.58.38-.9.52-1.08.5-2.53.78-4.1.78-1.57 0-3.02-.29-4.1-.78A4.92 4.92 0 015 6.7V15c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69s2.77-.27 3.68-.69c.96-.43 1.32-.94 1.32-1.31V6.7z",
    fill: primaryFill
  }));
};

export const DatabaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseRegularIcon({}), 'DatabaseRegular');

const DatabaseArrowDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3zm4.69.02c.47-.24.93-.54 1.31-.9v2.09A5.5 5.5 0 0010.26 18H10c-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.85 2.35a.5.5 0 00.35.15.5.5 0 00.35-.15l2-2a.5.5 0 00-.7-.7L15 15.29V12.5a.5.5 0 00-1 0v2.8l-1.15-1.15a.5.5 0 00-.7.7l2 2z",
    fill: primaryFill
  }));
};

export const DatabaseArrowDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseArrowDownFilledIcon({}), 'DatabaseArrowDownFilled');

const DatabaseArrowDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22 1.3-.54 2.7-.8 4.1-.78 1.4-.03 2.8.24 4.1.78C15.13 3.24 16 3.99 16 5v4.2c-.32-.08-.66-.15-1-.18V6.7c-.28.2-.58.38-.9.52-1.3.54-2.7.8-4.1.78-1.4.03-2.8-.24-4.1-.78A4.92 4.92 0 015 6.7V15c0 .37.36.87 1.32 1.31A9.2 9.2 0 009.6 17c.18.36.4.7.66 1H10c-1.4.03-2.8-.24-4.1-.78C4.87 16.75 4 16.01 4 15V5zm1 0c0 .37.36.87 1.32 1.31A9.2 9.2 0 0010 7a9.2 9.2 0 003.68-.69C14.64 5.87 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.2 9.2 0 0010 3a9.2 9.2 0 00-3.68.69C5.36 4.12 5 4.63 5 5zm14 9.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.85 2.35a.5.5 0 00.35.15.5.5 0 00.35-.15l2-2a.5.5 0 00-.7-.7L15 15.29V12.5a.5.5 0 00-1 0v2.8l-1.15-1.15a.5.5 0 00-.7.7l2 2z",
    fill: primaryFill
  }));
};

export const DatabaseArrowDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseArrowDownRegularIcon({}), 'DatabaseArrowDownRegular');

const DatabaseArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3zm4.69.02c.47-.24.93-.54 1.31-.9v2.09A5.5 5.5 0 0010.26 18H10c-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98zM14.5 10a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const DatabaseArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseArrowRightFilledIcon({}), 'DatabaseArrowRightFilled');

const DatabaseArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22 1.3-.54 2.7-.8 4.1-.78 1.4-.03 2.8.24 4.1.78C15.13 3.24 16 3.99 16 5v4.2c-.32-.08-.66-.15-1-.18V6.7c-.28.2-.58.38-.9.52-1.3.54-2.7.8-4.1.78-1.4.03-2.8-.24-4.1-.78A4.92 4.92 0 015 6.7V15c0 .37.36.87 1.32 1.31A9.2 9.2 0 009.6 17c.18.36.4.7.66 1H10c-1.4.03-2.8-.24-4.1-.78C4.87 16.75 4 16.01 4 15V5zm1 0c0 .37.36.87 1.32 1.31A9.2 9.2 0 0010 7a9.2 9.2 0 003.68-.69C14.64 5.87 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.2 9.2 0 0010 3a9.2 9.2 0 00-3.68.69C5.36 4.12 5 4.63 5 5zm9.5 5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const DatabaseArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseArrowRightRegularIcon({}), 'DatabaseArrowRightRegular');

const DatabaseArrowUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3zm4.69.02c.47-.24.93-.54 1.31-.9v2.09A5.5 5.5 0 0010.26 18H10c-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98zM10 14.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm4.85-2.35a.5.5 0 00-.35-.15.5.5 0 00-.35.15l-2 2a.5.5 0 00.7.7L14 13.71v2.79a.5.5 0 001 0v-2.8l1.15 1.15a.5.5 0 00.7-.7l-2-2z",
    fill: primaryFill
  }));
};

export const DatabaseArrowUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseArrowUpFilledIcon({}), 'DatabaseArrowUpFilled');

const DatabaseArrowUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22 1.3-.54 2.7-.8 4.1-.78 1.4-.03 2.8.24 4.1.78C15.13 3.24 16 3.99 16 5v4.2c-.32-.08-.66-.15-1-.18V6.7c-.28.2-.58.38-.9.52-1.3.54-2.7.8-4.1.78-1.4.03-2.8-.24-4.1-.78A4.92 4.92 0 015 6.7V15c0 .37.36.87 1.32 1.31A9.2 9.2 0 009.6 17c.18.36.4.7.66 1H10c-1.4.03-2.8-.24-4.1-.78C4.87 16.75 4 16.01 4 15V5zm1 0c0 .37.36.87 1.32 1.31A9.2 9.2 0 0010 7a9.2 9.2 0 003.68-.69C14.64 5.87 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.2 9.2 0 0010 3a9.2 9.2 0 00-3.68.69C5.36 4.12 5 4.63 5 5zm5 9.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm4.85-2.35a.5.5 0 00-.35-.15.5.5 0 00-.35.15l-2 2a.5.5 0 00.7.7L14 13.71v2.79a.5.5 0 001 0v-2.8l1.15 1.15a.5.5 0 00.7-.7l-2-2z",
    fill: primaryFill
  }));
};

export const DatabaseArrowUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseArrowUpRegularIcon({}), 'DatabaseArrowUpRegular');

const DatabaseLightningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3zm4.69.02c.47-.24.93-.54 1.31-.9V9h-1.92c-.6 0-1.15.36-1.38.92l-2.08 5A1.5 1.5 0 0012 17h.47l-.2.78c-.7.14-1.46.22-2.27.22-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98zM13.11 16c.33 0 .57.3.49.62l-.44 1.74c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 00-.51-1.3h-.4a.5.5 0 01-.48-.66l.56-1.68a.5.5 0 00-.47-.66h-3.47a.5.5 0 00-.47.3l-2.08 5c-.14.34.1.7.46.7h1.11z",
    fill: primaryFill
  }));
};

export const DatabaseLightningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseLightningFilledIcon({}), 'DatabaseLightningFilled');

const DatabaseLightningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22 1.3-.54 2.7-.8 4.1-.78 1.4-.03 2.8.24 4.1.78C15.13 3.24 16 3.99 16 5v4h-1V6.7c-.28.2-.58.38-.9.52-1.3.54-2.7.8-4.1.78-1.4.03-2.8-.24-4.1-.78A4.92 4.92 0 015 6.7V15c0 .37.36.87 1.32 1.31A9.2 9.2 0 0010 17c.5.01 1-.02 1.49-.09.15.06.33.09.51.09h.47l-.2.79c-.74.15-1.5.22-2.27.21-1.4.03-2.8-.24-4.1-.78C4.87 16.75 4 16.01 4 15V5zm1 0c0 .37.36.87 1.32 1.31A9.2 9.2 0 0010 7a9.2 9.2 0 003.68-.69C14.64 5.87 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.2 9.2 0 0010 3a9.2 9.2 0 00-3.68.69C5.36 4.12 5 4.63 5 5zm8.11 11c.33 0 .57.3.49.62l-.44 1.74c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 00-.51-1.3h-.4a.5.5 0 01-.48-.66l.56-1.68a.5.5 0 00-.47-.66h-3.47a.5.5 0 00-.47.3l-2.08 5c-.14.34.1.7.46.7h1.11z",
    fill: primaryFill
  }));
};

export const DatabaseLightningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseLightningRegularIcon({}), 'DatabaseLightningRegular');

const DatabaseLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3zm4.69.02c.47-.24.93-.54 1.31-.9V13h-3.5a3.5 3.5 0 00-3.17 4.98C6.33 17.81 4 16.54 4 15V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98zM12.5 14a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DatabaseLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseLinkFilledIcon({}), 'DatabaseLinkFilled');

const DatabaseLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22C6.98 2.28 8.43 2 10 2c1.57 0 3.02.29 4.1.78C15.12 3.24 16 3.99 16 5v8h-1V6.7c-.27.2-.58.38-.9.52-1.08.5-2.53.78-4.1.78-1.57 0-3.02-.29-4.1-.78A4.92 4.92 0 015 6.7V15c0 .37.36.88 1.32 1.31.7.32 1.64.56 2.71.65.05.36.15.7.3 1.02a9.7 9.7 0 01-3.43-.76C4.88 16.76 4 16.01 4 15V5zm1 0c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69s2.77-.27 3.68-.69C14.64 5.88 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.19 9.19 0 0010 3c-1.46 0-2.77.27-3.68.69C5.36 4.12 5 4.63 5 5zm7.5 9a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DatabaseLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseLinkRegularIcon({}), 'DatabaseLinkRegular');

const DatabaseMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4c0 1.66-2.69 3-6 3S6 5.66 6 4s2.69-3 6-3 6 1.34 6 3zm0 2.12c-.38.36-.84.66-1.31.9-1.25.62-2.91.98-4.69.98-.62 0-1.23-.04-1.81-.13.93.53 1.72 1.34 1.8 2.44H12v6.19c0 .17-.02.34-.05.5H12c3.31 0 6-1.34 6-3V6.12zm-10.69.9l.05.02A9.08 9.08 0 006 7.01v-.89c.38.36.84.66 1.31.9zM9 8.42A7.86 7.86 0 006.5 8C4.01 8 2 9.12 2 10.5S4.01 13 6.5 13s4.5-1.12 4.5-2.5c0-.87-.8-1.63-2-2.08zm1.17 4.72c-1 .55-2.29.86-3.67.86s-2.68-.3-3.67-.86c-.29-.16-.58-.36-.83-.59v3.95C2 17.88 4.01 19 6.5 19s4.5-1.12 4.5-2.5v-3.95c-.25.23-.54.43-.83.6z",
    fill: primaryFill
  }));
};

export const DatabaseMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseMultipleFilledIcon({}), 'DatabaseMultipleFilled');

const DatabaseMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.9 1.78C6.88 2.24 6 2.99 6 4v3.01a9.16 9.16 0 011 0V5.7c.27.2.58.38.9.52 1.08.5 2.53.78 4.1.78 1.57 0 3.02-.29 4.1-.78.32-.14.63-.32.9-.52V14c0 .37-.36.88-1.32 1.31-.91.42-2.22.69-3.68.69v.5c0 .17-.02.34-.05.5H12c1.57 0 3.02-.29 4.1-.78 1.02-.46 1.9-1.21 1.9-2.22V4c0-1-.88-1.76-1.9-2.22A10.17 10.17 0 0012 1c-1.57 0-3.02.29-4.1.78zm.42 3.53C7.36 4.88 7 4.37 7 4c0-.37.36-.88 1.32-1.31A9.19 9.19 0 0112 2c1.46 0 2.77.27 3.68.69.96.43 1.32.94 1.32 1.31 0 .37-.36.88-1.32 1.31-.91.42-2.22.69-3.68.69a9.19 9.19 0 01-3.68-.69zM7 8.01a7.68 7.68 0 012 .41c1.2.45 2 1.21 2 2.08 0 1.38-2.01 2.5-4.5 2.5S2 11.88 2 10.5c0-1.29 1.75-2.35 4-2.48a8.16 8.16 0 011 0zm3.93 8.94C10.54 18.12 8.7 19 6.5 19 4.01 19 2 17.88 2 16.5v-3.95c.25.23.54.43.83.6 1 .54 2.29.85 3.67.85s2.68-.3 3.67-.86c.29-.16.58-.36.83-.59v3.95c0 .15-.03.3-.07.45z",
    fill: primaryFill
  }));
};

export const DatabaseMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseMultipleRegularIcon({}), 'DatabaseMultipleRegular');

const DatabasePersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 5c0 1.66-2.69 3-6 3S4 6.66 4 5s2.69-3 6-3 6 1.34 6 3zm-1.31 3.02c.28-.14.55-.3.81-.49 0 .81-.7 1.44-1.41 1.82a3 3 0 00-.82 4.66A2.5 2.5 0 0011 16.5c0 .49.1.97.33 1.43-.43.04-.87.07-1.33.07-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const DatabasePersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabasePersonFilledIcon({}), 'DatabasePersonFilled');

const DatabasePersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22C6.98 2.28 8.43 2 10 2c1.57 0 3.02.29 4.1.78C15.12 3.24 16 3.99 16 5v4.04a3.02 3.02 0 00-1 0V6.7c-.27.2-.58.38-.9.52-1.08.5-2.53.78-4.1.78-1.57 0-3.02-.29-4.1-.78A4.92 4.92 0 015 6.7V15c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69.35 0 .7-.02 1.03-.05.05.34.15.67.3.98-.43.05-.87.07-1.33.07-1.57 0-3.02-.29-4.1-.78C4.88 16.76 4 16.01 4 15V5zm1 0c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69s2.77-.27 3.68-.69C14.64 5.88 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.19 9.19 0 0010 3c-1.46 0-2.77.27-3.68.69C5.36 4.12 5 4.63 5 5zm12.5 7a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const DatabasePersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabasePersonRegularIcon({}), 'DatabasePersonRegular');

const DatabasePlugConnectedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3zm4.69.02c.47-.24.93-.54 1.31-.9v2.99a2.97 2.97 0 00-1.87.86l-.6.6a1.98 1.98 0 00-.58 1.52 1.95 1.95 0 00-1.52.58l-.6.6a2.99 2.99 0 00-.77 2.9l-.76.75-.05.06C6.3 17.79 4 16.53 4 15V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98zm4.5 2.83a.5.5 0 10-.7-.7l-1.19 1.18a.64.64 0 00-.03.05 2 2 0 00-2.44.3l-.6.6a.98.98 0 000 1.4l1.45 1.43a.98.98 0 001.38 0l.6-.6a2 2 0 00.3-2.44.36.36 0 00.06-.03l1.18-1.19zm-5.66 3.53a.98.98 0 00-1.39 0l-.6.6a2 2 0 00-.3 2.43.42.42 0 00-.05.04L10 18.63a.5.5 0 00.7.7l1.19-1.18a.5.5 0 00.03-.05 2 2 0 002.44-.3l.6-.6a.98.98 0 000-1.39l-1.44-1.44z",
    fill: primaryFill
  }));
};

export const DatabasePlugConnectedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabasePlugConnectedFilledIcon({}), 'DatabasePlugConnectedFilled');

const DatabasePlugConnectedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22 1.3-.54 2.7-.8 4.1-.78 1.4-.03 2.8.24 4.1.78C15.13 3.24 16 3.99 16 5v5.1a2.97 2.97 0 00-1 .27V6.7c-.28.2-.58.38-.9.52-1.3.54-2.7.8-4.1.78-1.4.03-2.8-.24-4.1-.78A4.92 4.92 0 015 6.7V15c0 .37.36.87 1.32 1.31A9.2 9.2 0 0010 17h.02a3 3 0 00.04.16l-.76.77a1.5 1.5 0 00-.06.06 10.18 10.18 0 01-3.34-.77C4.87 16.75 4 16.01 4 15V5zm1 0c0 .37.36.87 1.32 1.31A9.2 9.2 0 0010 7a9.2 9.2 0 003.68-.69C14.64 5.87 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.2 9.2 0 0010 3a9.2 9.2 0 00-3.68.69C5.36 4.12 5 4.63 5 5zm14.2 5.85a.5.5 0 10-.7-.7l-1.2 1.18a.64.64 0 00-.03.05 2 2 0 00-2.44.3l-.6.6a.98.98 0 000 1.4l1.45 1.43a.98.98 0 001.38 0l.6-.6a2 2 0 00.3-2.44.36.36 0 00.06-.03l1.18-1.19zm-5.67 3.53a.98.98 0 00-1.39 0l-.6.6a2 2 0 00-.3 2.43.42.42 0 00-.05.04L10 18.63a.5.5 0 00.7.7l1.19-1.18a.5.5 0 00.03-.05 2 2 0 002.44-.3l.6-.6a.98.98 0 000-1.39l-1.44-1.44z",
    fill: primaryFill
  }));
};

export const DatabasePlugConnectedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabasePlugConnectedRegularIcon({}), 'DatabasePlugConnectedRegular');

const DatabaseSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3zm4.69.02c.47-.24.93-.54 1.31-.9v2.64a4.5 4.5 0 10-3.83 8.04c-.68.13-1.4.2-2.17.2-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98zM13.5 17c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 10.7-.7L16.3 15.6a3.5 3.5 0 10-2.8 1.4zm0-1a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const DatabaseSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseSearchFilledIcon({}), 'DatabaseSearchFilled');

const DatabaseSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22C6.98 2.28 8.43 2 10 2c1.57 0 3.02.29 4.1.78C15.12 3.24 16 3.99 16 5v4.76c-.3-.2-.64-.38-1-.5V6.7c-.27.2-.58.38-.9.52-1.08.5-2.53.78-4.1.78-1.57 0-3.02-.29-4.1-.78A4.92 4.92 0 015 6.7V15c0 .37.36.88 1.32 1.31a9.19 9.19 0 004.33.67c.45.37.97.65 1.53.82-.68.13-1.41.2-2.18.2-1.57 0-3.02-.29-4.1-.78C4.88 16.76 4 16.01 4 15V5zm1 0c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69s2.77-.27 3.68-.69C14.64 5.88 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.19 9.19 0 0010 3c-1.46 0-2.77.27-3.68.69C5.36 4.12 5 4.63 5 5zm8.5 12c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 10.7-.7L16.3 15.6a3.5 3.5 0 10-2.8 1.4zm0-1a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const DatabaseSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseSearchRegularIcon({}), 'DatabaseSearchRegular');

const DatabaseWarningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 5c0 1.66-2.69 3-6 3S4 6.66 4 5s2.69-3 6-3 6 1.34 6 3zm-1.31 3.02l.31-.17v.21c-.53.14-1 .48-1.29 1.05l-3.5 7c-.31.64-.25 1.34.06 1.89H10c-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98zm-.09 1.53l-3.5 7A1 1 0 0012 18h7a1 1 0 00.9-1.45l-3.5-7a1 1 0 00-1.8 0zM16 11.5v3a.5.5 0 11-1 0v-3a.5.5 0 111 0zm-.5 5.5a.5.5 0 110-1 .5.5 0 010 1z",
    fill: primaryFill
  }));
};

export const DatabaseWarningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseWarningFilledIcon({}), 'DatabaseWarningFilled');

const DatabaseWarningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22 1.3-.54 2.7-.8 4.1-.78 1.4-.03 2.8.24 4.1.78C15.13 3.24 16 3.99 16 5v3.06a2.05 2.05 0 00-1 0V6.7c-.28.2-.58.38-.9.52-1.3.54-2.7.8-4.1.78-1.4.03-2.8-.24-4.1-.78A4.92 4.92 0 015 6.7V15c0 .37.36.87 1.32 1.31A9.2 9.2 0 0010 17c0 .36.1.7.28 1H10c-1.4.03-2.8-.24-4.1-.78C4.87 16.75 4 16.01 4 15V5zm1 0c0 .37.36.87 1.32 1.31A9.2 9.2 0 0010 7a9.2 9.2 0 003.68-.69C14.64 5.87 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.2 9.2 0 0010 3a9.2 9.2 0 00-3.68.69C5.36 4.12 5 4.63 5 5zm9.6 4.55l-3.5 7A1 1 0 0012 18h7a1 1 0 00.9-1.45l-3.5-7a1 1 0 00-1.8 0zM16 11.5v3a.5.5 0 11-1 0v-3a.5.5 0 111 0zm-.5 5.5a.5.5 0 110-1 .5.5 0 010 1z",
    fill: primaryFill
  }));
};

export const DatabaseWarningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseWarningRegularIcon({}), 'DatabaseWarningRegular');

const DatabaseWindowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3zm4.69.02c.47-.24.93-.54 1.31-.9V9h-4.5A2.5 2.5 0 009 11.5v6c0 .16.01.31.04.46C6.18 17.73 4 16.5 4 15V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98zM10 11.5c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5v.5h-9v-.5zm0 1.5h9v4.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V13z",
    fill: primaryFill
  }));
};

export const DatabaseWindowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseWindowFilledIcon({}), 'DatabaseWindowFilled');

const DatabaseWindowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22C6.98 2.28 8.43 2 10 2c1.57 0 3.02.29 4.1.78C15.12 3.24 16 3.99 16 5v4h-1V6.7c-.27.2-.58.38-.9.52-1.08.5-2.53.78-4.1.78-1.57 0-3.02-.29-4.1-.78A4.92 4.92 0 015 6.7V15c0 .37.36.88 1.32 1.31.7.32 1.63.55 2.68.65v.54c0 .16.01.31.04.46a9.47 9.47 0 01-3.14-.74C4.88 16.76 4 16.01 4 15V5zm1 0c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69s2.77-.27 3.68-.69C14.64 5.88 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.19 9.19 0 0010 3c-1.46 0-2.77.27-3.68.69C5.36 4.12 5 4.63 5 5zm5 6.5c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5v.5h-9v-.5zm0 1.5h9v4.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V13z",
    fill: primaryFill
  }));
};

export const DatabaseWindowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseWindowRegularIcon({}), 'DatabaseWindowRegular');

const DecimalArrowLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3A2.5 2.5 0 006 5.5v4a2.5 2.5 0 005 0v-4A2.5 2.5 0 008.5 3zm-1 2.5a1 1 0 012 0v4a1 1 0 11-2 0v-4zM3 12a1 1 0 100-2 1 1 0 000 2zm12.5-9A2.5 2.5 0 0013 5.5v3.7c.48-.13.98-.2 1.5-.2V5.5a1 1 0 112 0v3.87c.51.2.98.48 1.4.81.07-.22.1-.44.1-.68v-4A2.5 2.5 0 0015.5 3zm-1 16a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.35-4.85a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const DecimalArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DecimalArrowLeftFilledIcon({}), 'DecimalArrowLeftFilled');

const DecimalArrowLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3A2.5 2.5 0 006 5.5v4a2.5 2.5 0 005 0v-4A2.5 2.5 0 008.5 3zM7 5.5a1.5 1.5 0 113 0v4a1.5 1.5 0 01-3 0v-4zM3 12a1 1 0 100-2 1 1 0 000 2zm12.5-9A2.5 2.5 0 0013 5.5v3.7c.32-.08.66-.15 1-.18V5.5a1.5 1.5 0 013 0v4.1c.32.16.62.36.9.58.07-.22.1-.44.1-.68v-4A2.5 2.5 0 0015.5 3zm-1 16a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.35-4.85a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const DecimalArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DecimalArrowLeftRegularIcon({}), 'DecimalArrowLeftRegular');

const DecimalArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3A2.5 2.5 0 006 5.5v4a2.5 2.5 0 005 0v-4A2.5 2.5 0 008.5 3zm-1 2.5a1 1 0 012 0v4a1 1 0 11-2 0v-4zM3 12a1 1 0 100-2 1 1 0 000 2zm12.5-9A2.5 2.5 0 0013 5.5v3.7c.48-.13.98-.2 1.5-.2V5.5a1 1 0 112 0v3.87c.51.2.98.48 1.4.81.07-.22.1-.44.1-.68v-4A2.5 2.5 0 0015.5 3zm-1 7a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const DecimalArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DecimalArrowRightFilledIcon({}), 'DecimalArrowRightFilled');

const DecimalArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3A2.5 2.5 0 006 5.5v4a2.5 2.5 0 005 0v-4A2.5 2.5 0 008.5 3zM7 5.5a1.5 1.5 0 113 0v4a1.5 1.5 0 01-3 0v-4zM3 12a1 1 0 100-2 1 1 0 000 2zm12.5-9A2.5 2.5 0 0013 5.5v3.7c.32-.08.66-.15 1-.18V5.5a1.5 1.5 0 013 0v4.1c.32.16.62.36.9.58.07-.22.1-.44.1-.68v-4A2.5 2.5 0 0015.5 3zm-1 7a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const DecimalArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DecimalArrowRightRegularIcon({}), 'DecimalArrowRightRegular');

const DeleteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 1.25c1.43 0 2.61 1.1 2.74 2.5H17a.75.75 0 01.1 1.5H16.42l-1.27 10.98A2 2 0 0113.16 18H6.84a2 2 0 01-1.99-1.77L3.58 5.25H3a.75.75 0 01-.74-.65l-.01-.1c0-.38.28-.7.65-.74l.1-.01h4.26c.13-1.4 1.3-2.5 2.74-2.5zM8.5 7.5c-.25 0-.45.15-.5.36v6.28c.05.2.25.36.5.36s.45-.15.5-.36V7.86c-.05-.2-.25-.36-.5-.36zm3 0c-.25 0-.45.15-.5.36v6.28c.05.2.25.36.5.36s.45-.15.5-.36V7.86c-.05-.2-.25-.36-.5-.36zM10 2.75c-.6 0-1.1.43-1.23 1h2.46c-.12-.57-.63-1-1.23-1z",
    fill: primaryFill
  }));
};

export const DeleteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteFilledIcon({}), 'DeleteFilled');

const DeleteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.5 4a1.5 1.5 0 00-3 0h-1a2.5 2.5 0 015 0H17a.5.5 0 010 1h-.55l-1.3 11.23A2 2 0 0113.16 18H6.84a2 2 0 01-1.99-1.77L3.55 5H3a.5.5 0 01-.5-.41V4.5c0-.28.22-.5.5-.5h8.5zm3.94 1H4.56l1.28 11.11a1 1 0 001 .89h6.32a1 1 0 001-.89L15.44 5zM8.5 7.5c.25 0 .45.15.5.36v6.2c0 .24-.22.44-.5.44-.25 0-.45-.15-.5-.36v-6.2c0-.24.22-.44.5-.44zm3 0c.25 0 .45.15.5.36v6.2c0 .24-.22.44-.5.44-.25 0-.45-.15-.5-.36v-6.2c0-.24.22-.44.5-.44z",
    fill: primaryFill
  }));
};

export const DeleteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteRegularIcon({}), 'DeleteRegular');

const DeleteArrowBackFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 1.25c1.43 0 2.61 1.1 2.74 2.5H17a.75.75 0 01.1 1.5H16.42l-.46 3.95a5.5 5.5 0 00-5.7 8.8H6.84a2 2 0 01-1.99-1.77L3.58 5.25H3a.75.75 0 01-.74-.65l-.01-.1c0-.38.28-.7.65-.74l.1-.01h4.26c.13-1.4 1.3-2.5 2.74-2.5zm0 1.5c-.6 0-1.1.43-1.23 1h2.46c-.12-.57-.63-1-1.23-1zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0117 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const DeleteArrowBackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteArrowBackFilledIcon({}), 'DeleteArrowBackFilled');

const DeleteArrowBackRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.5 4a1.5 1.5 0 00-3 0h3zm-4 0a2.5 2.5 0 015 0H17a.5.5 0 010 1h-.55l-.49 4.2a5.48 5.48 0 00-.99-.18L15.44 5H4.56l1.28 11.11a1 1 0 001 .89H9.6c.18.36.4.7.66 1H6.84a2 2 0 01-1.99-1.77L3.55 5H3a.5.5 0 01-.5-.41V4.5c0-.28.22-.5.5-.5h4.5zm7 15a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0117 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const DeleteArrowBackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteArrowBackRegularIcon({}), 'DeleteArrowBackRegular');

const DeleteDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 1.25c1.43 0 2.61 1.1 2.74 2.5H17a.75.75 0 01.1 1.5H16.42l-.46 3.95a5.5 5.5 0 00-5.7 8.8H6.84a2 2 0 01-1.99-1.77L3.58 5.25H3a.75.75 0 01-.74-.65l-.01-.1c0-.38.28-.7.65-.74l.1-.01h4.26c.13-1.4 1.3-2.5 2.74-2.5zm0 1.5c-.6 0-1.1.43-1.23 1h2.46c-.12-.57-.63-1-1.23-1zm9 11.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const DeleteDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteDismissFilledIcon({}), 'DeleteDismissFilled');

const DeleteDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.5 4a1.5 1.5 0 00-3 0h3zm-4 0a2.5 2.5 0 015 0H17a.5.5 0 010 1h-.55l-.49 4.2a5.48 5.48 0 00-.99-.18L15.44 5H4.56l1.28 11.11a1 1 0 001 .89H9.6c.18.36.4.7.66 1H6.84a2 2 0 01-1.99-1.77L3.55 5H3a.5.5 0 01-.5-.41V4.5c0-.28.22-.5.5-.5h4.5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const DeleteDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteDismissRegularIcon({}), 'DeleteDismissRegular');

const DeleteLinesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 1.25c1.43 0 2.61 1.1 2.74 2.5H17a.75.75 0 01.1 1.5H16.42l-.9 7.75H13.5a1.5 1.5 0 00-1.12 2.5 1.5 1.5 0 000 2 1.5 1.5 0 00-.3.5H6.85a2 2 0 01-1.99-1.77L3.58 5.25H3a.75.75 0 01-.74-.65l-.01-.1c0-.38.28-.7.65-.74l.1-.01h4.26c.13-1.4 1.3-2.5 2.74-2.5zm0 1.5c-.6 0-1.1.43-1.23 1h2.46c-.12-.57-.63-1-1.23-1zm3 11.75c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 2c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 2c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DeleteLinesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteLinesFilledIcon({}), 'DeleteLinesFilled');

const DeleteLinesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 4a2.5 2.5 0 015 0H17a.5.5 0 010 1h-.55l-.93 8h-1l.92-8H4.56l1.28 11.11a1 1 0 001 .89h5.25c.06.19.16.36.3.5a1.5 1.5 0 00-.3.5H6.84a2 2 0 01-1.99-1.77L3.55 5H3a.5.5 0 01-.5-.41V4.5c0-.28.22-.5.5-.5h4.5zm4 0a1.5 1.5 0 00-3 0h3zm2 12a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0-2a.5.5 0 000 1h5a.5.5 0 000-1h-5zm-.5 4.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DeleteLinesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteLinesRegularIcon({}), 'DeleteLinesRegular');

const DeleteOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.19 15.9l-.04.33A2 2 0 0113.16 18H6.84a2 2 0 01-1.99-1.77L3.58 5.25H3a.75.75 0 01-.74-.65l-.01-.1c0-.38.28-.7.65-.74l.1-.01h.04l-.9-.9a.5.5 0 11.71-.7l5.41 5.4 9.6 9.6a.5.5 0 01-.71.7l-1.96-1.95zM8 8.7v5.44c.05.2.25.36.5.36s.45-.15.5-.36V9.71l-1-1zm3 3v2.44c.05.2.25.36.5.36s.45-.15.5-.36V12.71l-1-1zm0-2.82L5.87 3.75h1.4a2.75 2.75 0 015.47 0H17a.75.75 0 01.1 1.5H16.42l-.94 8.11L12 9.88V7.86c-.05-.2-.25-.36-.5-.36s-.45.15-.5.36v1.02zm-1-6.13c-.6 0-1.1.43-1.23 1h2.46c-.12-.57-.63-1-1.23-1z",
    fill: primaryFill
  }));
};

export const DeleteOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteOffFilledIcon({}), 'DeleteOffFilled');

const DeleteOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4h.3L2.14 2.85a.5.5 0 11.7-.7l5.41 5.4 9.6 9.6a.5.5 0 01-.71.7l-1.96-1.95-.04.33A2 2 0 0113.16 18H6.84a2 2 0 01-1.99-1.77L3.55 5H3a.5.5 0 01-.5-.41V4.5c0-.28.22-.5.5-.5zm11.29 11L12 12.7v1.36c0 .24-.22.44-.5.44-.25 0-.45-.15-.5-.36v-2.43l-2-2v4.35c0 .24-.22.44-.5.44-.25 0-.45-.15-.5-.36V8.71L4.6 5.3l1.24 10.8a1 1 0 001 .89h6.32a1 1 0 001-.89l.13-1.12zm1.2-1.64l-.91-.9.86-7.46H7.12l-1-1H7.5a2.5 2.5 0 015 0H17a.5.5 0 010 1h-.55l-.97 8.36zM11.5 4a1.5 1.5 0 00-3 0h3zm.5 5.88l-1-1v-.94c0-.24.22-.44.5-.44.25 0 .45.15.5.36v2.02z",
    fill: primaryFill
  }));
};

export const DeleteOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteOffRegularIcon({}), 'DeleteOffRegular');

const DentistFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.94 3.93a3.46 3.46 0 00-2.9-.74c-.92.18-1.73.69-2.26 1.27a4.1 4.1 0 00-1.24 2.7c-.03.6.06 1.47.53 2.13a5 5 0 011.12 3.15c0 .65.14 1.53.46 2.34.32.8.87 1.6 1.77 1.94h.02l.03.01c.52.14 1 .1 1.38-.25.32-.3.46-.76.53-1.16.07-.38.1-.82.14-1.25l.01-.15a12 12 0 01.19-1.44c.26-1.27.64-1.5.82-1.55.49-.13.78-.04.97.1.28.2.49.61.64 1.22.14.6.2 1.27.25 1.88.07.87.25 1.65.6 2.16.18.26.44.49.79.56.35.08.69-.03.99-.22 1.1-.7 1.74-2.17 1.91-4.1.08-.88.17-1.3.3-1.64.1-.25.22-.46.42-.8a37.6 37.6 0 00.36-.63c.25-.43.65-1.23.7-2.16a3.48 3.48 0 00-1.44-2.96 4.4 4.4 0 00-3.01-1.16c-.9.05-1.62.46-2.13.9h-.01l-.01.02c-.5.49-.73.58-.88.57-.17 0-.45-.14-1-.7l-.03-.02-.02-.02zm4 1.67c.48 0 .98.15 1.38.5.4.35.64.87.7 1.52a.5.5 0 01-1 .1c-.03-.45-.19-.72-.37-.88a1.06 1.06 0 00-.71-.24.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const DentistFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DentistFilledIcon({}), 'DentistFilled');

const DentistRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.94 5.6a.5.5 0 000 1c.29 0 .53.08.71.24.18.16.34.43.38.87a.5.5 0 101-.09 2.25 2.25 0 00-.71-1.52c-.4-.35-.9-.5-1.38-.5zm-4-1.67a3.46 3.46 0 00-2.9-.74c-.92.18-1.73.69-2.26 1.27a4.1 4.1 0 00-1.24 2.7c-.03.6.06 1.47.53 2.13a5 5 0 011.12 3.15c0 .65.14 1.53.46 2.34.32.8.87 1.6 1.77 1.94h.02l.03.01c.52.14 1 .1 1.38-.25.32-.3.46-.76.53-1.16.07-.38.1-.82.14-1.25l.01-.15a12 12 0 01.19-1.44c.26-1.27.64-1.5.82-1.55.49-.13.78-.04.97.1.28.2.49.61.64 1.22.14.6.2 1.27.25 1.88.07.87.25 1.65.6 2.16.18.26.44.49.79.56.35.08.69-.03.99-.22 1.1-.7 1.74-2.17 1.91-4.1.08-.88.17-1.3.3-1.64.1-.25.22-.46.42-.8a37.6 37.6 0 00.36-.63c.25-.43.65-1.23.7-2.16a3.48 3.48 0 00-1.44-2.96 4.4 4.4 0 00-3.01-1.16c-.9.05-1.62.46-2.13.9h-.01l-.01.02c-.5.49-.73.58-.88.57-.17 0-.45-.14-1-.7l-.03-.02-.02-.02zm-4.43 1.2c.4-.43 1.03-.82 1.72-.96a2.45 2.45 0 012.06.52c.54.54 1.06.96 1.65.98.62.03 1.13-.37 1.61-.84.4-.34.91-.62 1.52-.65.61-.03 1.39.17 2.33.94.89.72 1.1 1.48 1.06 2.13-.03.7-.33 1.32-.56 1.72a20.02 20.02 0 01-.32.56c-.21.36-.39.66-.52 1-.18.47-.28 1-.36 1.9-.17 1.82-.75 2.9-1.46 3.36-.16.1-.23.09-.25.08-.01 0-.08-.02-.17-.15-.2-.28-.36-.85-.43-1.67v-.02c-.05-.6-.1-1.34-.27-2.01-.16-.67-.44-1.38-1.02-1.8-.49-.35-1.1-.44-1.82-.26h-.01c-.73.22-1.24.92-1.53 2.32-.11.52-.16 1.07-.2 1.56l-.01.15c-.04.44-.07.82-.13 1.14-.07.37-.16.55-.24.62-.03.03-.11.1-.41.02-.5-.2-.9-.7-1.17-1.37a5.7 5.7 0 01-.4-1.97 5.98 5.98 0 00-1.3-3.72 2.6 2.6 0 01-.34-1.51c.03-.87.44-1.48.97-2.06z",
    fill: primaryFill
  }));
};

export const DentistRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DentistRegularIcon({}), 'DentistRegular');

const DesignIdeasFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 4.5c-.75 0-1.44.24-2.01.64a3.59 3.59 0 00-.41-1.52A5 5 0 0114 8h2.25c.97 0 1.75.78 1.75 1.75v5.5c0 .97-.78 1.75-1.75 1.75h-5.5C9.78 17 9 16.22 9 15.25V13c-.72 0-1.4-.15-2.02-.42L7 11.5v-.06-.57c.56.4 1.26.63 2 .63V9.75C9 8.78 9.78 8 10.75 8h1.75A3.5 3.5 0 009 4.5zm4.77 5a5.01 5.01 0 01-3.27 3.27v2.48c0 .14.11.25.25.25h5.5c.14 0 .25-.11.25-.25v-5.5a.25.25 0 00-.25-.25h-2.48zm-1.6 0h-1.42a.25.25 0 00-.25.25v1.41a3.51 3.51 0 001.66-1.66zM4.57 2.13a.5.5 0 01.12.6l-.01.08c0 .07.01.19.16.34l.2.18.16.16c.13.12.27.27.4.45.25.38.39.86.39 1.56 0 .85-.32 1.58-.8 2.03l.05.07c.29.34.45.79.55 1.23.2.87.2 1.92.2 2.64v.03c0 2.79-.38 4.37-.8 5.27-.2.46-.43.75-.62.93a1.48 1.48 0 01-.4.26S4.09 18 4 18c-.07 0-.19-.04-.19-.04a.75.75 0 01-.13-.06c-.07-.05-.16-.1-.26-.2-.2-.18-.41-.47-.62-.93-.42-.9-.8-2.48-.8-5.27v-.03c0-.72 0-1.77.2-2.64a3.02 3.02 0 01.6-1.3C2.33 7.08 2 6.35 2 5.5a4.73 4.73 0 01.69-2.1A4.07 4.07 0 013.93 2.1l.04-.03a.5.5 0 01.61.05z",
    fill: primaryFill
  }));
};

export const DesignIdeasFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesignIdeasFilledIcon({}), 'DesignIdeasFilled');

const DesignIdeasRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 4c-.76 0-1.48.21-2.08.58a3.3 3.3 0 00-.34-.96A5 5 0 0114 8h2.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 019 15.5V13c-.72 0-1.4-.15-2.02-.42L7 11.5v-.04c.59.35 1.27.54 2 .54V9.5c0-.83.67-1.5 1.5-1.5H13a4 4 0 00-4-4zm4.9 5a5 5 0 01-3.9 3.9v2.6c0 .28.22.5.5.5h6a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5h-2.6zm-1.03 0H10.5a.5.5 0 00-.5.5v2.37A4 4 0 0012.87 9zM4.58 2.13a.5.5 0 01.12.6l-.01.08c0 .07.01.19.16.34l.2.18.16.16c.13.12.27.27.4.45.25.38.39.86.39 1.56 0 .85-.32 1.58-.8 2.03l.05.07c.29.34.45.79.55 1.23.2.87.2 1.92.2 2.64v.03c0 2.79-.38 4.37-.8 5.27-.2.46-.43.75-.62.93a1.48 1.48 0 01-.4.26S4.09 18 4 18c-.07 0-.19-.04-.19-.04a.75.75 0 01-.13-.06c-.07-.05-.16-.1-.26-.2-.2-.18-.41-.47-.62-.93-.42-.9-.8-2.48-.8-5.27v-.03c0-.72 0-1.77.2-2.64a3.02 3.02 0 01.6-1.3C2.33 7.08 2 6.35 2 5.5a4.73 4.73 0 01.69-2.1A4.07 4.07 0 013.93 2.1l.03-.02h.01a.5.5 0 01.61.04zM4 7c.39 0 1-.43 1-1.5 0-.55-.1-.82-.23-1-.06-.1-.14-.2-.25-.3l-.12-.1-.25-.25a1.67 1.67 0 01-.28-.36 2.5 2.5 0 00-.34.44A3.73 3.73 0 003 5.5C3 6.57 3.62 7 4 7zm-.48 1.23c-.14.18-.26.45-.35.82C3 9.8 3 10.75 3 11.5c0 2.71.37 4.13.7 4.85.11.24.22.4.3.5.08-.1.19-.26.3-.5.33-.72.7-2.14.7-4.85 0-.76 0-1.7-.17-2.45-.1-.37-.2-.64-.35-.82A.57.57 0 004 8a.57.57 0 00-.48.23z",
    fill: primaryFill
  }));
};

export const DesignIdeasRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesignIdeasRegularIcon({}), 'DesignIdeasRegular');

const DesktopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 2C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 000 1h9a.5.5 0 000-1H13v-2h3.5c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5h-13zM12 15v2H8v-2h4z",
    fill: primaryFill
  }));
};

export const DesktopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopFilledIcon({}), 'DesktopFilled');

const DesktopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 2a2 2 0 00-2 2v9c0 1.1.9 2 2 2h3v2H5.5a.5.5 0 000 1h9a.5.5 0 000-1H13v-2h3a2 2 0 002-2V4a2 2 0 00-2-2H4zm8 13v2H8v-2h4zM3 4a1 1 0 011-1h12a1 1 0 011 1v9a1 1 0 01-1 1H4a1 1 0 01-1-1V4z",
    fill: primaryFill
  }));
};

export const DesktopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopRegularIcon({}), 'DesktopRegular');

const DesktopArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35A.5.5 0 0017 5.5a.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 5H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2zM14.5 11c1.33 0 2.55-.47 3.5-1.26v3.76c0 .83-.67 1.5-1.5 1.5H13v2h1.5a.5.5 0 010 1h-9a.5.5 0 010-1H7v-2H3.5A1.5 1.5 0 012 13.5v-10C2 2.67 2.67 2 3.5 2h6.76a5.5 5.5 0 004.24 9zM12 17v-2H8v2h4z",
    fill: primaryFill
  }));
};

export const DesktopArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopArrowRightFilledIcon({}), 'DesktopArrowRightFilled');

const DesktopArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35A.5.5 0 0017 5.5a.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 5H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2zM17 13v-2.6c.36-.18.7-.4 1-.66V13a2 2 0 01-2 2h-3v2h1.5a.5.5 0 010 1h-9a.5.5 0 010-1H7v-2H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2h6.26c-.26.3-.48.64-.66 1H4a1 1 0 00-1 1v9a1 1 0 001 1h12a1 1 0 001-1zm-5 4v-2H8v2h4z",
    fill: primaryFill
  }));
};

export const DesktopArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopArrowRightRegularIcon({}), 'DesktopArrowRightRegular');

const DesktopCursorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 2C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 000 1H11v-1H8v-2h3v-4.5a1.5 1.5 0 012.56-1.07l4.4 4.37c.03-.1.04-.2.04-.3v-10c0-.83-.67-1.5-1.5-1.5h-13zm9.36 8.14a.5.5 0 00-.86.36v8a.5.5 0 00.9.3l2-2.65 3.5.78a.5.5 0 00.45-.84l-6-5.95z",
    fill: primaryFill
  }));
};

export const DesktopCursorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopCursorFilledIcon({}), 'DesktopCursorFilled');

const DesktopCursorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 2a2 2 0 00-2 2v9c0 1.1.9 2 2 2h3v2H5.5a.5.5 0 000 1H11v-1H8v-2h3v-1H4a1 1 0 01-1-1V4a1 1 0 011-1h12a1 1 0 011 1v8.84l.87.87A2 2 0 0018 13V4a2 2 0 00-2-2H4zm8.86 8.15a.5.5 0 00-.86.35v8a.5.5 0 00.9.3l2-2.65 3.5.78a.5.5 0 00.45-.84l-6-5.94z",
    fill: primaryFill
  }));
};

export const DesktopCursorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopCursorRegularIcon({}), 'DesktopCursorRegular');

const DesktopEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.98 6.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02zm-.7-.71L13.93 2H3.5C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 000 1h9a.5.5 0 000-1H13v-2h3.5c.83 0 1.5-.67 1.5-1.5V6.06l-3.67 3.67c-.4.4-.92.7-1.48.84l-1.5.37a1.89 1.89 0 01-2.3-2.29l.38-1.5a3.2 3.2 0 01.84-1.48zM12 15v2H8v-2h4z",
    fill: primaryFill
  }));
};

export const DesktopEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopEditFilledIcon({}), 'DesktopEditFilled');

const DesktopEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.98 6.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02zM17 13V7.06l1-1V13a2 2 0 01-2 2h-3v2h1.5a.5.5 0 010 1h-9a.5.5 0 010-1H7v-2H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2h9.94l-1 1H4a1 1 0 00-1 1v9a1 1 0 001 1h12a1 1 0 001-1zm-5 2H8v2h4v-2z",
    fill: primaryFill
  }));
};

export const DesktopEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopEditRegularIcon({}), 'DesktopEditRegular');

const DesktopFlowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 2.5c0-.18.03-.34.09-.5H3.5C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 000 1h9a.5.5 0 000-1H13v-2h3.5c.83 0 1.5-.67 1.5-1.5V7h-2.5a1.5 1.5 0 01-1.1-.47l-.25.76A2.5 2.5 0 0112 9v.51c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 016 9.5v-3C6 5.67 6.67 5 7.5 5h3c.43 0 .82.18 1.1.47l.25-.76A2.5 2.5 0 0114 3V2.5zM12 15v2H8v-2h4zm3.5-13a.5.5 0 00-.5.5V4h-.78a1.5 1.5 0 00-1.42 1.03l-.55 1.63a.5.5 0 01-.47.34H11v-.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5V8h.78a1.5 1.5 0 001.42-1.03l.55-1.63a.5.5 0 01.47-.34H15v.5c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3z",
    fill: primaryFill
  }));
};

export const DesktopFlowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopFlowFilledIcon({}), 'DesktopFlowFilled');

const DesktopFlowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.09 2H4a2 2 0 00-2 2v9c0 1.1.9 2 2 2h3v2H5.5a.5.5 0 000 1h9a.5.5 0 000-1H13v-2h3a2 2 0 002-2V7h-1v6a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h10v-.5c0-.18.03-.34.09-.5zM12 17H8v-2h4v2zm3-14.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5V5h-.78a.5.5 0 00-.47.34l-.55 1.63A1.5 1.5 0 0111.78 8H11v1.5a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V7h.78a.5.5 0 00.47-.34l.55-1.63A1.5 1.5 0 0114.22 4H15V2.5zM10 7H8v2h2V7zm6-2h2V3h-2v2z",
    fill: primaryFill
  }));
};

export const DesktopFlowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopFlowRegularIcon({}), 'DesktopFlowRegular');

const DesktopKeyboardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h12a2 2 0 012 2v7.1a2.75 2.75 0 00-.75-.1h-5.5A2.75 2.75 0 009 13.75v3.5c0 .26.04.51.1.75H6.5a.5.5 0 010-1H8v-2H4a2 2 0 01-2-2V4zm9.75 8c-.97 0-1.75.78-1.75 1.75v3.5c0 .97.78 1.75 1.75 1.75h5.5c.97 0 1.75-.78 1.75-1.75v-3.5c0-.97-.78-1.75-1.75-1.75h-5.5zm.25 5.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm.5-3.5a.5.5 0 110-1 .5.5 0 010 1zm1.5 1.5a.5.5 0 11-1 0 .5.5 0 011 0zm.5-1.5a.5.5 0 110-1 .5.5 0 010 1zm1.5 1.5a.5.5 0 11-1 0 .5.5 0 011 0zm.5-1.5a.5.5 0 110-1 .5.5 0 010 1z",
    fill: primaryFill
  }));
};

export const DesktopKeyboardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopKeyboardFilledIcon({}), 'DesktopKeyboardFilled');

const DesktopKeyboardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h12a2 2 0 012 2v7.1c-.24-.06-.49-.1-.75-.1H17V4a1 1 0 00-1-1H4a1 1 0 00-1 1v9a1 1 0 001 1h5v3.25c0 .26.04.51.1.75H6.5a.5.5 0 010-1H8v-2H4a2 2 0 01-2-2V4zm9.75 8h5.5c.97 0 1.75.78 1.75 1.75v3.5c0 .97-.78 1.75-1.75 1.75h-5.5c-.97 0-1.75-.78-1.75-1.75v-3.5c0-.97.78-1.75 1.75-1.75zm.25 5.5c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5zm.5-3.5a.5.5 0 100-1 .5.5 0 000 1zm1.5 1.5a.5.5 0 10-1 0 .5.5 0 001 0zm.5-1.5a.5.5 0 100-1 .5.5 0 000 1zm1.5 1.5a.5.5 0 10-1 0 .5.5 0 001 0zm.5-1.5a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const DesktopKeyboardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopKeyboardRegularIcon({}), 'DesktopKeyboardRegular');

const DesktopMacFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 2a2 2 0 00-2 2v9c0 1.1.9 2 2 2h4v1a1 1 0 01-1 1h-.5a.5.5 0 000 1h7a.5.5 0 000-1H13a1 1 0 01-1-1v-1h4a2 2 0 002-2V4a2 2 0 00-2-2H4zM3 13v-1h14v1a1 1 0 01-1 1H4a1 1 0 01-1-1zm5.73 4A2 2 0 009 16v-1h2v1c0 .36.1.7.27 1H8.73z",
    fill: primaryFill
  }));
};

export const DesktopMacFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopMacFilledIcon({}), 'DesktopMacFilled');

const DesktopMacRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h12a2 2 0 012 2v9a2 2 0 01-2 2h-4v1a1 1 0 001 1h.5a.5.5 0 010 1h-7a.5.5 0 010-1H7a1 1 0 001-1v-1H4a2 2 0 01-2-2V4zm1 8v1a1 1 0 001 1h12a1 1 0 001-1v-1H3zm14-1V4a1 1 0 00-1-1H4a1 1 0 00-1 1v7h14zm-5.73 6a2 2 0 01-.27-1v-1H9v1a2 2 0 01-.27 1h2.54z",
    fill: primaryFill
  }));
};

export const DesktopMacRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopMacRegularIcon({}), 'DesktopMacRegular');

const DesktopPulseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h12a2 2 0 012 2v4h-2.57l-1.09-2.17a1.5 1.5 0 00-2.68 0L10.32 8.5 8.93 4.05a1.5 1.5 0 00-2.82-.1L4.49 8H2V4zm12.5 7H18v2a2 2 0 01-2 2h-3v2h1.5a.5.5 0 010 1h-9a.5.5 0 010-1H7v-2H4a2 2 0 01-2-2v-2h3.5a1.5 1.5 0 001.4-.94l.43-1.09 1.24 3.98a1.5 1.5 0 002.77.22L13 9.85l.16.32c.25.5.77.83 1.34.83zM12 17v-2H8v2h4zM7.98 4.35a.5.5 0 00-.94-.04L5.16 9H2.5a.5.5 0 000 1h3a.5.5 0 00.47-.31l1.47-3.7 2.08 6.66a.5.5 0 00.93.07L13 7.62l1.05 2.1a.5.5 0 00.45.28h3a.5.5 0 000-1h-2.7l-1.35-2.72a.5.5 0 00-.9 0l-2.44 4.89-2.13-6.82z",
    fill: primaryFill
  }));
};

export const DesktopPulseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopPulseFilledIcon({}), 'DesktopPulseFilled');

const DesktopPulseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 2a2 2 0 00-2 2v4h1V4a1 1 0 011-1h12a1 1 0 011 1v4h1V4a2 2 0 00-2-2H4zM2 13v-2h1v2a1 1 0 001 1h12a1 1 0 001-1v-2h1v2a2 2 0 01-2 2h-3v2h1.5a.5.5 0 010 1h-9a.5.5 0 010-1H7v-2H4a2 2 0 01-2-2zm10 2H8v2h4v-2zM7.98 4.35a.5.5 0 00-.94-.04L5.16 9H2.5a.5.5 0 000 1h3a.5.5 0 00.46-.31l1.48-3.7 2.08 6.66a.5.5 0 00.93.07L13 7.62l1.05 2.1a.5.5 0 00.45.28h3a.5.5 0 100-1h-2.7l-1.35-2.72a.5.5 0 00-.9 0l-2.44 4.89-2.13-6.82z",
    fill: primaryFill
  }));
};

export const DesktopPulseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopPulseRegularIcon({}), 'DesktopPulseRegular');

const DesktopSignalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 1c-.18 0-.36 0-.54.02a.5.5 0 10.08 1L12 2a6 6 0 015.98 6.46.5.5 0 101 .08L19 8a7 7 0 00-7-7zm0 2c-.19 0-.37.01-.55.03a.5.5 0 00.1 1L12 4a4 4 0 013.98 4.45.5.5 0 10.99.1A5 5 0 0012 3zm0 2c-.2 0-.4.02-.6.06a.5.5 0 00.2.98A2.01 2.01 0 0114 8c0 .14-.01.27-.04.4a.5.5 0 00.98.2A3.01 3.01 0 0012 5zm-1.92-3H3.5C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 100 1h9a.5.5 0 000-1H13v-2h3.5c.83 0 1.5-.67 1.5-1.5V9.92a1.5 1.5 0 01-.52-.3 1.5 1.5 0 01-2.02-.01 1.5 1.5 0 01-2.13-.11 2 2 0 01-2.82-2.82 1.5 1.5 0 01-.12-2.14 1.5 1.5 0 010-2.02 1.5 1.5 0 01-.31-.52zM12 15v2H8v-2h4zm1-7a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const DesktopSignalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSignalFilledIcon({}), 'DesktopSignalFilled');

const DesktopSignalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 1c-.18 0-.36 0-.54.02a.5.5 0 10.08 1L12 2a6 6 0 015.98 6.46.5.5 0 101 .08L19 8a7 7 0 00-7-7zm0 2c-.19 0-.37.01-.55.03a.5.5 0 00.1 1L12 4a4 4 0 013.98 4.45.5.5 0 10.99.1A5 5 0 0012 3zm0 2c-.2 0-.4.02-.6.06a.5.5 0 00.2.98A2.01 2.01 0 0114 8c0 .14-.01.27-.04.4a.5.5 0 00.98.2A3.01 3.01 0 0012 5zm-1.92-3H4a2 2 0 00-2 2v9c0 1.1.9 2 2 2h3v2H5.5a.5.5 0 100 1h9a.5.5 0 000-1H13v-2h3a2 2 0 002-2V9.92a1.5 1.5 0 01-.52-.3c-.14.12-.3.22-.48.28V13a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h6.1c.06-.18.16-.34.29-.48a1.5 1.5 0 01-.31-.52zM12 15v2H8v-2h4zm1-7a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const DesktopSignalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSignalRegularIcon({}), 'DesktopSignalRegular');

const DesktopSpeakerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 2C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 000 1h6.38l-1-1H8v-2h1v-1.5c0-.83.67-1.5 1.5-1.5h.38l1.56-1.56a1.5 1.5 0 012.5.67c.3-.12.6-.14.88-.07A1.5 1.5 0 0118 10.2V3.5c0-.83-.67-1.5-1.5-1.5h-13zm10.2 9.04c.18.08.3.26.3.46v6a.5.5 0 01-.85.35L11.29 16h-.79a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 01.54-.11zm3.95.16c.12.16.29.45.44.87.26.68.41 1.5.41 2.43 0 .94-.15 1.75-.4 2.43-.16.42-.33.7-.45.87a.5.5 0 01-.85-.52l.12-.19a5.9 5.9 0 00.58-2.6 5.9 5.9 0 00-.58-2.58l-.07-.11a.5.5 0 01.8-.6zm-1.43 1.77c-.1-.3-.2-.55-.27-.7a.5.5 0 10-.9.45 4.6 4.6 0 01.45 1.78 3.94 3.94 0 01-.37 1.6l-.08.18a.5.5 0 10.9.44 5.5 5.5 0 00.55-2.22c0-.5-.1-1.02-.28-1.53z",
    fill: primaryFill
  }));
};

export const DesktopSpeakerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSpeakerFilledIcon({}), 'DesktopSpeakerFilled');

const DesktopSpeakerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 2a2 2 0 00-2 2v9c0 1.1.9 2 2 2h3v2H5.5a.5.5 0 000 1h6.38l-1-1H8v-2h1v-1H4a1 1 0 01-1-1V4a1 1 0 011-1h12a1 1 0 011 1v6.02c.34-.06.7 0 1 .18V4a2 2 0 00-2-2H4zm9.7 9.04c.18.08.3.26.3.46v6a.5.5 0 01-.85.35L11.29 16h-.79a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 01.54-.11zm3.95.16c.12.16.29.45.44.87.26.68.41 1.5.41 2.43 0 .94-.15 1.75-.4 2.43-.16.42-.33.7-.45.87a.5.5 0 01-.85-.52l.12-.19a5.9 5.9 0 00.58-2.6 5.9 5.9 0 00-.58-2.58l-.07-.11a.5.5 0 01.8-.6zm-1.43 1.77c-.1-.3-.2-.55-.27-.7a.5.5 0 10-.9.45 4.6 4.6 0 01.45 1.78 3.94 3.94 0 01-.37 1.6l-.08.18a.5.5 0 10.9.44 5.5 5.5 0 00.55-2.22c0-.5-.1-1.02-.28-1.53z",
    fill: primaryFill
  }));
};

export const DesktopSpeakerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSpeakerRegularIcon({}), 'DesktopSpeakerRegular');

const DesktopSpeakerOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.15 2.85a.5.5 0 01.7-.7l15 15a.5.5 0 01-.7.7L14 14.71v2.79a.5.5 0 01-.85.35L11.29 16h-.79a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5h.8l.5-.5-.71-.7-.21.2h-.38c-.83 0-1.5.67-1.5 1.5V15H8v2h2.88l1 1H5.5a.5.5 0 010-1H7v-2H3.5A1.5 1.5 0 012 13.5v-10c0-.23.05-.45.15-.65zM18.5 14.5a7.4 7.4 0 01-.19 1.7l-.86-.87a6.95 6.95 0 00-.3-2.9c-.08-.24-.17-.41-.23-.52l-.07-.11a.5.5 0 01.8-.6c.12.16.29.45.44.87.26.68.41 1.5.41 2.43zm-2.28-1.53c.16.47.26.95.28 1.4l-1.3-1.29a3.95 3.95 0 00-.15-.36.5.5 0 11.9-.44c.07.14.17.38.27.69zm-2.15-2.86a1.5 1.5 0 00-1.57.27L4.12 2H16.5c.83 0 1.5.67 1.5 1.5v6.7a1.5 1.5 0 00-2.18.84 1.5 1.5 0 00-.87.07 1.5 1.5 0 00-.88-1z",
    fill: primaryFill
  }));
};

export const DesktopSpeakerOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSpeakerOffFilledIcon({}), 'DesktopSpeakerOffFilled');

const DesktopSpeakerOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4a2 2 0 01.28-1.02l-.13-.13a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7L14 14.71v2.79a.5.5 0 01-.85.35L11.29 16h-.79a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5h.8l.5-.5-8.77-8.76A1 1 0 003 4v9a1 1 0 001 1h5v1H8v2h2.88l1 1H5.5a.5.5 0 010-1H7v-2H4a2 2 0 01-2-2V4zm16.5 10.5a7.4 7.4 0 01-.19 1.7l-.86-.87a6.95 6.95 0 00-.3-2.9c-.08-.24-.17-.41-.23-.52l-.07-.11a.5.5 0 01.8-.6c.12.16.29.45.44.87.26.68.41 1.5.41 2.43zm-2.28-1.53c.16.47.26.95.28 1.4l-1.3-1.29a3.95 3.95 0 00-.15-.36.5.5 0 11.9-.44c.07.14.17.38.27.69zM16 3H5.12l-1-1H16a2 2 0 012 2v6.2a1.5 1.5 0 00-1-.18V4a1 1 0 00-1-1z",
    fill: primaryFill
  }));
};

export const DesktopSpeakerOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSpeakerOffRegularIcon({}), 'DesktopSpeakerOffRegular');

const DesktopSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.98 1.98 0 00-1.72-.1 2 2 0 00-.66.44.5.5 0 11-.71-.71A3 3 0 0116 3.15V3c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 0113 7.85V8a.5.5 0 01-1 0V6.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.98 1.98 0 001.72.1 2 2 0 00.66-.44.5.5 0 11.71.71 3 3 0 01-1 .66zM14.5 11c1.33 0 2.55-.47 3.5-1.26v3.76c0 .83-.67 1.5-1.5 1.5H13v2h1.5a.5.5 0 010 1h-9a.5.5 0 010-1H7v-2H3.5A1.5 1.5 0 012 13.5v-10C2 2.67 2.67 2 3.5 2h6.76a5.5 5.5 0 004.24 9zM12 15H8v2h4v-2z",
    fill: primaryFill
  }));
};

export const DesktopSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSyncFilledIcon({}), 'DesktopSyncFilled');

const DesktopSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.98 1.98 0 00-1.72-.1 2 2 0 00-.66.44.5.5 0 11-.71-.71A3 3 0 0116 3.15V3c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 0113 7.85V8a.5.5 0 01-1 0V6.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.98 1.98 0 001.72.1 2 2 0 00.66-.44.5.5 0 11.71.71 3 3 0 01-1 .66zM17 13v-2.6c.36-.18.7-.4 1-.66V13a2 2 0 01-2 2h-3v2h1.5a.5.5 0 010 1h-9a.5.5 0 010-1H7v-2H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2h6.26c-.26.3-.48.64-.66 1H4a1 1 0 00-1 1v9a1 1 0 001 1h12a1 1 0 001-1zm-5 2H8v2h4v-2z",
    fill: primaryFill
  }));
};

export const DesktopSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSyncRegularIcon({}), 'DesktopSyncRegular');

const DesktopToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 2C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 000 1h3.55a2.51 2.51 0 01-.05-.5V17H8v-2h1v-1.5a2.5 2.5 0 012.04-2.46A2.5 2.5 0 0113.5 9h2a2.5 2.5 0 012.46 2.04l.04.01V3.5c0-.83-.67-1.5-1.5-1.5h-13zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const DesktopToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopToolboxFilledIcon({}), 'DesktopToolboxFilled');

const DesktopToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 2a2 2 0 00-2 2v9c0 1.1.9 2 2 2h3v2H5.5a.5.5 0 000 1h3.55a2.51 2.51 0 01-.05-.5V17H8v-2h1v-1H4a1 1 0 01-1-1V4a1 1 0 011-1h12a1 1 0 011 1v5.5c.5.37.84.91.96 1.54l.04.01V4a2 2 0 00-2-2H4zm8 10v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const DesktopToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopToolboxRegularIcon({}), 'DesktopToolboxRegular');

const DeveloperBoardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 12a2 2 0 100-4 2 2 0 000 4zM8 2.5a.5.5 0 00-1 0V4h-.5A2.5 2.5 0 004 6.5V7H2.5a.5.5 0 000 1H4v1.5H2.5a.5.5 0 000 1H4V12H2.5a.5.5 0 000 1H4v.5A2.5 2.5 0 006.5 16H7v1.5a.5.5 0 001 0V16h1.5v1.5a.5.5 0 001 0V16H12v1.5a.5.5 0 001 0V16h.5a2.5 2.5 0 002.5-2.5V13h1.5a.5.5 0 000-1H16v-1.5h1.5a.5.5 0 000-1H16V8h1.5a.5.5 0 000-1H16v-.5A2.5 2.5 0 0013.5 4H13V2.5a.5.5 0 00-1 0V4h-1.5V2.5a.5.5 0 00-1 0V4H8V2.5zm5 7.5a3 3 0 11-6 0 3 3 0 016 0z",
    fill: primaryFill
  }));
};

export const DeveloperBoardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardFilledIcon({}), 'DeveloperBoardFilled');

const DeveloperBoardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 7a3 3 0 100 6 3 3 0 000-6zm-2 3a2 2 0 114 0 2 2 0 01-4 0zm-.5-8c.28 0 .5.22.5.5V4h1.5V2.5a.5.5 0 011 0V4H12V2.5a.5.5 0 011 0V4h.5A2.5 2.5 0 0116 6.5V7h1.5a.5.5 0 010 1H16v1.5h1.5a.5.5 0 010 1H16V12h1.5a.5.5 0 010 1H16v.5a2.5 2.5 0 01-2.5 2.5H13v1.5a.5.5 0 01-1 0V16h-1.5v1.5a.5.5 0 01-1 0V16H8v1.5a.5.5 0 01-1 0V16h-.5A2.5 2.5 0 014 13.5V13H2.5a.5.5 0 010-1H4v-1.5H2.5a.5.5 0 010-1H4V8H2.5a.5.5 0 010-1H4v-.5A2.5 2.5 0 016.5 4H7V2.5c0-.28.22-.5.5-.5zM15 6.5c0-.83-.67-1.5-1.5-1.5h-7C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7z",
    fill: primaryFill
  }));
};

export const DeveloperBoardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardRegularIcon({}), 'DeveloperBoardRegular');

const DeveloperBoardLightningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 2.5a.5.5 0 00-1 0V4h-.5A2.5 2.5 0 004 6.5V7H2.5a.5.5 0 000 1H4v1.5H2.5a.5.5 0 000 1H4V12H2.5a.5.5 0 000 1H4v.5A2.5 2.5 0 006.5 16H7v1.5a.5.5 0 001 0V16h1.5v1.5a.5.5 0 001 0V16H12v1.5a.5.5 0 001 0V16h.5a2.5 2.5 0 002.5-2.5V13h1.5a.5.5 0 000-1H16v-1.5h1.5a.5.5 0 000-1H16V8h1.5a.5.5 0 000-1H16v-.5A2.5 2.5 0 0013.5 4H13V2.5a.5.5 0 00-1 0V4h-1.5V2.5a.5.5 0 00-1 0V4H8V2.5zm2.99 5.04L10.57 9h1.53c.34 0 .52.4.3.66l-2.65 3.19c-.3.35-.86.05-.73-.4L9.46 11H7.9a.4.4 0 01-.3-.66l2.66-3.19c.3-.34.85-.05.73.39z",
    fill: primaryFill
  }));
};

export const DeveloperBoardLightningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardLightningFilledIcon({}), 'DeveloperBoardLightningFilled');

const DeveloperBoardLightningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.99 7.54L10.57 9h1.53c.34 0 .52.4.3.66l-2.65 3.19c-.3.35-.86.05-.73-.4L9.46 11H7.9a.4.4 0 01-.3-.66l2.66-3.19c.3-.34.85-.05.73.39zM8 2.5a.5.5 0 00-1 0V4h-.5A2.5 2.5 0 004 6.5V7H2.5a.5.5 0 000 1H4v1.5H2.5a.5.5 0 000 1H4V12H2.5a.5.5 0 000 1H4v.5A2.5 2.5 0 006.5 16H7v1.5a.5.5 0 001 0V16h1.5v1.5a.5.5 0 001 0V16H12v1.5a.5.5 0 001 0V16h.5a2.5 2.5 0 002.5-2.5V13h1.5a.5.5 0 000-1H16v-1.5h1.5a.5.5 0 000-1H16V8h1.5a.5.5 0 000-1H16v-.5A2.5 2.5 0 0013.5 4H13V2.5a.5.5 0 00-1 0V4h-1.5V2.5a.5.5 0 00-1 0V4H8V2.5zM13.5 5c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 13.5v-7C5 5.67 5.67 5 6.5 5h7z",
    fill: primaryFill
  }));
};

export const DeveloperBoardLightningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardLightningRegularIcon({}), 'DeveloperBoardLightningRegular');

const DeveloperBoardLightningToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 2.5a.5.5 0 00-1 0V4h-.5A2.5 2.5 0 004 6.5V7H2.5a.5.5 0 000 1H4v1.5H2.5a.5.5 0 000 1H4V12H2.5a.5.5 0 000 1H4v.5A2.5 2.5 0 006.5 16H7v1.5a.5.5 0 001 0V16h1v-2.5c0-.23.03-.45.09-.67a.4.4 0 01-.07-.37L9.46 11H7.9a.4.4 0 01-.3-.66l2.66-3.19c.3-.34.85-.05.73.39L10.57 9h1.53c.17 0 .3.1.36.23.32-.15.67-.23 1.04-.23h2c.17 0 .34.02.5.05V8h1.5a.5.5 0 000-1H16v-.5A2.5 2.5 0 0013.5 4H13V2.5a.5.5 0 00-1 0V4h-1.5V2.5a.5.5 0 00-1 0V4H8V2.5zm4 9.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const DeveloperBoardLightningToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardLightningToolboxFilledIcon({}), 'DeveloperBoardLightningToolboxFilled');

const DeveloperBoardLightningToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 2c.28 0 .5.22.5.5V4h1.5V2.5a.5.5 0 011 0V4H12V2.5a.5.5 0 011 0V4h.5A2.5 2.5 0 0116 6.5V7h1.5a.5.5 0 010 1H16v1.05a2.51 2.51 0 00-.5-.05H15V6.5c0-.83-.67-1.5-1.5-1.5h-7C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5H9v1H8v1.5a.5.5 0 01-1 0V16h-.5A2.5 2.5 0 014 13.5V13H2.5a.5.5 0 010-1H4v-1.5H2.5a.5.5 0 010-1H4V8H2.5a.5.5 0 010-1H4v-.5A2.5 2.5 0 016.5 4H7V2.5c0-.28.22-.5.5-.5zm3.54 9.04a2.5 2.5 0 011.42-1.81.4.4 0 00-.36-.23h-1.53l.42-1.46c.12-.44-.44-.73-.73-.39l-2.67 3.2a.4.4 0 00.3.65h1.57l-.44 1.46a.4.4 0 00.07.37 2.5 2.5 0 011.95-1.79zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const DeveloperBoardLightningToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardLightningToolboxRegularIcon({}), 'DeveloperBoardLightningToolboxRegular');

const DeveloperBoardSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 9a2 2 0 11-4 0 2 2 0 014 0zM8.5 1c.28 0 .5.22.5.5V3h1.5V1.5a.5.5 0 011 0V3H13V1.5a.5.5 0 011 0V3h.5A2.5 2.5 0 0117 5.5V6h1.5a.5.5 0 010 1H17v1.5h1.5a.5.5 0 010 1H17V11h1.5a.5.5 0 010 1H17v.5a2.5 2.5 0 01-2.5 2.5H14v1.5a.5.5 0 01-1 0V15h-1.5v1.5a.5.5 0 01-1 0V15H8.74a4.5 4.5 0 00-5.68-5.76.5.5 0 01.44-.74H5V7H3.5a.5.5 0 010-1H5v-.5A2.5 2.5 0 017.5 3H8V1.5c0-.28.22-.5.5-.5zM11 12a3 3 0 100-6 3 3 0 000 6zm-6.5 5c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 00.7-.7L7.3 15.6A3.5 3.5 0 104.5 17zm0-1a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const DeveloperBoardSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardSearchFilledIcon({}), 'DeveloperBoardSearchFilled');

const DeveloperBoardSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 9a3 3 0 116 0 3 3 0 01-6 0zm3-2a2 2 0 100 4 2 2 0 000-4zM9 1.5a.5.5 0 00-1 0V3h-.5A2.5 2.5 0 005 5.5V6H3.5a.5.5 0 000 1H5v1.5H3.5a.5.5 0 00-.44.74A4.5 4.5 0 016 9.26V5.5C6 4.67 6.67 4 7.5 4h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H8.97c-.04.35-.11.68-.23 1h1.76v1.5a.5.5 0 001 0V15H13v1.5a.5.5 0 001 0V15h.5a2.5 2.5 0 002.5-2.5V12h1.5a.5.5 0 000-1H17V9.5h1.5a.5.5 0 000-1H17V7h1.5a.5.5 0 000-1H17v-.5A2.5 2.5 0 0014.5 3H14V1.5a.5.5 0 00-1 0V3h-1.5V1.5a.5.5 0 00-1 0V3H9V1.5zM4.5 17c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 00.7-.7L7.3 15.6A3.5 3.5 0 104.5 17zm0-1a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const DeveloperBoardSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardSearchRegularIcon({}), 'DeveloperBoardSearchRegular');

const DeviceEqFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c.41 0 .75.34.75.75v14.5a.75.75 0 01-1.5 0V2.75c0-.41.34-.75.75-.75zm3.75 3c.41 0 .75.34.75.75v8.5a.75.75 0 01-1.5 0v-8.5c0-.41.34-.75.75-.75zM7 5.75a.75.75 0 00-1.5 0v8.5a.75.75 0 001.5 0v-8.5zM17.25 8c.41 0 .75.34.75.75v2.5a.75.75 0 01-1.5 0v-2.5c0-.41.34-.75.75-.75zM3.5 8.75a.75.75 0 00-1.5 0v2.5a.75.75 0 001.5 0v-2.5z",
    fill: primaryFill
  }));
};

export const DeviceEqFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeviceEqFilledIcon({}), 'DeviceEqFilled');

const DeviceEqRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c.28 0 .5.22.5.5v15a.5.5 0 01-1 0v-15c0-.28.22-.5.5-.5zm3.5 3c.28 0 .5.22.5.5v9a.5.5 0 01-1 0v-9c0-.28.22-.5.5-.5zM7 5.5a.5.5 0 00-1 0v9a.5.5 0 001 0v-9zM16.5 8c.28 0 .5.22.5.5v3a.5.5 0 01-1 0v-3c0-.28.22-.5.5-.5zM4 8.5a.5.5 0 00-1 0v3a.5.5 0 001 0v-3z",
    fill: primaryFill
  }));
};

export const DeviceEqRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeviceEqRegularIcon({}), 'DeviceEqRegular');

const DeviceMeetingRoomFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.66 4.95A2.5 2.5 0 016.1 3h7.8c1.17 0 2.18.8 2.44 1.95l1.6 7A2.5 2.5 0 0115.48 15H4.51a2.5 2.5 0 01-2.44-3.05l1.59-7zM5.5 16a.5.5 0 000 1h9a.5.5 0 000-1h-9z",
    fill: primaryFill
  }));
};

export const DeviceMeetingRoomFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeviceMeetingRoomFilledIcon({}), 'DeviceMeetingRoomFilled');

const DeviceMeetingRoomRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.1 3a2.5 2.5 0 00-2.44 1.95l-1.6 7A2.5 2.5 0 004.52 15h10.98a2.5 2.5 0 002.44-3.05l-1.59-7A2.5 2.5 0 0013.9 3H6.1zM4.63 5.17A1.5 1.5 0 016.1 4h7.8c.7 0 1.31.48 1.47 1.17l1.59 7A1.5 1.5 0 0115.49 14H4.51a1.5 1.5 0 01-1.47-1.83l1.6-7zM5.5 16a.5.5 0 000 1h9a.5.5 0 000-1h-9z",
    fill: primaryFill
  }));
};

export const DeviceMeetingRoomRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeviceMeetingRoomRegularIcon({}), 'DeviceMeetingRoomRegular');

const DeviceMeetingRoomRemoteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.66 4.95A2.5 2.5 0 016.1 3h7.8c1.17 0 2.18.8 2.44 1.95l1.6 7A2.5 2.5 0 0115.48 15H9V9.5A2.5 2.5 0 006.5 7h-3c-.1 0-.21 0-.31.02l.47-2.07zM9 16.5c0 .17-.02.34-.05.5h5.55a.5.5 0 000-1H9v.5zM5 12a1 1 0 100-2 1 1 0 000 2zM2 9.5C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 012 16.5v-7zM3.5 9a.5.5 0 00-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-3z",
    fill: primaryFill
  }));
};

export const DeviceMeetingRoomRemoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeviceMeetingRoomRemoteFilledIcon({}), 'DeviceMeetingRoomRemoteFilled');

const DeviceMeetingRoomRemoteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.66 4.95A2.5 2.5 0 016.1 3h7.8c1.17 0 2.18.8 2.44 1.95l1.6 7A2.5 2.5 0 0115.48 15H9v-1h6.5c.96 0 1.67-.9 1.46-1.83l-1.6-7A1.5 1.5 0 0013.9 4H6.1c-.7 0-1.31.48-1.47 1.17L4.22 7H3.5c-.1 0-.21 0-.31.02l.47-2.07zM8.95 17h5.55a.5.5 0 000-1H9v.5c0 .17-.02.34-.05.5zM5 12a1 1 0 100-2 1 1 0 000 2zM2 9.5C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 012 16.5v-7zM3.5 9a.5.5 0 00-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-3z",
    fill: primaryFill
  }));
};

export const DeviceMeetingRoomRemoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeviceMeetingRoomRemoteRegularIcon({}), 'DeviceMeetingRoomRemoteRegular');

const DiagramFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a3 3 0 00-3 3v9a3 3 0 003 3h.82l.9-1H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2h8a2 2 0 012 2v5.03c.36.06.7.2 1 .4V5a3 3 0 00-3-3H5zm.5 3a.5.5 0 000 1h7a.5.5 0 000-1h-7zM5 8.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zM6.5 11a.5.5 0 00-.37.83L8.94 15l-2.81 3.17a.5.5 0 00.37.83h8.1c.38 0 .76-.15 1.04-.42l3.13-3.04c.3-.3.3-.78 0-1.08l-3.13-3.04a1.5 1.5 0 00-1.05-.42H6.5z",
    fill: primaryFill
  }));
};

export const DiagramFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DiagramFilledIcon({}), 'DiagramFilled');

const DiagramRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a3 3 0 00-3 3v9a3 3 0 003 3h.82l.9-1H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2h8a2 2 0 012 2v5.03c.36.06.7.2 1 .4V5a3 3 0 00-3-3H5zm1.5 9a.5.5 0 00-.37.83L8.94 15l-2.81 3.17a.5.5 0 00.37.83h8.1c.38 0 .76-.15 1.04-.42l3.13-3.04c.3-.3.3-.78 0-1.08l-3.13-3.04a1.5 1.5 0 00-1.05-.42H6.5zm3.34 3.5L7.6 12h6.98a.5.5 0 01.35.14L17.9 15l-2.95 2.86a.5.5 0 01-.35.14H7.61l2.23-2.5a.75.75 0 000-1zM5 5.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zM5.5 8a.5.5 0 000 1h4a.5.5 0 000-1h-4z",
    fill: primaryFill
  }));
};

export const DiagramRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DiagramRegularIcon({}), 'DiagramRegular');

const DialpadFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 5.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm0 4a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM7.25 12a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM10 5.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM11.25 8a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM10 13.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM11.25 16a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM14 5.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM15.25 8a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM14 13.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const DialpadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DialpadFilledIcon({}), 'DialpadFilled');

const DialpadRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 5a1 1 0 100-2 1 1 0 000 2zm0 4a1 1 0 100-2 1 1 0 000 2zm1 3a1 1 0 11-2 0 1 1 0 012 0zm3-7a1 1 0 100-2 1 1 0 000 2zm1 3a1 1 0 11-2 0 1 1 0 012 0zm-1 5a1 1 0 100-2 1 1 0 000 2zm1 3a1 1 0 11-2 0 1 1 0 012 0zm3-11a1 1 0 100-2 1 1 0 000 2zm1 3a1 1 0 11-2 0 1 1 0 012 0zm-1 5a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const DialpadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DialpadRegularIcon({}), 'DialpadRegular');

const DialpadOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l3.9 3.9H6a1.25 1.25 0 101.25 1.2l2.8 2.8H10a1.25 1.25 0 101.25 1.2l5.9 5.9a.5.5 0 00.7-.7l-15-15zM15.25 12c0 .31-.12.6-.3.82l-1.77-1.76a1.25 1.25 0 012.07.94zm-4-4c0 .31-.12.6-.3.82L9.17 7.06a1.25 1.25 0 012.07.94zm-4-4c0 .31-.12.6-.3.82L5.17 3.06A1.25 1.25 0 017.25 4zm0 8a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM10 5.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM11.25 16a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM14 5.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM15.25 8a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z",
    fill: primaryFill
  }));
};

export const DialpadOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DialpadOffFilledIcon({}), 'DialpadOffFilled');

const DialpadOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l4.2 4.22A1 1 0 005 8a1 1 0 101.93-.36l3.43 3.43a1 1 0 10.57.57l6.22 6.21a.5.5 0 00.7-.7l-15-15zM15 12a1 1 0 01-.23.64l-1.41-1.4A1 1 0 0115 12zm-4-4a1 1 0 01-.23.64l-1.41-1.4A1 1 0 0111 8zM7 4a1 1 0 01-.23.64l-1.41-1.4A1 1 0 017 4zm0 8a1 1 0 11-2 0 1 1 0 012 0zm3-7a1 1 0 100-2 1 1 0 000 2zm1 11a1 1 0 11-2 0 1 1 0 012 0zm3-11a1 1 0 100-2 1 1 0 000 2zm1 3a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const DialpadOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DialpadOffRegularIcon({}), 'DialpadOffRegular');

const DiamondFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.59 11.41a2 2 0 010-2.82l6-6a2 2 0 012.83 0l6 6a2 2 0 010 2.82l-6 6a2 2 0 01-2.83 0l-6-6z",
    fill: primaryFill
  }));
};

export const DiamondFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DiamondFilledIcon({}), 'DiamondFilled');

const DiamondRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.59 11.41a2 2 0 010-2.82l6-6a2 2 0 012.83 0l6 6a2 2 0 010 2.82l-6 6a2 2 0 01-2.83 0l-6-6zm.7-2.12a1 1 0 000 1.42l6 6a1 1 0 001.42 0l6-6a1 1 0 000-1.42l-6-6a1 1 0 00-1.42 0l-6 6z",
    fill: primaryFill
  }));
};

export const DiamondRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DiamondRegularIcon({}), 'DiamondRegular');

const DirectionsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.77 3.06a2.5 2.5 0 00-3.54 0L3.06 8.23a2.5 2.5 0 000 3.54l5.17 5.17a2.5 2.5 0 003.54 0l5.17-5.17a2.5 2.5 0 000-3.54l-5.17-5.17zm-1.12 3.09c.2-.2.5-.2.7 0l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 01-.7-.7l.64-.65h-.79C9.67 8.5 9 9.17 9 10v2.5a.5.5 0 01-1 0V10a2.5 2.5 0 012.5-2.5h.8l-.65-.65a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const DirectionsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DirectionsFilledIcon({}), 'DirectionsFilled');

const DirectionsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 8.5C9.67 8.5 9 9.17 9 10v2.5a.5.5 0 11-1 0V10a2.5 2.5 0 012.5-2.5h.8l-.65-.65a.5.5 0 01.7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 11-.7-.7l.64-.65h-.79zM8.23 3.06a2.5 2.5 0 013.54 0l5.17 5.17a2.5 2.5 0 010 3.54l-5.17 5.17a2.5 2.5 0 01-3.54 0l-5.17-5.17a2.5 2.5 0 010-3.54l5.17-5.17zm2.83.7a1.5 1.5 0 00-2.12 0L3.77 8.95a1.5 1.5 0 000 2.12l5.17 5.17a1.5 1.5 0 002.12 0l5.17-5.17a1.5 1.5 0 000-2.12l-5.17-5.17z",
    fill: primaryFill
  }));
};

export const DirectionsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DirectionsRegularIcon({}), 'DirectionsRegular');

const DismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.9 4.05l.07-.08a.75.75 0 01.98-.07l.08.07L10 8.94l4.97-4.97a.75.75 0 01.98-.07l.08.07c.27.27.3.68.07.98l-.07.08L11.06 10l4.97 4.97c.27.27.3.68.07.98l-.07.08a.75.75 0 01-.98.07l-.08-.07L10 11.06l-4.97 4.97a.75.75 0 01-.98.07l-.08-.07a.75.75 0 01-.07-.98l.07-.08L8.94 10 3.97 5.03a.75.75 0 01-.07-.98l.07-.08-.07.08z",
    fill: primaryFill
  }));
};

export const DismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissFilledIcon({}), 'DismissFilled');

const DismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.09 4.22l.06-.07a.5.5 0 01.63-.06l.07.06L10 9.29l5.15-5.14a.5.5 0 01.63-.06l.07.06c.18.17.2.44.06.63l-.06.07L10.71 10l5.14 5.15c.18.17.2.44.06.63l-.06.07a.5.5 0 01-.63.06l-.07-.06L10 10.71l-5.15 5.14a.5.5 0 01-.63.06l-.07-.06a.5.5 0 01-.06-.63l.06-.07L9.29 10 4.15 4.85a.5.5 0 01-.06-.63l.06-.07-.06.07z",
    fill: primaryFill
  }));
};

export const DismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissRegularIcon({}), 'DismissRegular');

const DismissCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zM7.8 7.11a.5.5 0 00-.63.06l-.06.07a.5.5 0 00.06.64L9.3 10l-2.12 2.12-.06.07a.5.5 0 00.06.64l.07.06c.2.13.47.11.64-.06L10 10.7l2.12 2.12.07.06c.2.13.46.11.64-.06l.06-.07a.5.5 0 00-.06-.64L10.7 10l2.12-2.12.06-.07a.5.5 0 00-.06-.64l-.07-.06a.5.5 0 00-.64.06L10 9.3 7.88 7.17l-.07-.06z",
    fill: primaryFill
  }));
};

export const DismissCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissCircleFilledIcon({}), 'DismissCircleFilled');

const DismissCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14zM7.8 7.11l.08.06L10 9.3l2.12-2.12a.5.5 0 01.64-.06l.07.06c.17.18.2.44.06.64l-.06.07L10.7 10l2.12 2.12c.17.17.2.44.06.64l-.06.07a.5.5 0 01-.64.06l-.07-.06L10 10.7l-2.12 2.12a.5.5 0 01-.64.06l-.07-.06a.5.5 0 01-.06-.64l.06-.07L9.3 10 7.17 7.88a.5.5 0 01-.06-.64l.06-.07a.5.5 0 01.64-.06z",
    fill: primaryFill
  }));
};

export const DismissCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissCircleRegularIcon({}), 'DismissCircleRegular');

const DismissSquareFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm4.15 1.15a.5.5 0 000 .7L9.29 10l-2.14 2.15a.5.5 0 00.7.7L10 10.71l2.15 2.14a.5.5 0 00.7-.7L10.71 10l2.14-2.15a.5.5 0 00-.7-.7L10 9.29 7.85 7.15a.5.5 0 00-.7 0z",
    fill: primaryFill
  }));
};

export const DismissSquareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissSquareFilledIcon({}), 'DismissSquareFilled');

const DismissSquareRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.15 7.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 01.7.7L10.71 10l2.14 2.15a.5.5 0 01-.7.7L10 10.71l-2.15 2.14a.5.5 0 01-.7-.7L9.29 10 7.15 7.85a.5.5 0 010-.7zM3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm3-2a2 2 0 00-2 2v8c0 1.1.9 2 2 2h8a2 2 0 002-2V6a2 2 0 00-2-2H6z",
    fill: primaryFill
  }));
};

export const DismissSquareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissSquareRegularIcon({}), 'DismissSquareRegular');

const DismissSquareMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h7A2.5 2.5 0 0115 5.5v7a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 013 12.5v-7zm3.15.65a.5.5 0 000 .7L8.29 9l-2.14 2.15a.5.5 0 00.7.7L9 9.71l2.15 2.14a.5.5 0 00.7-.7L9.71 9l2.14-2.15a.5.5 0 00-.7-.7L9 8.29 6.85 6.15a.5.5 0 00-.7 0zM5.5 16c.46.6 1.18 1 2 1h5a4.5 4.5 0 004.5-4.5v-5c0-.82-.4-1.54-1-2v7a3.5 3.5 0 01-3.5 3.5h-7z",
    fill: primaryFill
  }));
};

export const DismissSquareMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissSquareMultipleFilledIcon({}), 'DismissSquareMultipleFilled');

const DismissSquareMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h7A2.5 2.5 0 0115 5.5v7a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 013 12.5v-7zM5.5 4C4.67 4 4 4.67 4 5.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-7zm2 13a2.5 2.5 0 01-2-1h7a3.5 3.5 0 003.5-3.5v-7c.6.46 1 1.18 1 2v5a4.5 4.5 0 01-4.5 4.5h-5zM6.85 6.15a.5.5 0 10-.7.7L8.29 9l-2.14 2.15a.5.5 0 00.7.7L9 9.71l2.15 2.14a.5.5 0 00.7-.7L9.71 9l2.14-2.15a.5.5 0 00-.7-.7L9 8.29 6.85 6.15z",
    fill: primaryFill
  }));
};

export const DismissSquareMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissSquareMultipleRegularIcon({}), 'DismissSquareMultipleRegular');

const DiversityFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.74 16.45A2.99 2.99 0 016 17a3 3 0 01-2.45-4.74l4.19 4.19zm5.9-5.36l-2.23 1.15a.75.75 0 00-.41.66v2.2c0 .28.16.53.41.66l2.23 1.15c.23.12.5.12.72 0l2.23-1.15a.75.75 0 00.41-.66v-2.2a.75.75 0 00-.41-.66l-2.23-1.15a.79.79 0 00-.72 0zm-5.2 4.65A2.99 2.99 0 009 14a3 3 0 00-4.74-2.45l4.19 4.19zM13 3a2 2 0 00-2 2v2c0 1.1.9 2 2 2h2a2 2 0 002-2V5a2 2 0 00-2-2h-2zm-8.09.67c.45-.9 1.73-.9 2.18 0l1.78 3.54c.4.82-.18 1.79-1.1 1.79H4.23c-.9 0-1.5-.97-1.09-1.79l1.78-3.54z",
    fill: primaryFill
  }));
};

export const DiversityFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DiversityFilledIcon({}), 'DiversityFilled');

const DiversityRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 5c0-1.1.9-2 2-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM4.91 3.67c.45-.9 1.73-.9 2.18 0l1.78 3.54c.4.82-.18 1.79-1.1 1.79H4.23c-.9 0-1.5-.97-1.09-1.79l1.78-3.54zm1.28.45a.21.21 0 00-.38 0L4.03 7.66c-.09.17.04.34.2.34h3.55c.15 0 .28-.17.2-.34L6.18 4.12zM9 14a3 3 0 11-6 0 3 3 0 016 0zm-1 0a2 2 0 00-3.02-1.72l2.74 2.74A2 2 0 008 14zm-2 2a2 2 0 001.02-.28l-2.74-2.74A2 2 0 006 16zm7.64-4.91c.23-.12.5-.12.72 0l2.23 1.15c.25.13.41.38.41.66v2.2c0 .28-.16.53-.41.66l-2.23 1.15a.79.79 0 01-.72 0l-2.23-1.15a.75.75 0 01-.41-.66v-2.2c0-.28.16-.53.41-.66l2.23-1.15zM12 13.06v1.88l2 1.03 2-1.03v-1.88l-2-1.03-2 1.03z",
    fill: primaryFill
  }));
};

export const DiversityRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DiversityRegularIcon({}), 'DiversityRegular');

const DividerShortFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.75 3c.41 0 .75.34.75.75v12.5a.75.75 0 01-1.5 0V3.75c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const DividerShortFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DividerShortFilledIcon({}), 'DividerShortFilled');

const DividerShortRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 3c.28 0 .5.22.5.5v13a.5.5 0 01-1 0v-13c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const DividerShortRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DividerShortRegularIcon({}), 'DividerShortRegular');

const DividerTallFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.75 1c.41 0 .75.34.75.75v16.5a.75.75 0 01-1.5 0V1.75c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const DividerTallFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DividerTallFilledIcon({}), 'DividerTallFilled');

const DividerTallRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 1c.28 0 .5.22.5.5v17a.5.5 0 01-1 0v-17c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const DividerTallRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DividerTallRegularIcon({}), 'DividerTallRegular');

const DockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.53 3.22a.75.75 0 00-1.06 0l-2.5 2.5a.75.75 0 001.06 1.06l1.22-1.22v6.69a.75.75 0 001.5 0V5.56l1.22 1.22a.75.75 0 101.06-1.06l-2.5-2.5zM3.5 10.5a1 1 0 011-1h2.75a.75.75 0 000-1.5H4.5A2.5 2.5 0 002 10.5v3A2.5 2.5 0 004.5 16h11a2.5 2.5 0 002.5-2.5v-3A2.5 2.5 0 0015.5 8h-2.75a.75.75 0 000 1.5h2.75a1 1 0 011 1v3a1 1 0 01-1 1h-11a1 1 0 01-1-1v-3z",
    fill: primaryFill
  }));
};

export const DockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DockFilledIcon({}), 'DockFilled');

const DockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.35 3.15a.5.5 0 00-.7 0l-3 3a.5.5 0 10.7.7L9.5 4.71v7.79a.5.5 0 001 0V4.7l2.15 2.15a.5.5 0 00.7-.7l-3-3zM3 10.5C3 9.67 3.67 9 4.5 9h3a.5.5 0 000-1h-3A2.5 2.5 0 002 10.5v3A2.5 2.5 0 004.5 16h11a2.5 2.5 0 002.5-2.5v-3A2.5 2.5 0 0015.5 8h-3a.5.5 0 000 1h3c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 13.5v-3z",
    fill: primaryFill
  }));
};

export const DockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DockRegularIcon({}), 'DockRegular');

const DockRowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4c-.83 0-1.5.67-1.5 1.5v2C1.5 8.33 2.17 9 3 9h2c.83 0 1.5-.67 1.5-1.5v-2C6.5 4.67 5.83 4 5 4H3zm0 6c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H3zm4.5-4.5C7.5 4.67 8.17 4 9 4h2c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5H9a1.5 1.5 0 01-1.5-1.5v-2zM9 10c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H9zm4.5-4.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 01-1.5-1.5v-2zM15 10c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-2z",
    fill: primaryFill
  }));
};

export const DockRowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DockRowFilledIcon({}), 'DockRowFilled');

const DockRowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4c-.83 0-1.5.67-1.5 1.5v2C1.5 8.33 2.17 9 3 9h2c.83 0 1.5-.67 1.5-1.5v-2C6.5 4.67 5.83 4 5 4H3zm-.5 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2A.5.5 0 015 8H3a.5.5 0 01-.5-.5v-2zM3 10c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H3zm-.5 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5v-2zm5-6C7.5 4.67 8.17 4 9 4h2c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5H9a1.5 1.5 0 01-1.5-1.5v-2zM9 5a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h2a.5.5 0 00.5-.5v-2A.5.5 0 0011 5H9zm0 5c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H9zm-.5 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5H9a.5.5 0 01-.5-.5v-2zm5-6c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 01-1.5-1.5v-2zM15 5a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h2a.5.5 0 00.5-.5v-2A.5.5 0 0017 5h-2zm0 5c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-2zm-.5 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const DockRowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DockRowRegularIcon({}), 'DockRowRegular');

const DoctorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3C7.67 3 7 3.67 7 4.5V7H4.5C3.67 7 3 7.67 3 8.5v3c0 .83.67 1.5 1.5 1.5H7v2.5c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5V13h2.5c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5H13V4.5c0-.83-.67-1.5-1.5-1.5h-3z",
    fill: primaryFill
  }));
};

export const DoctorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoctorFilledIcon({}), 'DoctorFilled');

const DoctorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 4a.5.5 0 00-.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h3c.28 0 .5.22.5.5v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3c0-.28.22-.5.5-.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 00-.5-.5h-3zM7 4.5C7 3.67 7.67 3 8.5 3h3c.83 0 1.5.67 1.5 1.5V7h2.5c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5H13v2.5c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 017 15.5V13H4.5A1.5 1.5 0 013 11.5v-3C3 7.67 3.67 7 4.5 7H7V4.5z",
    fill: primaryFill
  }));
};

export const DoctorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoctorRegularIcon({}), 'DoctorRegular');

const DocumentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5v-13C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25z",
    fill: primaryFill
  }));
};

export const DocumentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFilledIcon({}), 'DocumentFilled');

const DocumentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zM5 4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1H6a1 1 0 01-1-1V4zm9.8 3h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7z",
    fill: primaryFill
  }));
};

export const DocumentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentRegularIcon({}), 'DocumentRegular');

const DocumentAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 004 9.2V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H6v-1.5z",
    fill: primaryFill
  }));
};

export const DocumentAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentAddFilledIcon({}), 'DocumentAddFilled');

const DocumentAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H6v-1.5z",
    fill: primaryFill
  }));
};

export const DocumentAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentAddRegularIcon({}), 'DocumentAddRegular');

const DocumentArrowDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 004 9.2V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM5.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-2.35-4.15a.5.5 0 01.7-.7L5 15.29V12.5a.5.5 0 011 0v2.8l1.15-1.15a.5.5 0 01.7.7l-2 2a.5.5 0 01-.35.15.5.5 0 01-.35-.14l-2-2z",
    fill: primaryFill
  }));
};

export const DocumentArrowDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowDownFilledIcon({}), 'DocumentArrowDownFilled');

const DocumentArrowDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM5.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-2.35-4.15a.5.5 0 01.7-.7L5 15.29V12.5a.5.5 0 011 0v2.8l1.15-1.15a.5.5 0 01.7.7l-2 2a.5.5 0 01-.35.15.5.5 0 01-.35-.14l-2-2z",
    fill: primaryFill
  }));
};

export const DocumentArrowDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowDownRegularIcon({}), 'DocumentArrowDownRegular');

const DocumentArrowLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 004 9.2V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L4.71 15H7.5a.5.5 0 000-1H4.7l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const DocumentArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowLeftFilledIcon({}), 'DocumentArrowLeftFilled');

const DocumentArrowLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L4.71 15H7.5a.5.5 0 000-1H4.7l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const DocumentArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowLeftRegularIcon({}), 'DocumentArrowLeftRegular');

const DocumentArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 004 9.2V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM5.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.35-2.15a.5.5 0 01-.7-.7L6.29 15H3.5a.5.5 0 010-1h2.8l-1.15-1.15a.5.5 0 01.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35l-2 2z",
    fill: primaryFill
  }));
};

export const DocumentArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowRightFilledIcon({}), 'DocumentArrowRightFilled');

const DocumentArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM5.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.35-2.15a.5.5 0 01-.7-.7L6.29 15H3.5a.5.5 0 010-1h2.8l-1.15-1.15a.5.5 0 01.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35l-2 2z",
    fill: primaryFill
  }));
};

export const DocumentArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowRightRegularIcon({}), 'DocumentArrowRightRegular');

const DocumentArrowUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 004 9.2V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM5.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm2.35-4.85a.5.5 0 11-.7.7L6 13.71v2.79a.5.5 0 01-1 0v-2.8l-1.15 1.15a.5.5 0 11-.7-.7l2-2A.5.5 0 015.5 12a.5.5 0 01.35.14l2 2z",
    fill: primaryFill
  }));
};

export const DocumentArrowUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowUpFilledIcon({}), 'DocumentArrowUpFilled');

const DocumentArrowUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM5.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm2.35-4.85a.5.5 0 11-.7.7L6 13.71v2.79a.5.5 0 01-1 0v-2.8l-1.15 1.15a.5.5 0 11-.7-.7l2-2A.5.5 0 015.5 12a.5.5 0 01.35.14l2 2z",
    fill: primaryFill
  }));
};

export const DocumentArrowUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowUpRegularIcon({}), 'DocumentArrowUpRegular');

const DocumentBriefcaseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H12v-4.5A2.5 2.5 0 009.5 11H9v-1a1 1 0 00-1-1H4V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM4 10.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V12h1a2 2 0 012 2v3a2 2 0 01-2 2H3a2 2 0 01-2-2v-3c0-1.1.9-2 2-2h1v-1.5zm3 .5H5v1h2v-1zm-4 2a1 1 0 00-1 1v3a1 1 0 001 1h6a1 1 0 001-1v-3a1 1 0 00-1-1H3z",
    fill: primaryFill
  }));
};

export const DocumentBriefcaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBriefcaseFilledIcon({}), 'DocumentBriefcaseFilled');

const DocumentBriefcaseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5h1V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-2v1h2a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM4 10.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V12h1a2 2 0 012 2v3a2 2 0 01-2 2H3a2 2 0 01-2-2v-3c0-1.1.9-2 2-2h1v-1.5zm3 .5H5v1h2v-1zm-4 2a1 1 0 00-1 1v3a1 1 0 001 1h6a1 1 0 001-1v-3a1 1 0 00-1-1H3z",
    fill: primaryFill
  }));
};

export const DocumentBriefcaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBriefcaseRegularIcon({}), 'DocumentBriefcaseRegular');

const DocumentBulletListFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5zm-4 4a.5.5 0 111 0 .5.5 0 01-1 0zm0 2a.5.5 0 111 0 .5.5 0 01-1 0zm0 2a.5.5 0 111 0 .5.5 0 01-1 0zm2-4c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 2c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 2c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm3-8V2.25L15.75 7H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentBulletListFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListFilledIcon({}), 'DocumentBulletListFilled');

const DocumentBulletListRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 10.5a.5.5 0 111 0 .5.5 0 01-1 0zm.5 1.5a.5.5 0 100 1 .5.5 0 000-1zM6 14.5a.5.5 0 111 0 .5.5 0 01-1 0zM8.5 10a.5.5 0 000 1h5a.5.5 0 000-1h-5zM8 12.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 1.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zM5 4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1H6a1 1 0 01-1-1V4zm9.8 3h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7z",
    fill: primaryFill
  }));
};

export const DocumentBulletListRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListRegularIcon({}), 'DocumentBulletListRegular');

const DocumentBulletListClockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.47 5.47 0 01-1.24-3H8.5a.5.5 0 010-1h.52c.03-.34.1-.68.19-1H8.5a.5.5 0 010-1h1.1c.18-.36.4-.7.66-1H8.5a.5.5 0 010-1h2.84A5.47 5.47 0 0116 9.2V8h-4.5A1.5 1.5 0 0110 6.5zm-4 4a.5.5 0 111 0 .5.5 0 01-1 0zm0 2a.5.5 0 111 0 .5.5 0 01-1 0zm.5 1.5a.5.5 0 110 1 .5.5 0 010-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M11 6.5V2.25L15.75 7H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-3a.5.5 0 00-1 0v3c0 .28.22.5.5.5h2a.5.5 0 000-1H15v-2.5z",
    fill: primaryFill
  }));
};

export const DocumentBulletListClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListClockFilledIcon({}), 'DocumentBulletListClockFilled');

const DocumentBulletListClockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 01-.66-1H6a1 1 0 01-1-1V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v1.02c.34.03.68.1 1 .19V7.4c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM9 14.5c0-.17 0-.34.02-.5H8.5a.5.5 0 000 1h.52a5.57 5.57 0 01-.02-.5zm.2-1.5c.1-.35.24-.68.4-1H8.5a.5.5 0 000 1h.7zm1.06-2c.31-.38.67-.72 1.08-1H8.5a.5.5 0 000 1h1.76zM6.5 10a.5.5 0 100 1 .5.5 0 000-1zM6 12.5a.5.5 0 111 0 .5.5 0 01-1 0zm0 2a.5.5 0 111 0 .5.5 0 01-1 0zm13 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-3a.5.5 0 00-1 0v3c0 .28.22.5.5.5h2a.5.5 0 000-1H15v-2.5z",
    fill: primaryFill
  }));
};

export const DocumentBulletListClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListClockRegularIcon({}), 'DocumentBulletListClockRegular');

const DocumentBulletListMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 6.5V2H5.5C4.67 2 4 2.67 4 3.5v11c0 .83.67 1.5 1.5 1.5H13a2 2 0 002-2V8h-4.5A1.5 1.5 0 019 6.5zm-3 4a.5.5 0 111 0 .5.5 0 01-1 0zm.5 2.5a.5.5 0 110-1 .5.5 0 010 1zm2-2a.5.5 0 010-1h4a.5.5 0 010 1h-4zM8 12.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm2-6V2.25L14.75 7H10.5a.5.5 0 01-.5-.5zM17 9a1 1 0 00-1-1v6a3 3 0 01-3 3H6a1 1 0 001 1h6.06A3.94 3.94 0 0017 14.06V9z",
    fill: primaryFill
  }));
};

export const DocumentBulletListMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListMultipleFilledIcon({}), 'DocumentBulletListMultipleFilled');

const DocumentBulletListMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 10a.5.5 0 100 1 .5.5 0 000-1zM6 12.5a.5.5 0 111 0 .5.5 0 01-1 0zm2-2c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm.5 1.5a.5.5 0 000 1h4a.5.5 0 000-1h-4zM6 2a2 2 0 00-2 2v10c0 1.1.9 2 2 2h7a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 009.59 2H6zM5 4a1 1 0 011-1h3v3.5c0 .83.67 1.5 1.5 1.5H14v6a1 1 0 01-1 1H6a1 1 0 01-1-1V4zm5 2.5V3.2L13.8 7h-3.3a.5.5 0 01-.5-.5zM16 8a1 1 0 011 1v5.06A3.94 3.94 0 0113.06 18H7a1 1 0 01-1-1h7a3 3 0 003-3V8z",
    fill: primaryFill
  }));
};

export const DocumentBulletListMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListMultipleRegularIcon({}), 'DocumentBulletListMultipleRegular');

const DocumentBulletListOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4.7L2.15 2.86a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-1.16-1.16A1.5 1.5 0 0114.5 18h-9A1.5 1.5 0 014 16.5V4.7zm9.3 9.3H8.5a.5.5 0 000 1h5a.5.5 0 00.47-.32l-.68-.68zm-1-1l-1-1H8.5a.5.5 0 000 1h3.8zm-2-2l-1-1h-.8a.5.5 0 000 1h1.8zm3.2 0h-.38L16 13.88V8h-4.5A1.5 1.5 0 0110 6.5V2H5.5c-.38 0-.73.14-1 .38L12.12 10h1.38a.5.5 0 010 1zM6 10.5a.5.5 0 101 0 .5.5 0 00-1 0zm0 2a.5.5 0 101 0 .5.5 0 00-1 0zm0 2a.5.5 0 101 0 .5.5 0 00-1 0zm5-8V2.25L15.75 7H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentBulletListOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListOffFilledIcon({}), 'DocumentBulletListOffFilled');

const DocumentBulletListOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4.7L2.15 2.86a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-1.25-1.24A2 2 0 0114 18H6a2 2 0 01-2-2V4.7zm11 11l-1.03-1.02a.5.5 0 01-.47.32h-5a.5.5 0 010-1h4.8l-1-1H8.5a.5.5 0 010-1h2.8l-1-1H8.5a.5.5 0 010-1h.8L5 5.7V16a1 1 0 001 1h8a1 1 0 001-1v-.3zM12.12 10l1 1h.38a.5.5 0 000-1h-1.38zM15 8v4.88l1 1V7.4c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6a2 2 0 00-1.35.53l.7.7A1 1 0 016 3h4v3.5c0 .83.67 1.5 1.5 1.5H15zm-9 2.5a.5.5 0 101 0 .5.5 0 00-1 0zm.5 1.5a.5.5 0 100 1 .5.5 0 000-1zM6 14.5a.5.5 0 111 0 .5.5 0 01-1 0zM14.8 7h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7z",
    fill: primaryFill
  }));
};

export const DocumentBulletListOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListOffRegularIcon({}), 'DocumentBulletListOffRegular');

const DocumentCatchUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 16.5V13h1.5a1.5 1.5 0 001.34-.83l.04-.07 1.24 2.98a1.5 1.5 0 002.72.1L11.93 13h.57a1.5 1.5 0 000-3H11a1.5 1.5 0 00-1.34.83l-.04.07-1.24-2.98a1.5 1.5 0 00-2.72-.1L4.57 10H4V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM7.46 8.31a.5.5 0 00-.9-.03L5.18 11H3.5a.5.5 0 000 1h2a.5.5 0 00.45-.28l1-2.02 2.09 5a.5.5 0 00.9.02L11.32 12h1.19a.5.5 0 000-1H11a.5.5 0 00-.45.28l-1 2.02-2.09-5z",
    fill: primaryFill
  }));
};

export const DocumentCatchUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCatchUpFilledIcon({}), 'DocumentCatchUpFilled');

const DocumentCatchUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v4.5a.5.5 0 001 0V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1H6a1 1 0 01-1-1v-3H4v3c0 1.1.9 2 2 2h8a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM7.45 8.3a.5.5 0 00-.9-.02L5.18 11H3.5a.5.5 0 000 1h2a.5.5 0 00.45-.28l1-2.02 2.09 5a.5.5 0 00.9.02L11.32 12h1.19a.5.5 0 000-1H11a.5.5 0 00-.45.28l-1 2.02-2.09-5z",
    fill: primaryFill
  }));
};

export const DocumentCatchUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCatchUpRegularIcon({}), 'DocumentCatchUpRegular');

const DocumentCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 004 9.2V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L4.5 15.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const DocumentCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCheckmarkFilledIcon({}), 'DocumentCheckmarkFilled');

const DocumentCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L4.5 15.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const DocumentCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCheckmarkRegularIcon({}), 'DocumentCheckmarkRegular');

const DocumentChevronDoubleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 004 9.2V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.65-1.15a.5.5 0 00-.7-.7l-1.5 1.5a.5.5 0 000 .7l1.5 1.5a.5.5 0 00.7-.7L3.21 14.5l1.14-1.15zm2.3-.7a.5.5 0 000 .7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.5-1.5a.5.5 0 000-.7l-1.5-1.5a.5.5 0 00-.7 0z",
    fill: primaryFill
  }));
};

export const DocumentChevronDoubleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentChevronDoubleFilledIcon({}), 'DocumentChevronDoubleFilled');

const DocumentChevronDoubleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.65-1.15a.5.5 0 00-.7-.7l-1.5 1.5a.5.5 0 000 .7l1.5 1.5a.5.5 0 00.7-.7L3.21 14.5l1.14-1.15zm2.3-.7a.5.5 0 000 .7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.5-1.5a.5.5 0 000-.7l-1.5-1.5a.5.5 0 00-.7 0z",
    fill: primaryFill
  }));
};

export const DocumentChevronDoubleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentChevronDoubleRegularIcon({}), 'DocumentChevronDoubleRegular');

const DocumentCopyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 6.5V2H7.5C6.67 2 6 2.67 6 3.5v11c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0111 6.5zm1 0V2.25L16.75 7H12.5a.5.5 0 01-.5-.5zM4 5a1 1 0 011-1v10.5A2.5 2.5 0 007.5 17H15a1 1 0 01-1 1H7.55A3.55 3.55 0 014 14.45V5z",
    fill: primaryFill
  }));
};

export const DocumentCopyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCopyFilledIcon({}), 'DocumentCopyFilled');

const DocumentCopyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4c0-1.1.9-2 2-2h3.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V14a2 2 0 01-2 2H8a2 2 0 01-2-2V4zm2-1a1 1 0 00-1 1v10a1 1 0 001 1h7a1 1 0 001-1V8h-3.5A1.5 1.5 0 0111 6.5V3H8zm4 .2v3.3c0 .28.22.5.5.5h3.3L12 3.2zM4 5a1 1 0 011-1v10a3 3 0 003 3h7a1 1 0 01-1 1H7.94A3.94 3.94 0 014 14.06V5z",
    fill: primaryFill
  }));
};

export const DocumentCopyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCopyRegularIcon({}), 'DocumentCopyRegular');

const DocumentCssFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v7.67a3 3 0 011.38 1A2.5 2.5 0 019.5 12a2.5 2.5 0 014.5 1.5c0 .44-.2.84-.5 1.12.32.42.5.95.5 1.5v.38c0 .56-.19 1.08-.5 1.5h1c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5zm1 0V2.25L15.75 7H11.5a.5.5 0 01-.5-.5zM3 12a2 2 0 00-2 2v2a2 2 0 104 0 .5.5 0 00-1 0 1 1 0 11-2 0v-2a1 1 0 112 0 .5.5 0 001 0 2 2 0 00-2-2zm8.5 0c-.83 0-1.5.67-1.5 1.5v.38c0 .57.32 1.09.83 1.34l.9.45a.5.5 0 01.27.45v.38a.5.5 0 01-1 0 .5.5 0 00-1 0 1.5 1.5 0 003 0v-.38a1.5 1.5 0 00-.83-1.34l-.9-.45a.5.5 0 01-.27-.45v-.38a.5.5 0 011 0 .5.5 0 001 0c0-.83-.67-1.5-1.5-1.5zM6 13.5a1.5 1.5 0 013 0 .5.5 0 01-1 0 .5.5 0 00-1 0v.38c0 .2.1.36.28.45l.9.45c.5.25.82.77.82 1.34v.38a1.5 1.5 0 01-3 0 .5.5 0 011 0 .5.5 0 001 0v-.38a.5.5 0 00-.28-.45l-.9-.45A1.5 1.5 0 016 13.88v-.38z",
    fill: primaryFill
  }));
};

export const DocumentCssFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCssFilledIcon({}), 'DocumentCssFilled');

const DocumentCssRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 01-2 2h-.5c.22-.3.38-.63.45-1H14a1 1 0 001-1V8h-3.5A1.5 1.5 0 0110 6.5V3H6a1 1 0 00-1 1v7.76a3 3 0 00-1-.59V4zm7.5 3h3.3L11 3.2v3.3c0 .28.22.5.5.5zM3 12a2 2 0 00-2 2v2a2 2 0 104 0 .5.5 0 00-1 0 1 1 0 11-2 0v-2a1 1 0 112 0 .5.5 0 001 0 2 2 0 00-2-2zm8.5 0c-.83 0-1.5.67-1.5 1.5v.38c0 .57.32 1.09.83 1.34l.9.45a.5.5 0 01.27.45v.38a.5.5 0 01-1 0 .5.5 0 00-1 0 1.5 1.5 0 003 0v-.38a1.5 1.5 0 00-.83-1.34l-.9-.45a.5.5 0 01-.27-.45v-.38a.5.5 0 011 0 .5.5 0 001 0c0-.83-.67-1.5-1.5-1.5zM6 13.5a1.5 1.5 0 013 0 .5.5 0 01-1 0 .5.5 0 00-1 0v.38c0 .2.1.36.28.45l.9.45c.5.25.82.77.82 1.34v.38a1.5 1.5 0 01-3 0 .5.5 0 011 0 .5.5 0 001 0v-.38a.5.5 0 00-.28-.45l-.9-.45A1.5 1.5 0 016 13.88v-.38z",
    fill: primaryFill
  }));
};

export const DocumentCssRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCssRegularIcon({}), 'DocumentCssRegular');

const DocumentDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 004 9.2V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM2.32 17.68a4.5 4.5 0 106.36-6.36 4.5 4.5 0 00-6.36 6.36zm1.41-4.95c.2-.2.51-.2.7 0L5.5 13.8l1.06-1.06a.5.5 0 11.7.7L6.22 14.5l1.06 1.06a.5.5 0 11-.71.7L5.5 15.22l-1.06 1.06a.5.5 0 11-.7-.71l1.05-1.06-1.06-1.06a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const DocumentDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentDismissFilledIcon({}), 'DocumentDismissFilled');

const DocumentDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM8.67 17.68a4.5 4.5 0 10-6.36-6.36 4.5 4.5 0 006.36 6.36zm-4.95-4.95c.2-.2.51-.2.7 0L5.5 13.8l1.06-1.06a.5.5 0 11.7.7L6.22 14.5l1.06 1.06a.5.5 0 11-.71.7L5.5 15.22l-1.06 1.06a.5.5 0 11-.7-.71l1.05-1.06-1.06-1.06a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const DocumentDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentDismissRegularIcon({}), 'DocumentDismissRegular');

const DocumentEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h2.72a1.86 1.86 0 01-.16-1.35l.37-1.5a3.2 3.2 0 01.84-1.48l4.83-4.83c.53-.53 1.21-.8 1.9-.84h-4.5A1.5 1.5 0 0110 6.5zm1 0V2.25L15.75 7H11.5a.5.5 0 01-.5-.5zm6.45 3.05a1.87 1.87 0 00-2.64 0l-4.83 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83c.73-.73.73-1.91 0-2.64z",
    fill: primaryFill
  }));
};

export const DocumentEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentEditFilledIcon({}), 'DocumentEditFilled');

const DocumentEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.5 8H16v-.59a1.5 1.5 0 00-.06-.4V7a1.5 1.5 0 00-.38-.65l-3.91-3.91A1.5 1.5 0 0010.59 2H6a2 2 0 00-2 2v12c0 1.1.9 2 2 2h2.22l-.01-.03A1.86 1.86 0 018 17H6a1 1 0 01-1-1V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5zm0-1a.5.5 0 01-.5-.5V3.2L14.8 7h-3.3zm3.3 2.55a1.87 1.87 0 112.65 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02l4.83-4.83z",
    fill: primaryFill
  }));
};

export const DocumentEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentEditRegularIcon({}), 'DocumentEditRegular');

const DocumentEndnoteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H11v-6a2 2 0 00-2-2H4V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM3.5 11a.5.5 0 010 1h-1a.5.5 0 00-.5.5v5c0 .28.22.5.5.5h1a.5.5 0 010 1h-1A1.5 1.5 0 011 17.5v-5c0-.83.67-1.5 1.5-1.5h1zm4 7a.5.5 0 000 1h1c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 000 1h1c.28 0 .5.22.5.5v5a.5.5 0 01-.5.5h-1zM6 14.5a.5.5 0 00-1 0v3a.5.5 0 101 0v-3zm0-2a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const DocumentEndnoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentEndnoteFilledIcon({}), 'DocumentEndnoteFilled');

const DocumentEndnoteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v6h1V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3v1h3a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM3.5 11a.5.5 0 010 1h-1a.5.5 0 00-.5.5v5c0 .28.22.5.5.5h1a.5.5 0 010 1h-1A1.5 1.5 0 011 17.5v-5c0-.83.67-1.5 1.5-1.5h1zm4 7a.5.5 0 000 1h1c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 000 1h1c.28 0 .5.22.5.5v5a.5.5 0 01-.5.5h-1zm-2-4c.27 0 .5.22.5.5v3a.5.5 0 11-1 0v-3c0-.28.22-.5.5-.5zm0-1a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const DocumentEndnoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentEndnoteRegularIcon({}), 'DocumentEndnoteRegular');

const DocumentErrorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 004 9.2V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM5.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const DocumentErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentErrorFilledIcon({}), 'DocumentErrorFilled');

const DocumentErrorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM5.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const DocumentErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentErrorRegularIcon({}), 'DocumentErrorRegular');

const DocumentFlowchartFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5zm-4 1c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5H8v1.8L9.2 13H11v-.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5V14H9.2l-1.35 1.35a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 010-.7L7 11.79V10h-.5a.5.5 0 01-.5-.5v-2zm5-1V2.25L15.75 7H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentFlowchartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFlowchartFilledIcon({}), 'DocumentFlowchartFilled');

const DocumentFlowchartRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 7.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5H8v1.8L9.2 13H11v-.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5V14H9.2l-1.35 1.35a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 010-.7L7 11.79V10h-.5a.5.5 0 01-.5-.5v-2zM6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zM5 4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1H6a1 1 0 01-1-1V4zm9.8 3h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7z",
    fill: primaryFill
  }));
};

export const DocumentFlowchartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFlowchartRegularIcon({}), 'DocumentFlowchartRegular');

const DocumentFooterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm1 12h6a1 1 0 110 2H7a1 1 0 110-2z",
    fill: primaryFill
  }));
};

export const DocumentFooterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFooterFilledIcon({}), 'DocumentFooterFilled');

const DocumentFooterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zM5 4a1 1 0 011-1h8a1 1 0 011 1v12a1 1 0 01-1 1H6a1 1 0 01-1-1V4zm2 10a1 1 0 100 2h6a1 1 0 100-2H7z",
    fill: primaryFill
  }));
};

export const DocumentFooterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFooterRegularIcon({}), 'DocumentFooterRegular');

const DocumentFooterDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-3.8 0l1.15-1.15a.5.5 0 00-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L15.21 5.5zm-.7 5.5a5.5 5.5 0 001.5-.2V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.1.9-2 2-2h4.26a5.5 5.5 0 004.24 9zM7 14a1 1 0 100 2h6a1 1 0 100-2H7z",
    fill: primaryFill
  }));
};

export const DocumentFooterDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFooterDismissFilledIcon({}), 'DocumentFooterDismissFilled');

const DocumentFooterDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L15.21 5.5l1.14-1.15zM15 16v-5.02c.34-.03.68-.1 1-.19V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.1.9-2 2-2h4.26c-.26.3-.48.64-.66 1H6a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1zm-8-2a1 1 0 100 2h6a1 1 0 100-2H7z",
    fill: primaryFill
  }));
};

export const DocumentFooterDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFooterDismissRegularIcon({}), 'DocumentFooterDismissRegular');

const DocumentHeaderFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm1 2h6a1 1 0 110 2H7a1 1 0 010-2z",
    fill: primaryFill
  }));
};

export const DocumentHeaderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderFilledIcon({}), 'DocumentHeaderFilled');

const DocumentHeaderRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zM5 4a1 1 0 011-1h8a1 1 0 011 1v12a1 1 0 01-1 1H6a1 1 0 01-1-1V4zm2 0a1 1 0 000 2h6a1 1 0 100-2H7z",
    fill: primaryFill
  }));
};

export const DocumentHeaderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderRegularIcon({}), 'DocumentHeaderRegular');

const DocumentHeaderArrowDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h4.26A5.5 5.5 0 0116 9.2V4a2 2 0 00-2-2H6zm1 2h6a1 1 0 110 2H7a1 1 0 010-2zm12 10.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.85 2.35a.5.5 0 00.35.15.5.5 0 00.35-.15l2-2a.5.5 0 00-.7-.7L15 15.29V12.5a.5.5 0 00-1 0v2.8l-1.15-1.15a.5.5 0 00-.7.7l2 2z",
    fill: primaryFill
  }));
};

export const DocumentHeaderArrowDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderArrowDownFilledIcon({}), 'DocumentHeaderArrowDownFilled');

const DocumentHeaderArrowDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 01-.66-1H6a1 1 0 01-1-1V4a1 1 0 011-1h8a1 1 0 011 1v5.02c.34.03.68.1 1 .19V4a2 2 0 00-2-2H6zm1 2a1 1 0 000 2h6a1 1 0 100-2H7zm12 10.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.85 2.35a.5.5 0 00.35.15.5.5 0 00.35-.15l2-2a.5.5 0 00-.7-.7L15 15.29V12.5a.5.5 0 00-1 0v2.8l-1.15-1.15a.5.5 0 00-.7.7l2 2z",
    fill: primaryFill
  }));
};

export const DocumentHeaderArrowDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderArrowDownRegularIcon({}), 'DocumentHeaderArrowDownRegular');

const DocumentHeaderDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h4.26A5.5 5.5 0 0116 9.2V4a2 2 0 00-2-2H6zm1 2h6a1 1 0 110 2H7a1 1 0 010-2zm12 10.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const DocumentHeaderDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderDismissFilledIcon({}), 'DocumentHeaderDismissFilled');

const DocumentHeaderDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 01-.66-1H6a1 1 0 01-1-1V4a1 1 0 011-1h8a1 1 0 011 1v5.02c.34.03.68.1 1 .19V4a2 2 0 00-2-2H6zm1 2a1 1 0 000 2h6a1 1 0 100-2H7zm12 10.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const DocumentHeaderDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderDismissRegularIcon({}), 'DocumentHeaderDismissRegular');

const DocumentHeaderFooterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 1a1 1 0 001 1h6a1 1 0 100-2H7a1 1 0 00-1 1zm0 10a1 1 0 001 1h6a1 1 0 100-2H7a1 1 0 00-1 1z",
    fill: primaryFill
  }));
};

export const DocumentHeaderFooterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderFooterFilledIcon({}), 'DocumentHeaderFooterFilled');

const DocumentHeaderFooterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 5a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm0 10a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zM6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm8 1a1 1 0 011 1v12a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1h8z",
    fill: primaryFill
  }));
};

export const DocumentHeaderFooterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderFooterRegularIcon({}), 'DocumentHeaderFooterRegular');

const DocumentHeartFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5V9c.7.03 1.4.25 2 .66a3.85 3.85 0 014.88 5.91L8.45 18h6.05c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5zm1 0V2.25L15.75 7H11.5a.5.5 0 01-.5-.5zm-4.86 4.33a2.85 2.85 0 114.03 4.04l-3.82 3.81a.5.5 0 01-.7 0l-3.82-3.81a2.85 2.85 0 114.03-4.04l.14.14.14-.14zm4.03 4.04l-.36-.36z",
    fill: primaryFill
  }));
};

export const DocumentHeartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeartFilledIcon({}), 'DocumentHeartFilled');

const DocumentHeartRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 01-2 2H8.45l1-1H14a1 1 0 001-1V8h-3.5A1.5 1.5 0 0110 6.5V3H6a1 1 0 00-1 1v5.17c-.33-.1-.66-.15-1-.17V4zm7-.8v3.3c0 .28.22.5.5.5h3.3L11 3.2zM5.65 18.69a.5.5 0 00.7 0l3.82-3.81a2.85 2.85 0 10-4.03-4.04l-.14.14-.13-.14a2.85 2.85 0 10-4.04 4.04l3.82 3.81z",
    fill: primaryFill
  }));
};

export const DocumentHeartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeartRegularIcon({}), 'DocumentHeartRegular');

const DocumentHeartPulseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 2v4.5c0 .83.67 1.5 1.5 1.5H18v8.5c0 .83-.67 1.5-1.5 1.5H9.45l2.43-2.43A3.85 3.85 0 007 9.66a3.82 3.82 0 00-1-.49V3.5C6 2.67 6.67 2 7.5 2H12zm1 .25V6.5c0 .28.22.5.5.5h4.25L13 2.25zm-5.86 8.58A2.85 2.85 0 0112 13h-1.88l-.56-.56a1.5 1.5 0 00-2.26.16l-.16.22-.35-.6a1.5 1.5 0 00-2.54-.05L3.7 13H2a2.84 2.84 0 014.86-2.17l.14.14.14-.14zM3.97 16l2.68 2.68c.2.2.5.2.7 0L10.03 16H8.5l-.3.4a1.5 1.5 0 01-2.49-.13L5.55 16H3.97zm1.96-3.26a.5.5 0 00-.85-.02L4.23 14H3a.5.5 0 000 1h1.5a.5.5 0 00.42-.22l.56-.85 1.1 1.83a.5.5 0 00.82.04l1.15-1.54.6.6c.1.09.22.14.35.14H11a.5.5 0 000-1H9.7l-.85-.85a.5.5 0 00-.75.05l-1.05 1.4-1.12-1.86z",
    fill: primaryFill
  }));
};

export const DocumentHeartPulseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeartPulseFilledIcon({}), 'DocumentHeartPulseFilled');

const DocumentHeartPulseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 2a2 2 0 00-2 2v5.17c.35.11.69.27 1 .48V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H17v8a1 1 0 01-1 1h-5.55l-1 1H16a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0012.59 2H8zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L16.8 7zM3.53 11.54c.72-.72 1.9-.72 2.62 0l.49.5c.2.19.51.19.7 0l.5-.5A1.85 1.85 0 0111 13h1a2.84 2.84 0 00-4.86-2.17l-.14.14-.13-.14A2.85 2.85 0 002 13h1c-.04-.52.14-1.06.54-1.46zM5.38 16H3.97l2.68 2.68a.5.5 0 00.7 0L10.05 16H8.62L7 17.62 5.38 16zm.57-3.72a.5.5 0 00-.9 0L4.2 14H3a.5.5 0 000 1h1.5a.5.5 0 00.45-.28l.55-1.1 1.06 2.1a.5.5 0 00.84.08l1.16-1.54.59.6c.1.09.22.14.35.14H11a.5.5 0 100-1H9.71l-.85-.85a.5.5 0 00-.76.05L7.1 14.55l-1.14-2.27z",
    fill: primaryFill
  }));
};

export const DocumentHeartPulseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeartPulseRegularIcon({}), 'DocumentHeartPulseRegular');

const DocumentJavascriptFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v7.59c.32.1.59.33.77.6A2.5 2.5 0 019 13.5c0 .44-.2.84-.5 1.12.32.42.5.95.5 1.5v.38c0 .56-.19 1.08-.5 1.5h6c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5zm1 0V2.25L15.75 7H11.5a.5.5 0 01-.5-.5zM3.5 12a.5.5 0 00-.5.5v4a.5.5 0 01-1 0V16a.5.5 0 00-1 0v.5a1.5 1.5 0 003 0v-4a.5.5 0 00-.5-.5zM5 13.5a1.5 1.5 0 013 0 .5.5 0 01-1 0 .5.5 0 00-1 0v.38c0 .2.1.36.28.45l.9.45c.5.25.82.77.82 1.34v.38a1.5 1.5 0 01-3 0 .5.5 0 011 0 .5.5 0 001 0v-.38a.5.5 0 00-.28-.45l-.9-.45A1.5 1.5 0 015 13.88v-.38z",
    fill: primaryFill
  }));
};

export const DocumentJavascriptFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentJavascriptFilledIcon({}), 'DocumentJavascriptFilled');

const DocumentJavascriptRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 01-2 2H8.5c.22-.3.38-.63.45-1H14a1 1 0 001-1V8h-3.5A1.5 1.5 0 0110 6.5V3H6a1 1 0 00-1 1v7.5l-.23.2a1.5 1.5 0 00-.77-.61V4zm7.5 3h3.3L11 3.2v3.3c0 .28.22.5.5.5zm-8 5a.5.5 0 00-.5.5v4a.5.5 0 01-1 0V16a.5.5 0 00-1 0v.5a1.5 1.5 0 003 0v-4a.5.5 0 00-.5-.5zM5 13.5a1.5 1.5 0 013 0 .5.5 0 01-1 0 .5.5 0 00-1 0v.38c0 .2.1.36.28.45l.9.45c.5.25.82.77.82 1.34v.38a1.5 1.5 0 01-3 0 .5.5 0 011 0 .5.5 0 001 0v-.38a.5.5 0 00-.28-.45l-.9-.45A1.5 1.5 0 015 13.88v-.38z",
    fill: primaryFill
  }));
};

export const DocumentJavascriptRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentJavascriptRegularIcon({}), 'DocumentJavascriptRegular');

const DocumentLandscapeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10h-4.5A1.5 1.5 0 0112 8.5V4H3.5C2.67 4 2 4.67 2 5.5v9c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V10zm-.25-1H13.5a.5.5 0 01-.5-.5V4.25L17.75 9z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeFilledIcon({}), 'DocumentLandscapeFilled');

const DocumentLandscapeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 14a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2h8.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V14zm-2 1a1 1 0 001-1v-4h-3.5A1.5 1.5 0 0112 8.5V5H4a1 1 0 00-1 1v8a1 1 0 001 1h12zm-3-9.8v3.3c0 .28.22.5.5.5h3.3L13 5.2z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeRegularIcon({}), 'DocumentLandscapeRegular');

const DocumentLandscapeDataFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 4A2.5 2.5 0 002 6.5v7A2.5 2.5 0 004.5 16h11a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015.5 4h-11zM9 7a1 1 0 012 0v6a1 1 0 11-2 0V7zm5 1a1 1 0 011 1v4a1 1 0 11-2 0V9a1 1 0 011-1zm-9 3a1 1 0 112 0v2a1 1 0 11-2 0v-2z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeDataFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeDataFilledIcon({}), 'DocumentLandscapeDataFilled');

const DocumentLandscapeDataRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 4A2.5 2.5 0 002 6.5v7A2.5 2.5 0 004.5 16h11a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015.5 4h-11zM3 6.5C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 13.5v-7zM6 10c-.83 0-1.5.67-1.5 1.5v1a1.5 1.5 0 003 0v-1c0-.83-.67-1.5-1.5-1.5zm-.5 1.5a.5.5 0 011 0v1a.5.5 0 01-1 0v-1zm3-4a1.5 1.5 0 113 0v5a1.5 1.5 0 01-3 0v-5zM10 7a.5.5 0 00-.5.5v5a.5.5 0 001 0v-5A.5.5 0 0010 7zm4 1c-.83 0-1.5.67-1.5 1.5v3a1.5 1.5 0 003 0v-3c0-.83-.67-1.5-1.5-1.5zm-.5 1.5a.5.5 0 011 0v3a.5.5 0 01-1 0v-3z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeDataRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeDataRegularIcon({}), 'DocumentLandscapeDataRegular');

const DocumentLandscapeSplitFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 8.5V4h-2v12h6a2 2 0 002-2v-4h-4.5A1.5 1.5 0 0112 8.5zM9 16H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2h5v12zm4-7.5V4.06c.24.07.47.2.65.38l3.91 3.91c.18.18.31.4.38.65H13.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeSplitFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeSplitFilledIcon({}), 'DocumentLandscapeSplitFilled');

const DocumentLandscapeSplitRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 16a2 2 0 002-2V9.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0012.59 4H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12zm1-2a1 1 0 01-1 1h-6V5h2v3.5c0 .83.67 1.5 1.5 1.5H17v4zM9 5v10H4a1 1 0 01-1-1V6a1 1 0 011-1h5zm4 3.5V5.2L16.8 9h-3.3a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeSplitRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeSplitRegularIcon({}), 'DocumentLandscapeSplitRegular');

const DocumentLandscapeSplitHintFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a1 1 0 011-1h.5a.5.5 0 000-1H4a2 2 0 00-2 2v.5a.5.5 0 001 0V6zm1 9a1 1 0 01-1-1v-.5a.5.5 0 00-1 0v.5c0 1.1.9 2 2 2h.5a.5.5 0 000-1H4zM2.5 8c.28 0 .5.22.5.5v3a.5.5 0 01-1 0v-3c0-.28.22-.5.5-.5zm4-4a.5.5 0 000 1h2a.5.5 0 000-1h-2zM6 15.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm6-7V4h-1.5a.5.5 0 00-.5.5v11c0 .28.22.5.5.5H16a2 2 0 002-2v-4h-4.5A1.5 1.5 0 0112 8.5zm1 0V4.06c.24.07.47.2.65.38l3.91 3.91c.18.18.31.4.38.65H13.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeSplitHintFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeSplitHintFilledIcon({}), 'DocumentLandscapeSplitHintFilled');

const DocumentLandscapeSplitHintRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a1 1 0 011-1h.5a.5.5 0 000-1H4a2 2 0 00-2 2v.5a.5.5 0 001 0V6zm6.5-2a.5.5 0 00-.5.5v11c0 .28.22.5.5.5H16a2 2 0 002-2V9.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0012.59 4H9.5zm.5 11V5h2v3.5c0 .83.67 1.5 1.5 1.5H17v4a1 1 0 01-1 1h-6zm3.5-6a.5.5 0 01-.5-.5V5.2L16.8 9h-3.3zM3 14a1 1 0 001 1h.5a.5.5 0 010 1H4a2 2 0 01-2-2v-.5a.5.5 0 011 0v.5zm0-5.5a.5.5 0 00-1 0v3a.5.5 0 001 0v-3zm3-4c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM6.5 15a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeSplitHintRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeSplitHintRegularIcon({}), 'DocumentLandscapeSplitHintRegular');

const DocumentLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5h-3.26a4.5 4.5 0 00-3.74-7H4V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM5 12.5a.5.5 0 00-.5-.5h-.2a3.5 3.5 0 00.2 7h.09a.5.5 0 00-.09-1h-.16a2.5 2.5 0 01.16-5h.09a.5.5 0 00.41-.5zm6 3A3.5 3.5 0 007.5 12h-.09a.5.5 0 00.09 1h.16a2.5 2.5 0 01-.16 5l-.1.01a.5.5 0 00.1 1V19h.2a3.5 3.5 0 003.3-3.5zM7.5 15H4.41a.5.5 0 00.09 1h3.09a.5.5 0 00-.09-1z",
    fill: primaryFill
  }));
};

export const DocumentLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLinkFilledIcon({}), 'DocumentLinkFilled');

const DocumentLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v7h1V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-2.26c-.12.36-.3.7-.5 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM5 12.5a.5.5 0 00-.5-.5h-.2a3.5 3.5 0 00.2 7h.09a.5.5 0 00-.09-1h-.16a2.5 2.5 0 01.16-5h.09a.5.5 0 00.41-.5zm6 3A3.5 3.5 0 007.5 12h-.09a.5.5 0 00.09 1h.16a2.5 2.5 0 01-.16 5l-.1.01a.5.5 0 00.1 1V19h.2a3.5 3.5 0 003.3-3.5zM7.5 15H4.41a.5.5 0 00.09 1h3.09a.5.5 0 00-.09-1z",
    fill: primaryFill
  }));
};

export const DocumentLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLinkRegularIcon({}), 'DocumentLinkRegular');

const DocumentLockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H10v-4a2 2 0 00-1.5-1.94V12A3 3 0 004 9.4V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM3.5 12v1H3a1 1 0 00-1 1v4a1 1 0 001 1h5a1 1 0 001-1v-4a1 1 0 00-1-1h-.5v-1a2 2 0 10-4 0zm1 1v-1a1 1 0 112 0v1h-2zm1 2.25a.75.75 0 110 1.5.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const DocumentLockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLockFilledIcon({}), 'DocumentLockFilled');

const DocumentLockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.4c.3-.17.64-.3 1-.36V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-4v1h4a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM3.5 12v1H3a1 1 0 00-1 1v4a1 1 0 001 1h5a1 1 0 001-1v-4a1 1 0 00-1-1h-.5v-1a2 2 0 10-4 0zm1 1v-1a1 1 0 112 0v1h-2zm1 2.25a.75.75 0 110 1.5.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const DocumentLockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLockRegularIcon({}), 'DocumentLockRegular');

const DocumentMarginsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2v-3.5a.5.5 0 011 0V18h6v-3.5a.5.5 0 011 0V18a2 2 0 002-2V4a2 2 0 00-2-2v3.5a.5.5 0 01-1 0V2H7v3.5a.5.5 0 01-1 0V2zm.5 11a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v5a.5.5 0 01-.5.5zm7 0a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v5a.5.5 0 01-.5.5z",
    fill: primaryFill
  }));
};

export const DocumentMarginsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMarginsFilledIcon({}), 'DocumentMarginsFilled');

const DocumentMarginsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 13a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v5a.5.5 0 01-.5.5zm7 0a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v5a.5.5 0 01-.5.5zM4 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm3-1v2.5a.5.5 0 01-1 0V3a1 1 0 00-1 1v12a1 1 0 001 1v-2.5a.5.5 0 011 0V17h6v-2.5a.5.5 0 011 0V17a1 1 0 001-1V4a1 1 0 00-1-1v2.5a.5.5 0 01-1 0V3H7z",
    fill: primaryFill
  }));
};

export const DocumentMarginsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMarginsRegularIcon({}), 'DocumentMarginsRegular');

const DocumentMentionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H8.39l-.04-.18C9.95 17.63 11 16.1 11 14.5a5.5 5.5 0 00-7-5.3V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM10 14.5a4.5 4.5 0 10-3.14 4.29l.19-.06.06-.03a.54.54 0 00-.43-.99l-.14.05-.2.06a3.43 3.43 0 112.58-3.32c0 .74-.45 1.26-.9 1.26-.34 0-.54-.36-.54-1.26v-1.87a.54.54 0 00-1-.2 1.8 1.8 0 00-.98-.27c-1.22 0-1.98 1.1-1.98 2.34 0 1.25.76 2.34 1.98 2.34.55 0 1-.22 1.34-.58.26.37.66.58 1.18.58 1.09 0 1.98-1.04 1.98-2.34zm-5.4 0c0-.72.38-1.26.9-1.26s.9.54.9 1.26-.38 1.26-.9 1.26-.9-.54-.9-1.26z",
    fill: primaryFill
  }));
};

export const DocumentMentionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMentionFilledIcon({}), 'DocumentMentionFilled');

const DocumentMentionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-4c-.43.44-1 .74-1.65.82l.04.18H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM6.67 17.71a.54.54 0 01.43.99l-.06.03-.19.06A4.5 4.5 0 1110 14.5c0 1.3-.89 2.34-1.98 2.34-.52 0-.92-.2-1.18-.58a1.8 1.8 0 01-1.38.58A1.82 1.82 0 014 16.07a2.66 2.66 0 01-.48-1.57c0-.6.17-1.15.48-1.57a1.84 1.84 0 012.47-.5.54.54 0 011 .2l.01.07v1.8c0 .9.2 1.26.54 1.26.45 0 .9-.52.9-1.26a3.42 3.42 0 10-2.59 3.32l.2-.06.15-.05zM5 13.44c-.25.22-.4.6-.4 1.06 0 .46.15.84.4 1.06.14.13.31.2.5.2.52 0 .9-.54.9-1.26s-.38-1.26-.9-1.26a.74.74 0 00-.5.2z",
    fill: primaryFill
  }));
};

export const DocumentMentionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMentionRegularIcon({}), 'DocumentMentionRegular');

const DocumentMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 6.5V2H5.5C4.67 2 4 2.67 4 3.5v11c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 019 6.5zm1 0V2.25L14.75 7H10.5a.5.5 0 01-.5-.5zM17 9a1 1 0 00-1-1v6a3 3 0 01-3 3H6a1 1 0 001 1h6.06A3.94 3.94 0 0017 14.06V9z",
    fill: primaryFill
  }));
};

export const DocumentMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMultipleFilledIcon({}), 'DocumentMultipleFilled');

const DocumentMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h3.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V14a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2-1a1 1 0 00-1 1v10a1 1 0 001 1h7a1 1 0 001-1V8h-3.5A1.5 1.5 0 019 6.5V3H6zm4 .2v3.3c0 .28.22.5.5.5h3.3L10 3.2zM17 9a1 1 0 00-1-1v6a3 3 0 01-3 3H6a1 1 0 001 1h6.06A3.94 3.94 0 0017 14.06V9z",
    fill: primaryFill
  }));
};

export const DocumentMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMultipleRegularIcon({}), 'DocumentMultipleRegular');

const DocumentMultiplePercentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 6.5V2H5.5C4.67 2 4 2.67 4 3.5v5.67a3 3 0 012 2.71l1.44-1.44a1.5 1.5 0 012.12 2.12L8.12 14a3 3 0 012.7 2h2.68c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 019 6.5zM5 12a2 2 0 11-4 0 2 2 0 014 0zm-1 0a1 1 0 10-2 0 1 1 0 002 0zm-1.15 5.85a.5.5 0 01-.7-.7l6-6a.5.5 0 01.7.7l-6 6zm10.21.15h-2.23a3 3 0 00.17-1h2a3 3 0 003-3V8a1 1 0 011 1v5.06A3.94 3.94 0 0113.06 18zM8 15a2 2 0 110 4 2 2 0 010-4zm-1 2a1 1 0 102 0 1 1 0 00-2 0zm3-10.5V2.25L14.75 7H10.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentMultiplePercentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMultiplePercentFilledIcon({}), 'DocumentMultiplePercentFilled');

const DocumentMultiplePercentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h3.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V14a2 2 0 01-2 2h-2.17a3 3 0 00-.6-1H13a1 1 0 001-1V8h-3.5A1.5 1.5 0 019 6.5V3H6a1 1 0 00-1 1v5.76a3 3 0 00-1-.59V4zm6-.8v3.3c0 .28.22.5.5.5h3.3L10 3.2zM8 15a2 2 0 110 4 2 2 0 010-4zm-1 2a1 1 0 001 1 1 1 0 10-1-1zm4 0a3 3 0 01-.17 1h2.23A3.94 3.94 0 0017 14.06V9a1 1 0 00-1-1v6a3 3 0 01-3 3h-2zm-8.15.85a.5.5 0 01-.7-.7l6-6a.5.5 0 01.7.7l-6 6zM5 12a2 2 0 11-4 0 2 2 0 014 0zm-1 0a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const DocumentMultiplePercentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMultiplePercentRegularIcon({}), 'DocumentMultiplePercentRegular');

const DocumentMultipleProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 2v4.5c0 .83.67 1.5 1.5 1.5H17v6.5c0 .83-.67 1.5-1.5 1.5h-4.7A5.5 5.5 0 006 9.02V3.5C6 2.67 6.67 2 7.5 2H11zM5 9.02V4a1 1 0 00-1 1v4.2c.32-.08.66-.15 1-.18zM10.4 17c-.18.36-.4.7-.66 1H14a1 1 0 001-1h-4.6zM12 2.25V6.5c0 .28.22.5.5.5h4.25L12 2.25zM1 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm2.4 2.8l4.9-4.9a3.5 3.5 0 01-4.9 4.9zm-.7-.7a3.5 3.5 0 014.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const DocumentMultipleProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMultipleProhibitedFilledIcon({}), 'DocumentMultipleProhibitedFilled');

const DocumentMultipleProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 2a2 2 0 00-2 2v5.02c.34.03.68.1 1 .19V4a1 1 0 011-1h3v3.5c0 .83.67 1.5 1.5 1.5H16v6a1 1 0 01-1 1h-4.02c-.03.34-.1.68-.19 1H15a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0011.59 2H8zm4 4.5V3.2L15.8 7h-3.3a.5.5 0 01-.5-.5zM5 9.02V4a1 1 0 00-1 1v4.2c.32-.08.66-.15 1-.18zM9.74 18c.26-.3.48-.64.66-1H15a1 1 0 01-1 1H9.74zM1 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm2.4 2.8l4.9-4.9a3.5 3.5 0 01-4.9 4.9zm-.7-.7a3.5 3.5 0 014.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const DocumentMultipleProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMultipleProhibitedRegularIcon({}), 'DocumentMultipleProhibitedRegular');

const DocumentMultipleSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 6.5V2H5.5C4.67 2 4 2.67 4 3.5v5.7a5.5 5.5 0 016.8 6.8h2.7c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 019 6.5zM13.06 18H9.74c.26-.3.48-.64.66-1H13a3 3 0 003-3V8a1 1 0 011 1v5.06A3.94 3.94 0 0113.06 18zM10 6.5V2.25L14.75 7H10.5a.5.5 0 01-.5-.5zm-9 8a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H6a.5.5 0 010-1h.47a1.99 1.99 0 00-2.38.34.5.5 0 01-.71-.71A3 3 0 017 12.15V12c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 014 16.85V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H5a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const DocumentMultipleSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMultipleSyncFilledIcon({}), 'DocumentMultipleSyncFilled');

const DocumentMultipleSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h3.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V14a2 2 0 01-2 2h-2.2c.08-.32.15-.66.18-1H13a1 1 0 001-1V8h-3.5A1.5 1.5 0 019 6.5V3H6a1 1 0 00-1 1v5.02c-.34.03-.68.1-1 .19V4zm6-.8v3.3c0 .28.22.5.5.5h3.3L10 3.2zm.4 13.8c-.18.36-.4.7-.66 1h3.32A3.94 3.94 0 0017 14.06V9a1 1 0 00-1-1v6a3 3 0 01-3 3h-2.6zM1 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H6a.5.5 0 010-1h.47a1.99 1.99 0 00-2.38.34.5.5 0 01-.71-.71A3 3 0 017 12.15V12c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 014 16.85V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H5a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const DocumentMultipleSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMultipleSyncRegularIcon({}), 'DocumentMultipleSyncRegular');

const DocumentOnePageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5h-9zm7.09 5H7.5a.5.5 0 01-.09-1h5.09a.5.5 0 01.09 1zm0 3.5H7.5a.5.5 0 01-.09-1h5.09a.5.5 0 01.09 1zm0 3.5H7.5a.5.5 0 01-.09-1h5.09a.5.5 0 01.09 1z",
    fill: primaryFill
  }));
};

export const DocumentOnePageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentOnePageFilledIcon({}), 'DocumentOnePageFilled');

const DocumentOnePageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.1.9-2 2-2zm0 1a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1V4a1 1 0 00-1-1H6zm7 3.5a.5.5 0 01-.41.5H7.5a.5.5 0 01-.09-1h5.09c.28 0 .5.22.5.5zm0 3.5a.5.5 0 01-.41.5H7.5a.5.5 0 01-.09-1h5.09c.28 0 .5.22.5.5zm0 3.5a.5.5 0 01-.41.5H7.5a.5.5 0 01-.09-1h5.09c.28 0 .5.22.5.5z",
    fill: primaryFill
  }));
};

export const DocumentOnePageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentOnePageRegularIcon({}), 'DocumentOnePageRegular');

const DocumentPageBottomCenterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.75 13.5l-.22 1.5H9.3l.22-1.5h1.24zM5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5h-9zm2.57 14.44l.07-.44H7.5a.5.5 0 010-1h.78l.22-1.5H8a.5.5 0 010-1h.65l.16-1.07a.5.5 0 01.99.14l-.14.93h1.24l.16-1.07a.5.5 0 01.99.14l-.14.93h.59a.5.5 0 010 1h-.74l-.22 1.5H12a.5.5 0 010 1h-.6l-.09.59a.5.5 0 01-.99-.15l.07-.44H9.15l-.09.59a.5.5 0 01-.99-.15z",
    fill: primaryFill
  }));
};

export const DocumentPageBottomCenterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageBottomCenterFilledIcon({}), 'DocumentPageBottomCenterFilled');

const DocumentPageBottomCenterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.07 15.44l.07-.44H7.5a.5.5 0 110-1h.78l.22-1.5H8a.5.5 0 110-1h.65l.16-1.07a.5.5 0 01.99.14l-.14.93h1.24l.16-1.07a.5.5 0 01.99.14l-.14.93h.59a.5.5 0 010 1h-.74l-.22 1.5H12a.5.5 0 010 1h-.6l-.09.59a.5.5 0 11-.99-.15l.07-.44H9.15l-.09.59a.5.5 0 11-.99-.15zm2.68-2.94H9.51L9.3 14h1.24l.22-1.5zM6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm0 1h8a1 1 0 011 1v12a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z",
    fill: primaryFill
  }));
};

export const DocumentPageBottomCenterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageBottomCenterRegularIcon({}), 'DocumentPageBottomCenterRegular');

const DocumentPageBottomLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.25 14.5l.22-1.5H8.7l-.22 1.5H7.25zM14.5 18c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5h-9C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9zm-4.57-6.44l-.07.44h.64a.5.5 0 010 1h-.78l-.22 1.5h.5a.5.5 0 010 1h-.65l-.16 1.07a.5.5 0 01-.99-.14l.14-.93H7.1l-.16 1.07a.5.5 0 01-.99-.14l.14-.93H5.5a.5.5 0 010-1h.74l.22-1.5H6a.5.5 0 010-1h.6l.09-.59a.5.5 0 01.99.15L7.6 12h1.24l.09-.59a.5.5 0 01.99.15z",
    fill: primaryFill
  }));
};

export const DocumentPageBottomLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageBottomLeftFilledIcon({}), 'DocumentPageBottomLeftFilled');

const DocumentPageBottomLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.93 10.56a.5.5 0 10-1-.15l-.08.59H8.61l.07-.44a.5.5 0 10-1-.15L7.6 11H7a.5.5 0 100 1h.46l-.22 1.5H6.5a.5.5 0 100 1h.59l-.14.93a.5.5 0 101 .14l.15-1.07h1.24l-.14.93a.5.5 0 001 .14l.15-1.07H11a.5.5 0 000-1h-.5l.22-1.5h.78a.5.5 0 000-1h-.64l.07-.44zM8.25 13.5l.22-1.5H9.7l-.22 1.5H8.25zM14 18a2 2 0 002-2V4a2 2 0 00-2-2H6a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8zm0-1H6a1 1 0 01-1-1V4a1 1 0 011-1h8a1 1 0 011 1v12a1 1 0 01-1 1z",
    fill: primaryFill
  }));
};

export const DocumentPageBottomLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageBottomLeftRegularIcon({}), 'DocumentPageBottomLeftRegular');

const DocumentPageBottomRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.25 14.5l.22-1.5h1.24l-.22 1.5h-1.24zM14.5 18c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5h-9C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9zm-.57-6.44l-.07.44h.64a.5.5 0 110 1h-.78l-.22 1.5h.5a.5.5 0 110 1h-.65l-.16 1.07a.5.5 0 01-.99-.14l.14-.93H11.1l-.16 1.07a.5.5 0 01-.99-.14l.14-.93H9.5a.5.5 0 010-1h.74l.22-1.5H10a.5.5 0 010-1h.6l.09-.59a.5.5 0 11.99.15l-.07.44h1.24l.09-.59a.5.5 0 11.99.15z",
    fill: primaryFill
  }));
};

export const DocumentPageBottomRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageBottomRightFilledIcon({}), 'DocumentPageBottomRightFilled');

const DocumentPageBottomRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.93 10.56a.5.5 0 10-1-.15l-.08.59h-1.24l.07-.44a.5.5 0 10-1-.15L9.6 11H9a.5.5 0 000 1h.46l-.22 1.5H8.5a.5.5 0 000 1h.59l-.14.93a.5.5 0 001 .14l.15-1.07h1.24l-.14.93a.5.5 0 001 .14l.15-1.07H13a.5.5 0 000-1h-.5l.22-1.5h.78a.5.5 0 000-1h-.64l.07-.44zm-2.68 2.94l.22-1.5h1.24l-.22 1.5h-1.24zM14 18a2 2 0 002-2V4a2 2 0 00-2-2H6a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8zm0-1H6a1 1 0 01-1-1V4a1 1 0 011-1h8a1 1 0 011 1v12a1 1 0 01-1 1z",
    fill: primaryFill
  }));
};

export const DocumentPageBottomRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageBottomRightRegularIcon({}), 'DocumentPageBottomRightRegular');

const DocumentPageBreakFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 6V2.5a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5V6c0 .83.67 1.5 1.49 1.5h9.01c.82 0 1.5-.67 1.5-1.5zM3 9.5a.5.5 0 000 1h1.2a.5.5 0 000-1H3zm3.2 0a.5.5 0 000 1h1.2a.5.5 0 000-1H6.2zm2.7.5c0-.28.22-.5.5-.5h1.2a.5.5 0 010 1H9.4a.5.5 0 01-.5-.5zm3.7-.5a.5.5 0 000 1h1.2a.5.5 0 000-1h-1.2zm2.7.5c0-.28.22-.5.5-.5H17a.5.5 0 010 1h-1.2a.5.5 0 01-.5-.5zm.7 7.5V14c0-.83-.68-1.5-1.5-1.5H5.49A1.5 1.5 0 004 14v3.5c0 .28.22.5.5.5h11a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentPageBreakFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageBreakFilledIcon({}), 'DocumentPageBreakFilled');

const DocumentPageBreakRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 2.5V6c0 .83-.68 1.5-1.5 1.5H5.49A1.5 1.5 0 014 6V2.5a.5.5 0 111 0V6c0 .28.21.5.49.5h9.01A.5.5 0 0015 6V2.5c0-.28.23-.5.5-.5s.5.22.5.5zm-13 7a.5.5 0 000 1h1.2a.5.5 0 000-1H3zm3.2 0a.5.5 0 000 1h1.2a.5.5 0 000-1H6.2zm2.7.5c0-.28.22-.5.5-.5h1.2a.5.5 0 010 1H9.4a.5.5 0 01-.5-.5zm3.7-.5a.5.5 0 000 1h1.2a.5.5 0 000-1h-1.2zm2.7.5c0-.28.22-.5.5-.5H17a.5.5 0 010 1h-1.2a.5.5 0 01-.5-.5zm.7 4v3.5a.5.5 0 01-.5.5.5.5 0 01-.5-.5V14a.5.5 0 00-.5-.5H5.49a.5.5 0 00-.5.5v3.5a.5.5 0 01-.5.5.5.5 0 01-.49-.5V14c0-.83.67-1.5 1.49-1.5h9.01c.82 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const DocumentPageBreakRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageBreakRegularIcon({}), 'DocumentPageBreakRegular');

const DocumentPageNumberFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.75 9.5l-.22 1.5H9.3l.22-1.5h1.24zM5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5h-9zm2.57 10.44l.07-.44H7.5a.5.5 0 110-1h.78l.22-1.5H8a.5.5 0 010-1h.65l.16-1.07a.5.5 0 01.99.14l-.14.93h1.24l.16-1.07a.5.5 0 01.99.14l-.14.93h.59a.5.5 0 010 1h-.74l-.22 1.5H12a.5.5 0 010 1h-.6l-.09.59a.5.5 0 11-.99-.15l.07-.44H9.15l-.09.59a.5.5 0 11-.99-.15z",
    fill: primaryFill
  }));
};

export const DocumentPageNumberFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageNumberFilledIcon({}), 'DocumentPageNumberFilled');

const DocumentPageNumberRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.07 12.44a.5.5 0 101 .15l.08-.59h1.24l-.07.44a.5.5 0 101 .15l.08-.59h.6a.5.5 0 000-1h-.46l.22-1.5h.74a.5.5 0 000-1h-.59l.14-.93a.5.5 0 00-1-.14L10.9 8.5H9.66l.14-.93a.5.5 0 00-1-.14L8.66 8.5H8a.5.5 0 000 1h.5L8.28 11H7.5a.5.5 0 100 1h.64l-.07.44zm2.68-2.94l-.22 1.5H9.3l.22-1.5h1.24zM6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm0 1h8a1 1 0 011 1v12a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z",
    fill: primaryFill
  }));
};

export const DocumentPageNumberRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageNumberRegularIcon({}), 'DocumentPageNumberRegular');

const DocumentPageTopCenterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.75 5.5L10.53 7H9.3l.22-1.5h1.24zM5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5h-9zm2.57 6.44L8.14 8H7.5a.5.5 0 110-1h.78l.22-1.5H8a.5.5 0 110-1h.65l.16-1.07a.5.5 0 01.99.14l-.14.93h1.24l.16-1.07a.5.5 0 01.99.14l-.14.93h.59a.5.5 0 010 1h-.74L11.54 7H12a.5.5 0 010 1h-.6l-.09.59a.5.5 0 01-.99-.15L10.4 8H9.15l-.09.59a.5.5 0 01-.99-.15z",
    fill: primaryFill
  }));
};

export const DocumentPageTopCenterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageTopCenterFilledIcon({}), 'DocumentPageTopCenterFilled');

const DocumentPageTopCenterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.07 9.44a.5.5 0 101 .15L9.14 9h1.24l-.07.44a.5.5 0 101 .15L11.4 9h.6a.5.5 0 000-1h-.46l.22-1.5h.74a.5.5 0 000-1h-.59l.14-.93a.5.5 0 00-1-.14L10.9 5.5H9.66l.14-.93a.5.5 0 00-1-.14L8.66 5.5H8a.5.5 0 000 1h.5L8.28 8H7.5a.5.5 0 000 1h.64l-.07.44zm2.68-2.94L10.53 8H9.3l.22-1.5h1.24zM6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm0 1h8a1 1 0 011 1v12a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z",
    fill: primaryFill
  }));
};

export const DocumentPageTopCenterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageTopCenterRegularIcon({}), 'DocumentPageTopCenterRegular');

const DocumentPageTopLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.75 5.5L8.53 7H7.3l.22-1.5h1.24zM5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5h-9zm.57 6.44L6.14 8H5.5a.5.5 0 010-1h.78l.22-1.5H6a.5.5 0 010-1h.65l.16-1.07a.5.5 0 01.99.14l-.14.93H8.9l.16-1.07a.5.5 0 01.99.14l-.14.93h.59a.5.5 0 010 1h-.74L9.54 7H10a.5.5 0 010 1h-.6l-.09.59a.5.5 0 11-.99-.15L8.4 8H7.15l-.09.59a.5.5 0 11-.99-.15z",
    fill: primaryFill
  }));
};

export const DocumentPageTopLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageTopLeftFilledIcon({}), 'DocumentPageTopLeftFilled');

const DocumentPageTopLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.07 9.44a.5.5 0 001 .15L8.14 9h1.24l-.07.44a.5.5 0 001 .15L10.4 9h.6a.5.5 0 000-1h-.46l.22-1.5h.74a.5.5 0 000-1h-.59l.14-.93a.5.5 0 00-1-.14L9.9 5.5H8.66l.14-.93a.5.5 0 00-1-.14L7.66 5.5H7a.5.5 0 000 1h.5L7.28 8H6.5a.5.5 0 000 1h.64l-.07.44zM9.75 6.5L9.53 8H8.3l.22-1.5h1.24zM6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm0 1h8a1 1 0 011 1v12a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z",
    fill: primaryFill
  }));
};

export const DocumentPageTopLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageTopLeftRegularIcon({}), 'DocumentPageTopLeftRegular');

const DocumentPageTopRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.75 5.5L12.53 7H11.3l.22-1.5h1.24zM5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5h-9zm4.57 6.44l.07-.44H9.5a.5.5 0 110-1h.78l.22-1.5H10a.5.5 0 110-1h.65l.16-1.07a.5.5 0 01.99.14l-.14.93h1.24l.16-1.07a.5.5 0 01.99.14l-.14.93h.59a.5.5 0 010 1h-.74L13.54 7H14a.5.5 0 010 1h-.6l-.09.59a.5.5 0 01-.99-.15L12.4 8h-1.24l-.09.59a.5.5 0 01-.99-.15z",
    fill: primaryFill
  }));
};

export const DocumentPageTopRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageTopRightFilledIcon({}), 'DocumentPageTopRightFilled');

const DocumentPageTopRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.07 9.44a.5.5 0 101 .15l.08-.59h1.24l-.07.44a.5.5 0 101 .15L12.4 9h.6a.5.5 0 000-1h-.46l.22-1.5h.74a.5.5 0 000-1h-.59l.14-.93a.5.5 0 00-1-.14L11.9 5.5h-1.24l.14-.93a.5.5 0 00-1-.14L9.66 5.5H9a.5.5 0 000 1h.5L9.28 8H8.5a.5.5 0 000 1h.64l-.07.44zm2.68-2.94L11.53 8H10.3l.22-1.5h1.24zM6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm0 1h8a1 1 0 011 1v12a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1z",
    fill: primaryFill
  }));
};

export const DocumentPageTopRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPageTopRightRegularIcon({}), 'DocumentPageTopRightRegular');

const DocumentPdfFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 11a.5.5 0 00-.5.5v2a.5.5 0 001 0v-.17h.33a1.17 1.17 0 000-2.33H6.5zm.83 1.33H7V12h.33a.17.17 0 010 .33zM12 11.5c0-.28.23-.5.5-.5h1a.5.5 0 110 1H13v.33h.5a.5.5 0 110 1H13v.17a.5.5 0 11-1 0v-2zM9.5 11a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h.5a1.5 1.5 0 000-3h-.5zm.5 2v-1a.5.5 0 010 1zm0-6.5V2H5.5C4.67 2 4 2.67 4 3.5v5.58c-.58.2-1 .76-1 1.42v4c0 .65.42 1.2 1 1.41v.59c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-.59c.58-.2 1-.76 1-1.41v-4c0-.66-.42-1.21-1-1.42V8h-4.5A1.5 1.5 0 0110 6.5zM4.5 10h11c.28 0 .5.22.5.5v4a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-4c0-.28.23-.5.5-.5zM11 6.5V2.25L15.75 7H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentPdfFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPdfFilledIcon({}), 'DocumentPdfFilled');

const DocumentPdfRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 11a.5.5 0 00-.5.5v2a.5.5 0 001 0v-.17h.33a1.17 1.17 0 000-2.33H6.5zm.83 1.33H7V12h.33a.17.17 0 010 .33zM12 11.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1H13v.33h.5a.5.5 0 110 1H13v.17a.5.5 0 01-1 0v-2zM9.5 11a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h.5a1.5 1.5 0 000-3h-.5zm.5 2v-1a.5.5 0 010 1zM4 4c0-1.1.9-2 2-2h4.59c.4 0 .77.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06v1.67c.58.2 1 .76 1 1.42v4c0 .65-.42 1.2-1 1.41V16a2 2 0 01-2 2H6a2 2 0 01-2-2v-.09c-.58-.2-1-.76-1-1.41v-4c0-.66.42-1.21 1-1.42V4zm11 4h-3.5A1.5 1.5 0 0110 6.5V3H6a1 1 0 00-1 1v5h10V8zM5 16a1 1 0 001 1h8a1 1 0 001-1H5zm6-12.8v3.3c0 .28.22.5.5.5h3.3L11 3.2zM4.5 10a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h11a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-11z",
    fill: primaryFill
  }));
};

export const DocumentPdfRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPdfRegularIcon({}), 'DocumentPdfRegular');

const DocumentPercentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v5.67a3 3 0 012 2.71l1.44-1.44a1.5 1.5 0 012.12 2.12L8.12 14a3 3 0 012.7 4h3.68c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5zM5 12a2 2 0 11-4 0 2 2 0 014 0zm-1 0a1 1 0 10-2 0 1 1 0 002 0zm-1.15 5.85a.5.5 0 01-.7-.7l6-6a.5.5 0 01.7.7l-6 6zM6 17a2 2 0 002 2 2 2 0 10-2-2zm2 1a1 1 0 110-2 1 1 0 010 2zm3-11.5V2.25L15.75 7H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentPercentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPercentFilledIcon({}), 'DocumentPercentFilled');

const DocumentPercentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 01-2 2h-3.17a3 3 0 00.17-1h3a1 1 0 001-1V8h-3.5A1.5 1.5 0 0110 6.5V3H6a1 1 0 00-1 1v5.76a3 3 0 00-1-.59V4zm7.5 3h3.3L11 3.2v3.3c0 .28.22.5.5.5zM5 12a2 2 0 11-4 0 2 2 0 014 0zm-1 0a1 1 0 10-2 0 1 1 0 002 0zm6 5a2 2 0 11-4 0 2 2 0 014 0zm-1 0a1 1 0 10-2 0 1 1 0 002 0zm-.15-5.85c.2.2.2.5 0 .7l-6 6a.5.5 0 01-.7-.7l6-6c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const DocumentPercentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPercentRegularIcon({}), 'DocumentPercentRegular');

const DocumentPersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H8.63c.25-.47.37-.99.37-1.5 0-1.3-1-2.38-2.27-2.49A3 3 0 004 9.04V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM6.5 12a2 2 0 11-4 0 2 2 0 014 0zM8 16.5C8 17.75 7 19 4.5 19S1 17.75 1 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const DocumentPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPersonFilledIcon({}), 'DocumentPersonFilled');

const DocumentPersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.04a3.02 3.02 0 011 0V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1H8.96c-.05.34-.16.68-.33 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zm-8.3 5a2 2 0 11-4 0 2 2 0 014 0zM8 16.5C8 17.75 7 19 4.5 19S1 17.75 1 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const DocumentPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPersonRegularIcon({}), 'DocumentPersonRegular');

const DocumentPillFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v.91a3.6 3.6 0 00-2.06 1.03l-4 4A3.62 3.62 0 009.2 18H5.5A1.5 1.5 0 014 16.5v-13C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zm7.35 8.4a2.62 2.62 0 00-3.7 0l-4 4a2.62 2.62 0 003.7 3.7l4-4a2.62 2.62 0 000-3.7zm-3 .7a1.62 1.62 0 112.3 2.3L16 15.29 13.7 13l1.65-1.65zm-1.5 4.3c.2.2.2.5 0 .7l-1 1a.5.5 0 01-.7-.7l1-1c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const DocumentPillFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPillFilledIcon({}), 'DocumentPillFilled');

const DocumentPillRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h3.2a3.61 3.61 0 01-.29-1H6a1 1 0 01-1-1V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v1.2c.32-.14.66-.24 1-.29v-1.5c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zm3.55 3.65a2.62 2.62 0 00-3.7 0l-4 4a2.62 2.62 0 003.7 3.7l4-4a2.62 2.62 0 000-3.7zm-3 .7a1.62 1.62 0 112.3 2.3L16 15.29 13.7 13l1.65-1.65zm-2.2 4.3a.5.5 0 01.7.7l-1 1a.5.5 0 01-.7-.7l1-1z",
    fill: primaryFill
  }));
};

export const DocumentPillRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentPillRegularIcon({}), 'DocumentPillRegular');

const DocumentProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 004 9.2V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zm-8.68 9.07a4.5 4.5 0 106.36 6.36 4.5 4.5 0 00-6.36-6.36zm5.65 5.65a3.5 3.5 0 01-4.57.33l4.9-4.9a3.5 3.5 0 01-.33 4.57zM7.6 11.7l-4.9 4.9a3.5 3.5 0 014.9-4.9z",
    fill: primaryFill
  }));
};

export const DocumentProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentProhibitedFilledIcon({}), 'DocumentProhibitedFilled');

const DocumentProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 01-2 2H9.74c.26-.3.48-.64.66-1H14a1 1 0 001-1V8h-3.5A1.5 1.5 0 0110 6.5V3H6a1 1 0 00-1 1v5.02c-.34.03-.68.1-1 .19V4zm7-.8v3.3c0 .28.22.5.5.5h3.3L11 3.2zM8.68 17.69a4.5 4.5 0 11-6.36-6.36 4.5 4.5 0 016.36 6.36zM3.4 17.3a3.5 3.5 0 004.9-4.9l-4.9 4.9zm-.7-.7l4.9-4.9a3.5 3.5 0 00-4.9 4.9z",
    fill: primaryFill
  }));
};

export const DocumentProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentProhibitedRegularIcon({}), 'DocumentProhibitedRegular');

const DocumentQuestionMarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 004 9.2V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM10 14.5a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-4.5 1.88a.62.62 0 110 1.25.62.62 0 010-1.25zm0-4.88c1.03 0 1.85.85 1.85 1.95 0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 01-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 11-1 0c-.01-1.13.8-1.95 1.85-1.95z",
    fill: primaryFill
  }));
};

export const DocumentQuestionMarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentQuestionMarkFilledIcon({}), 'DocumentQuestionMarkFilled');

const DocumentQuestionMarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM10 14.5a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-4.5 1.88a.62.62 0 110 1.25.62.62 0 010-1.25zm0-4.88c1.03 0 1.85.85 1.85 1.95 0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 01-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 11-1 0c-.01-1.13.8-1.95 1.85-1.95z",
    fill: primaryFill
  }));
};

export const DocumentQuestionMarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentQuestionMarkRegularIcon({}), 'DocumentQuestionMarkRegular');

const DocumentQueueFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v6.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 14.5v-11C4 2.67 4.67 2 5.5 2H10zM6.5 5a.5.5 0 000 1h2a.5.5 0 000-1h-2zM6 7.5c0 .28.22.5.5.5h2a.5.5 0 000-1h-2a.5.5 0 00-.5.5zM6.5 9a.5.5 0 000 1h2a.5.5 0 000-1h-2zM11 2.25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM2.5 13c.28 0 .5.22.5.5v1A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-1a.5.5 0 011 0v1a3.5 3.5 0 01-3.5 3.5h-9A3.5 3.5 0 012 14.5v-1c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentQueueFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentQueueFilledIcon({}), 'DocumentQueueFilled');

const DocumentQueueRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 5a.5.5 0 000 1h2a.5.5 0 000-1h-2zM6 7.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zM6.5 9a.5.5 0 000 1h2a.5.5 0 000-1h-2zm3.98-7h.04c.45.01.88.2 1.2.51l3.77 3.77A1.75 1.75 0 0116 7.5v6.75c0 .97-.78 1.75-1.75 1.75h-8.5C4.78 16 4 15.22 4 14.25V3.75C4 2.78 4.78 2 5.75 2h4.73zM5 3.75v10.5c0 .41.34.75.75.75h8.5c.41 0 .75-.34.75-.75V8h-3.5A1.5 1.5 0 0110 6.5V3H5.75a.75.75 0 00-.75.75zm6 2.75c0 .28.22.5.5.5h3.3l-.02-.01-3.77-3.77-.01-.01V6.5zm-8 7a.5.5 0 00-1 0v1A3.5 3.5 0 005.5 18h9a3.5 3.5 0 003.5-3.5v-1a.5.5 0 00-1 0v1a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-1z",
    fill: primaryFill
  }));
};

export const DocumentQueueRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentQueueRegularIcon({}), 'DocumentQueueRegular');

const DocumentQueueAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v11c0 .83.67 1.5 1.5 1.5h3.7A5.5 5.5 0 0116 9.2V8h-4.5A1.5 1.5 0 0110 6.5zm-4-1c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zM6.5 7h2a.5.5 0 010 1h-2a.5.5 0 010-1zM6 9.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zM5.5 17h4.1c.18.36.4.7.66 1H5.5A3.5 3.5 0 012 14.5v-1a.5.5 0 011 0v1A2.5 2.5 0 005.5 17zM11 6.5V2.25L15.75 7H11.5a.5.5 0 01-.5-.5zm8 8a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const DocumentQueueAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentQueueAddFilledIcon({}), 'DocumentQueueAddFilled');

const DocumentQueueAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 2H5.74C4.78 2 4 2.78 4 3.75v10.5c0 .97.78 1.75 1.75 1.75h3.46c-.1-.32-.16-.66-.19-1H5.75a.75.75 0 01-.75-.75V3.75c0-.41.34-.75.75-.75H10v3.5c0 .83.67 1.5 1.5 1.5H15v1.02c.34.03.68.1 1 .19V7.5v-.02c-.01-.45-.2-.88-.51-1.2l-3.77-3.77A1.75 1.75 0 0010.5 2zm.5 1.2l.01.02 3.77 3.77.01.01H11.5a.5.5 0 01-.5-.5V3.2zM5.5 17h4.1c.18.36.4.7.66 1H5.5A3.5 3.5 0 012 14.5v-1a.5.5 0 011 0v1A2.5 2.5 0 005.5 17zM6 5.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zM6.5 7a.5.5 0 000 1h2a.5.5 0 000-1h-2zm0 2a.5.5 0 000 1h2a.5.5 0 000-1h-2zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const DocumentQueueAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentQueueAddRegularIcon({}), 'DocumentQueueAddRegular');

const DocumentQueueMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.38 3.75l1.11 1.12L16 7.37v-.66c0-.46-.18-.9-.5-1.23l-2.4-2.44A3.5 3.5 0 0010.6 2H5.75C4.83 2 4.07 2.72 4 3.62 4.48 3.23 5.1 3 5.75 3h4.85c.67 0 1.31.27 1.78.75zM2.5 13c.28 0 .5.22.5.5v1A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-1a.5.5 0 011 0v1a3.5 3.5 0 01-3.5 3.5h-9A3.5 3.5 0 012 14.5v-1c0-.28.22-.5.5-.5zM10 4v4.5c0 .83.67 1.5 1.5 1.5H16v4.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 14.5v-9C4 4.67 4.67 4 5.5 4H10zM6 7.5c0 .28.22.5.5.5h2a.5.5 0 000-1h-2a.5.5 0 00-.5.5zM6.5 9a.5.5 0 000 1h2a.5.5 0 000-1h-2zM6 11.5c0 .28.22.5.5.5h2a.5.5 0 000-1h-2a.5.5 0 00-.5.5zm5-7.25V8.5c0 .28.22.5.5.5h4.25L11 4.25z",
    fill: primaryFill
  }));
};

export const DocumentQueueMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentQueueMultipleFilledIcon({}), 'DocumentQueueMultipleFilled');

const DocumentQueueMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.38 3.75l1.11 1.12L16 7.37v-.66c0-.46-.18-.9-.5-1.23l-2.4-2.44A3.5 3.5 0 0010.6 2H5.75C4.83 2 4.07 2.72 4 3.62 4.48 3.23 5.1 3 5.75 3h4.85c.67 0 1.31.27 1.78.75zM2.5 13c.28 0 .5.22.5.5v1A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-1a.5.5 0 011 0v1a3.5 3.5 0 01-3.5 3.5h-9A3.5 3.5 0 012 14.5v-1c0-.28.22-.5.5-.5zM6 7.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zM6.5 9a.5.5 0 000 1h2a.5.5 0 000-1h-2zM6 11.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm10-2v-.02c-.01-.45-.2-.88-.51-1.2l-3.77-3.77A1.75 1.75 0 0010.5 4H5.74C4.78 4 4 4.78 4 5.75v8.5c0 .97.78 1.75 1.75 1.75h8.5c.97 0 1.75-.78 1.75-1.75V9.51zM5 5.76c0-.41.34-.75.75-.75H10v3.5c0 .83.67 1.5 1.5 1.5H15v4.25c0 .41-.34.75-.75.75h-8.5a.75.75 0 01-.75-.75v-8.5zm6-.54l.01.01 3.77 3.77.01.01H11.5a.5.5 0 01-.5-.5V5.2z",
    fill: primaryFill
  }));
};

export const DocumentQueueMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentQueueMultipleRegularIcon({}), 'DocumentQueueMultipleRegular');

const DocumentRibbonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H8v-2.35a4 4 0 00-4-6.52V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM8 13a3 3 0 11-6 0 3 3 0 016 0zm-1 3.46a3.98 3.98 0 01-4 0v2.29c0 .2.21.31.38.21L5 18l1.62.96c.17.1.38-.02.38-.21v-2.29z",
    fill: primaryFill
  }));
};

export const DocumentRibbonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentRibbonFilledIcon({}), 'DocumentRibbonFilled');

const DocumentRibbonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.13A4 4 0 015 9V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1H8v1h6a2 2 0 002-2V7.4c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM8 13a3 3 0 11-6 0 3 3 0 016 0zm-1 3.46a3.98 3.98 0 01-4 0v2.29c0 .2.21.31.38.21L5 18l1.62.96c.17.1.38-.02.38-.21v-2.29z",
    fill: primaryFill
  }));
};

export const DocumentRibbonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentRibbonRegularIcon({}), 'DocumentRibbonRegular');

const DocumentSaveFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H11v-5.59a2 2 0 00-.59-1.41L9 9.59A2 2 0 007.59 9H4V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM2 10h1v2.5c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-2.41c.1.05.2.12.3.2l1.4 1.42a1 1 0 01.3.7V18a1 1 0 01-1 1v-4.5a.5.5 0 00-.5-.5h-6a.5.5 0 00-.5.5V19a1 1 0 01-1-1v-7a1 1 0 011-1zm6 5v4H3v-4h5zm-4-5h3v2H4v-2z",
    fill: primaryFill
  }));
};

export const DocumentSaveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentSaveFilledIcon({}), 'DocumentSaveFilled');

const DocumentSaveRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5h1V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3v1h3a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM4 10h3v2H4v-2zm-2 0h1v2.5c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-2.41c.1.05.2.12.3.2l1.4 1.42a1 1 0 01.3.7V18a1 1 0 01-1 1v-4.5a.5.5 0 00-.5-.5h-6a.5.5 0 00-.5.5V19a1 1 0 01-1-1v-7a1 1 0 011-1zm6 5v4H3v-4h5z",
    fill: primaryFill
  }));
};

export const DocumentSaveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentSaveRegularIcon({}), 'DocumentSaveRegular');

const DocumentSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2h5v4.5c0 .83.67 1.5 1.5 1.5H16v9a1 1 0 01-1 1h-1.09a1.5 1.5 0 00-.35-.56l-3.13-3.13A4.98 4.98 0 006 7c-.71 0-1.39.15-2 .42V3a1 1 0 011-1zm6 0l5 5h-4.5a.5.5 0 01-.5-.5V2zm-1 10c0 .92-.31 1.78-.84 2.45l3.7 3.7a.5.5 0 11-.72.7l-3.69-3.69A4 4 0 1110 12zm-4 3a3 3 0 100-6 3 3 0 000 6z",
    fill: primaryFill
  }));
};

export const DocumentSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentSearchFilledIcon({}), 'DocumentSearchFilled');

const DocumentSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 12c0 .92-.31 1.78-.84 2.45l3.7 3.7a.5.5 0 11-.72.7l-3.69-3.69A4 4 0 1110 12zm-4 3a3 3 0 100-6 3 3 0 000 6zM5.5 3a.5.5 0 00-.5.5v3.6c-.35.07-.68.18-1 .32V3.5C4 2.67 4.67 2 5.5 2h5.09c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06v9.09c0 .83-.67 1.5-1.5 1.5h-.59a1.5 1.5 0 00-.35-.56l-.44-.44h1.38a.5.5 0 00.5-.5V8h-3.5A1.5 1.5 0 0110 6.5V3H5.5zm5.5.2v3.3c0 .28.22.5.5.5h3.3L11 3.2z",
    fill: primaryFill
  }));
};

export const DocumentSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentSearchRegularIcon({}), 'DocumentSearchRegular');

const DocumentSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H8.66A5.5 5.5 0 004 8.2V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zm-7.94 8.2a2 2 0 01-1.43 2.47l-.46.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 013 16.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 018 10.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zM5.5 14.5a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const DocumentSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentSettingsFilledIcon({}), 'DocumentSettingsFilled');

const DocumentSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v4.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1H9.74c-.31.38-.67.72-1.08 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM3.05 10.44a2 2 0 01-1.43 2.48l-.46.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 013 16.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 018 10.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zM5.5 14.5a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const DocumentSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentSettingsRegularIcon({}), 'DocumentSettingsRegular');

const DocumentSplitHintFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v1.5a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-6C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM5 12a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zm11 0a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zM5 15.5a.5.5 0 00-1 0v.5c0 1.1.9 2 2 2h.5a.5.5 0 000-1H6a1 1 0 01-1-1v-.5zm11 0a.5.5 0 00-1 0v.5a1 1 0 01-1 1h-.5a.5.5 0 000 1h.5a2 2 0 002-2v-.5zM9 17a.5.5 0 000 1h2a.5.5 0 000-1H9z",
    fill: primaryFill
  }));
};

export const DocumentSplitHintFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentSplitHintFilledIcon({}), 'DocumentSplitHintFilled');

const DocumentSplitHintRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V9.5a.5.5 0 01-1 0V8h-3.5A1.5 1.5 0 0110 6.5V3H6a1 1 0 00-1 1v5.5a.5.5 0 01-1 0V4zm7-.8v3.3c0 .28.22.5.5.5h3.3L11 3.2zm-6.5 8.3c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm11 0c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zM4.5 15c.28 0 .5.22.5.5v.5a1 1 0 001 1h.5a.5.5 0 010 1H6a2 2 0 01-2-2v-.5c0-.28.22-.5.5-.5zm11 0c.28 0 .5.22.5.5v.5a2 2 0 01-2 2h-.5a.5.5 0 010-1h.5a1 1 0 001-1v-.5c0-.28.22-.5.5-.5zm-7 2.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1H9a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentSplitHintRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentSplitHintRegularIcon({}), 'DocumentSplitHintRegular');

const DocumentSplitHintOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4.7v4.8c0 .28.22.5.5.5h4.8l5.7 5.7v.3a1 1 0 01-1 1h-.5a.5.5 0 000 1h.5a2 2 0 001.9-1.39l1.25 1.24a.5.5 0 00.7-.7l-15-15a.5.5 0 10-.7.7L4 4.71zm11 8.18l.6.6A.5.5 0 0016 13v-1a.5.5 0 00-1 0v.88zM4.5 2.38L12.12 10h3.38a.5.5 0 00.5-.5V8h-4.5A1.5 1.5 0 0110 6.5V2H5.5c-.38 0-.73.14-1 .38zm6.5-.13V6.5c0 .28.22.5.5.5h4.25L11 2.25zM5 12a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zm0 3.5a.5.5 0 00-1 0v.5c0 1.1.9 2 2 2h.5a.5.5 0 000-1H6a1 1 0 01-1-1v-.5zm6 1.5H9a.5.5 0 000 1h2a.5.5 0 000-1z",
    fill: primaryFill
  }));
};

export const DocumentSplitHintOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentSplitHintOffFilledIcon({}), 'DocumentSplitHintOffFilled');

const DocumentSplitHintOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4.7v4.8a.5.5 0 001 0V5.7l10 10v.3a1 1 0 01-1 1h-.5a.5.5 0 000 1h.5a2 2 0 001.9-1.39l1.25 1.24a.5.5 0 00.7-.7l-15-15a.5.5 0 10-.7.7L4 4.71zm11 8.18l.6.6A.5.5 0 0016 13v-1a.5.5 0 00-1 0v.88zM4.65 2.53l.7.7A1 1 0 016 3h4v3.5c0 .83.67 1.5 1.5 1.5H15v1.5a.5.5 0 001 0V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6a2 2 0 00-1.35.53zM11 3.2L14.8 7h-3.3a.5.5 0 01-.5-.5V3.2zM4.5 11.5c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm0 3.5c.28 0 .5.22.5.5v.5a1 1 0 001 1h.5a.5.5 0 010 1H6a2 2 0 01-2-2v-.5c0-.28.22-.5.5-.5zM9 18a.5.5 0 010-1h2a.5.5 0 010 1H9z",
    fill: primaryFill
  }));
};

export const DocumentSplitHintOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentSplitHintOffRegularIcon({}), 'DocumentSplitHintOffRegular');

const DocumentSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 004 9.2V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM1 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H6a.5.5 0 010-1h.47a1.99 1.99 0 00-2.38.34.5.5 0 01-.71-.71A3 3 0 017 12.15V12c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 014 16.85V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H5a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const DocumentSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentSyncFilledIcon({}), 'DocumentSyncFilled');

const DocumentSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM1 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H6a.5.5 0 010-1h.47a1.99 1.99 0 00-2.38.34.5.5 0 01-.71-.71A3 3 0 017 12.15V12c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 014 16.85V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H5a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const DocumentSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentSyncRegularIcon({}), 'DocumentSyncRegular');

const DocumentTableFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 15v-2h4v1.5a.5.5 0 01-.5.5H9zm4-4.5V12H9v-2h3.5c.28 0 .5.22.5.5zM7 13h1v2h-.5a.5.5 0 01-.5-.5V13zm1-1v-2h-.5a.5.5 0 00-.5.5V12h1zm2-5.5V2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5zm-4 4C6 9.67 6.67 9 7.5 9h5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 016 14.5v-4zm5-4V2.25L15.75 7H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentTableFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTableFilledIcon({}), 'DocumentTableFilled');

const DocumentTableRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 10.5C6 9.67 6.67 9 7.5 9h5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 016 14.5v-4zM8 15v-2H7v1.5c0 .28.22.5.5.5H8zm1-3h4v-1.5a.5.5 0 00-.5-.5H9v2zm0 3h3.5a.5.5 0 00.5-.5V13H9v2zm-1.5-5a.5.5 0 00-.5.5V12h1v-2h-.5zM6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zM5 4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1H6a1 1 0 01-1-1V4zm9.8 3h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7z",
    fill: primaryFill
  }));
};

export const DocumentTableRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTableRegularIcon({}), 'DocumentTableRegular');

const DocumentTableArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 10.26A5.52 5.52 0 0110.4 12H13v-1.5a.5.5 0 00-.5-.5H9v.26zM13 13h-2.2a5.5 5.5 0 01.18 2h1.52a.5.5 0 00.5-.5V13zM5.5 9c.46 0 .9.06 1.32.16.2-.1.44-.16.68-.16h5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-1.7a5.49 5.49 0 01-1.06 2h4.76c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5V2H5.5C4.67 2 4 2.67 4 3.5v5.7c.48-.13.98-.2 1.5-.2zM11 6.5V2.25L15.75 7H11.5a.5.5 0 01-.5-.5zm-1 8a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35A.5.5 0 008 14.5a.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L6.29 14H3.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const DocumentTableArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTableArrowRightFilledIcon({}), 'DocumentTableArrowRightFilled');

const DocumentTableArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 9c-.24 0-.47.06-.68.16.82.2 1.56.58 2.18 1.1V10h3.5c.28 0 .5.22.5.5V12h-2.6c.16.32.3.65.4 1H13v1.5a.5.5 0 01-.5.5h-1.52c-.03.34-.1.68-.19 1h1.71c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-5zM4 9.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6a2 2 0 00-2 2v5.2zM14.8 7h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35A.5.5 0 008 14.5a.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L6.29 14H3.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const DocumentTableArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTableArrowRightRegularIcon({}), 'DocumentTableArrowRightRegular');

const DocumentTableCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 10.26A5.52 5.52 0 0110.4 12H13v-1.5a.5.5 0 00-.5-.5H9v.26zM13 13h-2.2a5.5 5.5 0 01.18 2h1.52a.5.5 0 00.5-.5V13zM5.5 9c.46 0 .9.06 1.32.16.2-.1.44-.16.68-.16h5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-1.7a5.49 5.49 0 01-1.06 2h4.76c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5V2H5.5C4.67 2 4 2.67 4 3.5v5.7c.48-.13.98-.2 1.5-.2zM11 6.5V2.25L15.75 7H11.5a.5.5 0 01-.5-.5zm-1 8a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L4.5 15.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const DocumentTableCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTableCheckmarkFilledIcon({}), 'DocumentTableCheckmarkFilled');

const DocumentTableCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 9c-.24 0-.47.06-.68.16.82.2 1.56.58 2.18 1.1V10h3.5c.28 0 .5.22.5.5V12h-2.6c.16.32.3.65.4 1H13v1.5a.5.5 0 01-.5.5h-1.52c-.03.34-.1.68-.19 1h1.71c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-5zM4 9.2c.32-.08.66-.15 1-.18V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6a2 2 0 00-2 2v5.2zM14.8 7h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM10 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L4.5 15.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const DocumentTableCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTableCheckmarkRegularIcon({}), 'DocumentTableCheckmarkRegular');

const DocumentTableCubeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.86 12A2 2 0 009 11v-1h3.5c.28 0 .5.22.5.5V12H9.86zM13 13v1.5a.5.5 0 01-.5.5H10v-2h3zM6.27 9.64l-.38-.2a2 2 0 00-1.78 0L4 9.5v-6C4 2.67 4.67 2 5.5 2H10v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.32a2 2 0 00.68-1.5V16h2.5c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-5c-.5 0-.96.25-1.23.64zM11 2.25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM1.03 16.51v-3.77a1 1 0 01.56-.9l3-1.5a1 1 0 01.89 0l3 1.5a1 1 0 01.55.9v3.77a1 1 0 01-.55.9l-3 1.5a1 1 0 01-.9 0l-3-1.5a1 1 0 01-.55-.9zm1.04-3.58a.5.5 0 00.27.66l2.2.92v2.62a.5.5 0 101 0V14.5l2.19-.92a.5.5 0 10-.4-.93l-2.3.98-2.3-.98a.5.5 0 00-.66.27z",
    fill: primaryFill
  }));
};

export const DocumentTableCubeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTableCubeFilledIcon({}), 'DocumentTableCubeFilled');

const DocumentTableCubeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 9c-.5 0-.96.25-1.23.64l.93.46a.5.5 0 01.3-.1H8v.5l.9.45.1.05v-1h3.5c.28 0 .5.22.5.5V12H9.86a2 2 0 01.14.74V13h3v1.5a.5.5 0 01-.5.5H10v1h2.5c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-5zm-3.4.45a2 2 0 01.9-.21V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1H9.94a2 2 0 01-.62 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6a2 2 0 00-2 2v5.5l.1-.05zM14.8 7h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM1.02 16.5v-3.76a1 1 0 01.56-.9l3-1.5a1 1 0 01.89 0l3 1.5a1 1 0 01.55.9v3.77a1 1 0 01-.55.9l-3 1.5a1 1 0 01-.9 0l-3-1.5a1 1 0 01-.55-.9zm1.04-3.57a.5.5 0 00.27.66l2.2.92v2.62a.5.5 0 101 0V14.5l2.19-.92a.5.5 0 10-.4-.93l-2.3.98-2.3-.98a.5.5 0 00-.66.27z",
    fill: primaryFill
  }));
};

export const DocumentTableCubeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTableCubeRegularIcon({}), 'DocumentTableCubeRegular');

const DocumentTableSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 15h3.5a.5.5 0 00.5-.5V13H9v2zm.12 1l1.44 1.44c.16.16.28.36.35.56h3.59c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5V2H5.5C4.67 2 4 2.67 4 3.5v5.53a4.55 4.55 0 012.44.4A1.5 1.5 0 017.5 9h5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5H9.12zM13 12v-1.5a.5.5 0 00-.5-.5H9v2h4zm-2-9.75V6.5c0 .28.22.5.5.5h4.25L11 2.25zM7.3 15.6a3.5 3.5 0 10-.7.7l2.55 2.55a.5.5 0 10.7-.7L7.3 15.6zM7 13.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const DocumentTableSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTableSearchFilledIcon({}), 'DocumentTableSearchFilled');

const DocumentTableSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.44 9.44A1.5 1.5 0 017.5 9h5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5H9.12l-.56-.56c.28-.59.44-1.25.44-1.94V15h3.5a.5.5 0 00.5-.5V13H9v.5c0-1.07-.37-2.06-1-2.83V10h-.5a.5.5 0 00-.15.02 4.5 4.5 0 00-.91-.58zM13 10.5a.5.5 0 00-.5-.5H9v2h4v-1.5zM5 9.03a4.55 4.55 0 00-1 0V4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 01-2 2h-3.09a1.5 1.5 0 00-.35-.56l-.44-.44H14a1 1 0 001-1V8h-3.5A1.5 1.5 0 0110 6.5V3H6a1 1 0 00-1 1v5.03zM11.5 7h3.3L11 3.2v3.3c0 .28.22.5.5.5zm-4.2 8.6a3.5 3.5 0 10-.7.7l2.55 2.55a.5.5 0 10.7-.7L7.3 15.6zM7 13.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const DocumentTableSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTableSearchRegularIcon({}), 'DocumentTableSearchRegular');

const DocumentTableTruckFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.87 11.43l.13.05V10h-.5a.5.5 0 00-.48.35c.39.26.7.64.85 1.08zM13 13H9.32l.47.93a2 2 0 01.21.9V15h2.5a.5.5 0 00.5-.5V13zm-7.17-3l.25.01A1.5 1.5 0 017.5 9h5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5H10v1a2 2 0 01-.27 1h4.77c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5V2H5.5C4.67 2 4 2.67 4 3.5V10h1.83zm7.17.5V12H9v-2h3.5c.28 0 .5.22.5.5zm-2-4V2.25L15.75 7H11.5a.5.5 0 01-.5-.5zM2.17 11C1.52 11 1 11.52 1 12.17v4.66c0 .48.28.88.69 1.07a1.33 1.33 0 002.6.1h.75a1.33 1.33 0 002.58 0H8a1 1 0 001-1v-2.18a1 1 0 00-.1-.44l-.75-1.5a1 1 0 00-.9-.55H7v-.16C7 11.52 6.48 11 5.83 11H2.17zM7 14.33V13h.25c.13 0 .25.07.3.18l.58 1.15H7zm-4.67 3.34a.67.67 0 111.34 0 .67.67 0 01-1.34 0zm4 .66a.67.67 0 110-1.33.67.67 0 010 1.33z",
    fill: primaryFill
  }));
};

export const DocumentTableTruckFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTableTruckFilledIcon({}), 'DocumentTableTruckFilled');

const DocumentTableTruckRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 9a1.5 1.5 0 00-1.42 1.01c.35.04.67.16.94.34A.5.5 0 017.5 10H8v1.48a2 2 0 011.04.96l.28.56H13v1.5a.5.5 0 01-.5.5H10v1h2.5c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-5zm5.5 3H9v-2h3.5c.28 0 .5.22.5.5V12zm-9-2h1V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-4a2 2 0 01-.27 1H14a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6a2 2 0 00-2 2v6zm10.8-3h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM2.16 11C1.52 11 1 11.52 1 12.17v4.66c0 .48.28.88.69 1.07a1.33 1.33 0 002.6.1h.75a1.33 1.33 0 002.58 0H8a1 1 0 001-1v-2.18a1 1 0 00-.1-.44l-.75-1.5a1 1 0 00-.9-.55H7v-.16C7 11.52 6.48 11 5.83 11H2.17zM7 14.33V13h.25c.13 0 .25.07.3.18l.58 1.15H7zm-4.67 3.34a.67.67 0 111.34 0 .67.67 0 01-1.34 0zm4 .66a.67.67 0 110-1.33.67.67 0 010 1.33z",
    fill: primaryFill
  }));
};

export const DocumentTableTruckRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTableTruckRegularIcon({}), 'DocumentTableTruckRegular');

const DocumentTextFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5zM6.5 10h7a.5.5 0 010 1h-7a.5.5 0 010-1zm0 2h7a.5.5 0 010 1h-7a.5.5 0 010-1zm0 2h7a.5.5 0 010 1h-7a.5.5 0 010-1zM11 6.5V2.25L15.75 7H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentTextFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTextFilledIcon({}), 'DocumentTextFilled');

const DocumentTextRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 10a.5.5 0 000 1h7a.5.5 0 000-1h-7zm0 2a.5.5 0 000 1h7a.5.5 0 000-1h-7zm0 2a.5.5 0 000 1h7a.5.5 0 000-1h-7zM4 4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2-1a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1V8h-3.5A1.5 1.5 0 0110 6.5V3H6zm5.5 4h3.3L11 3.2v3.3c0 .28.22.5.5.5z",
    fill: primaryFill
  }));
};

export const DocumentTextRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTextRegularIcon({}), 'DocumentTextRegular');

const DocumentTextClockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v5.7a5.5 5.5 0 014.66.8h4.84a.5.5 0 010 1H9.74c.26.3.48.64.66 1h3.1a.5.5 0 010 1h-2.7c.08.32.15.66.18 1h2.52a.5.5 0 010 1h-2.52a5.48 5.48 0 01-1.24 3h4.76c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5zm1 0V2.25L15.75 7H11.5a.5.5 0 01-.5-.5zM5.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM5 12.5a.5.5 0 011 0V14h1a.5.5 0 010 1H5.5a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const DocumentTextClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTextClockFilledIcon({}), 'DocumentTextClockFilled');

const DocumentTextClockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.74 11a5.53 5.53 0 00-1.08-1h4.84a.5.5 0 010 1H9.74zm.66 1c.16.32.3.65.4 1h2.7a.5.5 0 000-1h-3.1zm.6 2.5c0 .17 0 .34-.02.5h2.52a.5.5 0 000-1h-2.52l.02.5zM5 4v5.02c-.34.03-.68.1-1 .19V4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 01-2 2H9.74c.26-.3.48-.64.66-1H14a1 1 0 001-1V8h-3.5A1.5 1.5 0 0110 6.5V3H6a1 1 0 00-1 1zm6.5 3h3.3L11 3.2v3.3c0 .28.22.5.5.5zm-6 12a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM5 12.5a.5.5 0 011 0V14h1a.5.5 0 010 1H5.5a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const DocumentTextClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTextClockRegularIcon({}), 'DocumentTextClockRegular');

const DocumentTextExtractFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5V11h5.5a1.5 1.5 0 010 3H4v2.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5zm-4 3c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm0 6c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm5-9V2.25L15.75 7H11.5a.5.5 0 01-.5-.5zM2.5 12a.5.5 0 000 1h7a.5.5 0 000-1h-7z",
    fill: primaryFill
  }));
};

export const DocumentTextExtractFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTextExtractFilledIcon({}), 'DocumentTextExtractFilled');

const DocumentTextExtractRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v7h1V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1H6a1 1 0 01-1-1v-2H4v2c0 1.1.9 2 2 2h8a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zm-8.3 3a.5.5 0 000 1h7a.5.5 0 000-1h-7zm-4 2a.5.5 0 000 1h7a.5.5 0 000-1h-7zm4 2a.5.5 0 000 1h7a.5.5 0 000-1h-7z",
    fill: primaryFill
  }));
};

export const DocumentTextExtractRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTextExtractRegularIcon({}), 'DocumentTextExtractRegular');

const DocumentTextLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5V13h2.5a.5.5 0 010-1h7a.5.5 0 010 1h-6c.95 0 1.82.38 2.45 1h3.55a.5.5 0 010 1h-2.84a3.49 3.49 0 010 3h3.84c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5zM6.5 10h7a.5.5 0 010 1h-7a.5.5 0 010-1zM11 6.5V2.25L15.75 7H11.5a.5.5 0 01-.5-.5zM3.5 14a2.5 2.5 0 000 5H4a.5.5 0 000-1h-.5a1.5 1.5 0 010-3H4a.5.5 0 000-1h-.5zM7 14a.5.5 0 000 1h.5a1.5 1.5 0 010 3H7a.5.5 0 000 1h.5a2.5 2.5 0 000-5H7zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentTextLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTextLinkFilledIcon({}), 'DocumentTextLinkFilled');

const DocumentTextLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 01-2 2h-3.34c.15-.31.25-.65.3-1H14a1 1 0 001-1V8h-3.5A1.5 1.5 0 0110 6.5V3H6a1 1 0 00-1 1v9H4V4zm7.5 3h3.3L11 3.2v3.3c0 .28.22.5.5.5zm2 8h-2.84a3.51 3.51 0 00-.71-1h3.55a.5.5 0 010 1zm0-2h-7a.5.5 0 010-1h7a.5.5 0 010 1zm-7-3a.5.5 0 000 1h7a.5.5 0 000-1h-7zm-3 4a2.5 2.5 0 000 5H4a.5.5 0 000-1h-.5a1.5 1.5 0 010-3H4a.5.5 0 000-1h-.5zM7 14a.5.5 0 000 1h.5a1.5 1.5 0 010 3H7a.5.5 0 000 1h.5a2.5 2.5 0 000-5H7zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DocumentTextLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTextLinkRegularIcon({}), 'DocumentTextLinkRegular');

const DocumentTextToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v5.55c.16-.03.33-.05.5-.05h2c.82 0 1.54.4 2 1h5a.5.5 0 010 1H8.95v.04a2.5 2.5 0 011.55.96h3a.5.5 0 010 1h-2.55c.03.16.05.33.05.5v.5h2.5a.5.5 0 010 1H11v2.5c0 .17-.02.34-.05.5h3.55c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0110 6.5zm1 0V2.25L15.75 7H11.5a.5.5 0 01-.5-.5zM3 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15H8v-.5a.5.5 0 00-1 0v.5H4v-.5a.5.5 0 00-1 0v.5H1v-1.5c0-.83.67-1.5 1.5-1.5H3zm4-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v.5h3v-.5zM8 16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 011 17.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0V16z",
    fill: primaryFill
  }));
};

export const DocumentTextToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTextToolboxFilledIcon({}), 'DocumentTextToolboxFilled');

const DocumentTextToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.95 11c-.07-.37-.23-.7-.45-1h5a.5.5 0 010 1H8.95zm1.55 1c.22.3.38.63.45 1h2.55a.5.5 0 000-1h-3zm3 2H11v1h2.5a.5.5 0 000-1zM5 4v5h-.5c-.17 0-.34.02-.5.05V4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 01-2 2h-3.05c.03-.16.05-.33.05-.5V17h3a1 1 0 001-1V8h-3.5A1.5 1.5 0 0110 6.5V3H6a1 1 0 00-1 1zm6.5 3h3.3L11 3.2v3.3c0 .28.22.5.5.5zM3 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15H8v-.5a.5.5 0 00-1 0v.5H4v-.5a.5.5 0 00-1 0v.5H1v-1.5c0-.83.67-1.5 1.5-1.5H3zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zM8 16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 011 17.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0V16z",
    fill: primaryFill
  }));
};

export const DocumentTextToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentTextToolboxRegularIcon({}), 'DocumentTextToolboxRegular');

const DocumentToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H13v-5a2 2 0 00-2-2h-1v-1a2 2 0 00-2-2H5a2 2 0 00-1 .27V3.5C4 2.67 4.67 2 5.5 2H10zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25zM4 12v-1.5C4 9.67 4.67 9 5.5 9h2c.83 0 1.5.67 1.5 1.5V12h1.5c.83 0 1.5.67 1.5 1.5V15H9v-.5a.5.5 0 00-1 0v.5H5v-.5a.5.5 0 00-1 0v.5H1v-1.5c0-.83.67-1.5 1.5-1.5H4zm1-1.5V12h3v-1.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zM9 16h3v1.5c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 011 17.5V16h3v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0V16z",
    fill: primaryFill
  }));
};

export const DocumentToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentToolboxFilledIcon({}), 'DocumentToolboxFilled');

const DocumentToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v4.27A2 2 0 015 8V4a1 1 0 011-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 01-1 1h-1v1h1a2 2 0 002-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0010.59 2H6zm8.8 5h-3.3a.5.5 0 01-.5-.5V3.2L14.8 7zM4 12v-1.5C4 9.67 4.67 9 5.5 9h2c.83 0 1.5.67 1.5 1.5V12h1.5c.83 0 1.5.67 1.5 1.5V15H9v-.5a.5.5 0 00-1 0v.5H5v-.5a.5.5 0 00-1 0v.5H1v-1.5c0-.83.67-1.5 1.5-1.5H4zm1-1.5V12h3v-1.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zM9 16h3v1.5c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 011 17.5V16h3v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0V16z",
    fill: primaryFill
  }));
};

export const DocumentToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentToolboxRegularIcon({}), 'DocumentToolboxRegular');

const DocumentWidthFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2h8a2 2 0 012 2v2.34A1.5 1.5 0 0015.02 8h-.52a1.5 1.5 0 000 3h.52a1.5 1.5 0 00.98 1.66V16a2 2 0 01-2 2H6a2 2 0 01-2-2v-3.34A1.5 1.5 0 004.98 11h.52a1.5 1.5 0 000-3h-.52A1.5 1.5 0 004 6.34V4c0-1.1.9-2 2-2zM3.88 7.42a.5.5 0 01-.05.7l-1 .88H5.5a.5.5 0 110 1H2.83l1 .87a.5.5 0 01-.66.76l-2-1.75a.5.5 0 010-.76l2-1.75a.5.5 0 01.7.05zM17.17 10l-1 .87a.5.5 0 00.66.76l2-1.75a.5.5 0 000-.76l-2-1.75a.5.5 0 00-.66.76l1 .87H14.5a.5.5 0 000 1h2.67z",
    fill: primaryFill
  }));
};

export const DocumentWidthFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentWidthFilledIcon({}), 'DocumentWidthFilled');

const DocumentWidthRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.88 7.42a.5.5 0 01-.05.7l-1 .88H5.5a.5.5 0 010 1H2.83l1 .88a.5.5 0 11-.66.75l-2-1.75a.5.5 0 010-.75l2-1.75a.5.5 0 01.7.04zM17.17 10l-1 .88a.5.5 0 00.66.75l2-1.75a.5.5 0 000-.75l-2-1.75a.5.5 0 00-.66.75l1 .87H14.5a.5.5 0 000 1h2.67zM5 4a1 1 0 011-1h8a1 1 0 011 1v3.5h.02A1.5 1.5 0 0116 6.34V4a2 2 0 00-2-2H6a2 2 0 00-2 2v2.34a1.5 1.5 0 01.98 1.16H5V4zm-.37 8.24c.19-.22.3-.48.35-.74H5V16a1 1 0 001 1h8a1 1 0 001-1v-4.5h.02a1.5 1.5 0 00.98 1.16V16a2 2 0 01-2 2H6a2 2 0 01-2-2v-3.34c.24-.08.45-.22.63-.42z",
    fill: primaryFill
  }));
};

export const DocumentWidthRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentWidthRegularIcon({}), 'DocumentWidthRegular');

const DoorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 4c0-.83.67-1.5 1.5-1.5h8.15A1.5 1.5 0 0115.5 4v12c0 .83-.67 1.5-1.5 1.5H6A1.5 1.5 0 014.5 16V4zM7 11a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const DoorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoorFilledIcon({}), 'DoorFilled');

const DoorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 11a1 1 0 100-2 1 1 0 000 2zM4 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 13h8a1 1 0 001-1V4a1 1 0 00-1-1H6a1 1 0 00-1 1v12a1 1 0 001 1z",
    fill: primaryFill
  }));
};

export const DoorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoorRegularIcon({}), 'DoorRegular');

const DoorArrowLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2.5c-.83 0-1.5.67-1.5 1.5v12c0 .83.67 1.5 1.5 1.5h3.89a5.5 5.5 0 015.61-8.4V4c0-.83-.67-1.5-1.5-1.5H6zM8 10a1 1 0 11-2 0 1 1 0 012 0zm11 4.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const DoorArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoorArrowLeftFilledIcon({}), 'DoorArrowLeftFilled');

const DoorArrowLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 01-.66-1H6a1 1 0 01-1-1V4a1 1 0 011-1h8a1 1 0 011 1v5.02c.34.03.68.1 1 .19V4a2 2 0 00-2-2H6zm2 8a1 1 0 11-2 0 1 1 0 012 0zm11 4.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const DoorArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoorArrowLeftRegularIcon({}), 'DoorArrowLeftRegular');

const DoorArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2.5c-.83 0-1.5.67-1.5 1.5v12c0 .83.67 1.5 1.5 1.5h3.89a5.5 5.5 0 015.61-8.4V4c0-.83-.67-1.5-1.5-1.5H6zM8 10a1 1 0 11-2 0 1 1 0 012 0zm6.5 9a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.35-2.15a.5.5 0 01-.7-.7L15.29 15H12.5a.5.5 0 010-1h2.8l-1.15-1.15a.5.5 0 01.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35l-2 2z",
    fill: primaryFill
  }));
};

export const DoorArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoorArrowRightFilledIcon({}), 'DoorArrowRightFilled');

const DoorArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 01-.66-1H6a1 1 0 01-1-1V4a1 1 0 011-1h8a1 1 0 011 1v5.02c.34.03.68.1 1 .19V4a2 2 0 00-2-2H6zm2 8a1 1 0 11-2 0 1 1 0 012 0zm6.5 9a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.35-2.15a.5.5 0 01-.7-.7L15.29 15H12.5a.5.5 0 010-1h2.8l-1.15-1.15a.5.5 0 01.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35l-2 2z",
    fill: primaryFill
  }));
};

export const DoorArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoorArrowRightRegularIcon({}), 'DoorArrowRightRegular');

const DoorTagFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.3 6.3A1 1 0 1110 8H7a2 2 0 00-2 2v6c0 1.1.9 2 2 2h6a2 2 0 002-2V7.05a4.98 4.98 0 00-8.54-3.59A2 2 0 109.3 6.3zM8 14h4a.5.5 0 010 1H8a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const DoorTagFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoorTagFilledIcon({}), 'DoorTagFilled');

const DoorTagRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.3 6.3A1 1 0 1110 8H7a2 2 0 00-2 2v6c0 1.1.9 2 2 2h6a2 2 0 002-2V7.05a4.98 4.98 0 00-8.54-3.59A2 2 0 109.3 6.3zM11.4 8.4A2 2 0 108.6 5.6a1 1 0 01-1.42-1.42A4 4 0 0114 7V16a1 1 0 01-1 1H7a1 1 0 01-1-1v-6a1 1 0 011-1h3a2 2 0 001.41-.59zM8 14a.5.5 0 000 1h4a.5.5 0 000-1H8z",
    fill: primaryFill
  }));
};

export const DoorTagRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoorTagRegularIcon({}), 'DoorTagRegular');

const DoubleSwipeDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.28 17.78c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 111.06-1.06L5 15.44V5.75a.75.75 0 011.5 0v9.69l1.22-1.22a.75.75 0 011.06 1.06l-2.5 2.5zM2 5.75c0 1.44.81 2.69 2 3.32v-1.9a2.25 2.25 0 113.5 0v1.9A3.75 3.75 0 102 5.75zm10.5 3.32a3.75 3.75 0 113.5 0v-1.9a2.25 2.25 0 10-3.5 0v1.9zm2.28 8.71c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 111.06-1.06l1.22 1.22V5.75a.75.75 0 011.5 0v9.69l1.22-1.22a.75.75 0 111.06 1.06l-2.5 2.5z",
    fill: primaryFill
  }));
};

export const DoubleSwipeDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoubleSwipeDownFilledIcon({}), 'DoubleSwipeDownFilled');

const DoubleSwipeDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.85 17.85a.5.5 0 01-.7 0l-3-3a.5.5 0 11.7-.7L5 16.29V5.5a.5.5 0 111 0v10.8l2.15-2.15a.5.5 0 01.7.7l-3 3zm9 0a.5.5 0 01-.7 0l-3-3a.5.5 0 01.7-.7L14 16.29V5.5a.5.5 0 011 0v10.8l2.15-2.15a.5.5 0 01.7.7l-3 3zM11 5.5c0 1.4.82 2.6 2 3.16V7.5a2.5 2.5 0 113 0v1.16a3.5 3.5 0 10-5-3.16zM4 8.66a3.5 3.5 0 113 0V7.5a2.5 2.5 0 10-3 0v1.16z",
    fill: primaryFill
  }));
};

export const DoubleSwipeDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoubleSwipeDownRegularIcon({}), 'DoubleSwipeDownRegular');

const DoubleSwipeUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.28 2.22a.75.75 0 00-1.06 0l-2.5 2.5a.75.75 0 001.06 1.06L5 4.56v9.69a.75.75 0 001.5 0V4.56l1.22 1.22a.75.75 0 001.06-1.06l-2.5-2.5zM2 14.25c0-1.44.81-2.69 2-3.32v1.9a2.25 2.25 0 103.5 0v-1.9A3.75 3.75 0 112 14.25zm10.5-3.32a3.75 3.75 0 103.5 0v1.9a2.25 2.25 0 11-3.5 0v-1.9zm2.28-8.71a.75.75 0 00-1.06 0l-2.5 2.5a.75.75 0 001.06 1.06l1.22-1.22v9.69a.75.75 0 001.5 0V4.56l1.22 1.22a.75.75 0 101.06-1.06l-2.5-2.5z",
    fill: primaryFill
  }));
};

export const DoubleSwipeUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoubleSwipeUpFilledIcon({}), 'DoubleSwipeUpFilled');

const DoubleSwipeUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.85 2.15a.5.5 0 00-.7 0l-3 3a.5.5 0 10.7.7L5 3.71V14.5a.5.5 0 001 0V3.7l2.15 2.15a.5.5 0 10.7-.7l-3-3zm9 0a.5.5 0 00-.7 0l-3 3a.5.5 0 00.7.7L14 3.71V14.5a.5.5 0 001 0V3.7l2.15 2.15a.5.5 0 00.7-.7l-3-3zM11 14.5c0-1.4.82-2.6 2-3.16v1.16a2.5 2.5 0 103 0v-1.16a3.5 3.5 0 11-5 3.16zm-7-3.16a3.5 3.5 0 103 0v1.16a2.5 2.5 0 11-3 0v-1.16z",
    fill: primaryFill
  }));
};

export const DoubleSwipeUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoubleSwipeUpRegularIcon({}), 'DoubleSwipeUpRegular');

const DoubleTapSwipeDownFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.53 17.78c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 011.06-1.06l1.22 1.22V7.75a.75.75 0 111.5 0v7.69l1.22-1.22a.75.75 0 111.06 1.06l-2.5 2.5zM4.25 7.5a5.75 5.75 0 004 5.48v-1.6a4.25 4.25 0 113.5 0v1.6a5.75 5.75 0 10-7.5-5.48zm2.5 0c0 1.15.6 2.16 1.5 2.74V7.75v-.13-.12a1.75 1.75 0 113.5.12v2.62a3.25 3.25 0 10-5-2.74z",
    fill: primaryFill
  }));
};

export const DoubleTapSwipeDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoubleTapSwipeDownFilledIcon({}), 'DoubleTapSwipeDownFilled');

const DoubleTapSwipeDownRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.35 17.85a.5.5 0 01-.7 0l-3-3a.5.5 0 01.7-.7l2.15 2.14V7.5a.5.5 0 011 0v8.8l2.15-2.15a.5.5 0 01.7.7l-3 3zM4.5 7.5a5.5 5.5 0 004 5.3v-1.06a4.5 4.5 0 113 0v1.05a5.5 5.5 0 10-7-5.29zm2 0c0 1.4.82 2.6 2 3.16V9.5a2.5 2.5 0 113 0v1.16a3.5 3.5 0 10-5-3.16z",
    fill: primaryFill
  }));
};

export const DoubleTapSwipeDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoubleTapSwipeDownRegularIcon({}), 'DoubleTapSwipeDownRegular');

const DoubleTapSwipeUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.53 2.22a.75.75 0 00-1.06 0l-2.5 2.5a.75.75 0 001.06 1.06l1.22-1.22v7.69a.75.75 0 001.5 0V4.56l1.22 1.22a.75.75 0 101.06-1.06l-2.5-2.5zM4.25 12.5a5.75 5.75 0 014-5.48v1.6a4.25 4.25 0 103.5 0v-1.6a5.75 5.75 0 11-7.5 5.48zm2.5 0c0-1.15.6-2.16 1.5-2.74v2.74a1.75 1.75 0 103.5 0V9.76a3.25 3.25 0 11-5 2.74z",
    fill: primaryFill
  }));
};

export const DoubleTapSwipeUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoubleTapSwipeUpFilledIcon({}), 'DoubleTapSwipeUpFilled');

const DoubleTapSwipeUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.35 2.15a.5.5 0 00-.7 0l-3 3a.5.5 0 10.7.7L9.5 3.71v8.79a.5.5 0 001 0V3.7l2.15 2.15a.5.5 0 00.7-.7l-3-3zM4.5 12.5a5.5 5.5 0 014-5.3v1.06a4.5 4.5 0 103 0V7.2a5.5 5.5 0 11-7 5.29zm2 0c0-1.4.82-2.6 2-3.16v1.16a2.5 2.5 0 103 0V9.34a3.5 3.5 0 11-5 3.16z",
    fill: primaryFill
  }));
};

export const DoubleTapSwipeUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoubleTapSwipeUpRegularIcon({}), 'DoubleTapSwipeUpRegular');

const DraftsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.61 8.32l-3.93-3.94-8.04 8.04-.12.13a2 2 0 00-.4.76l-1.1 4.06-.02.08a.5.5 0 00.63.53l4.06-1.1.16-.06a2 2 0 00.73-.46l8.03-8.04zm1.57-5.5a2.78 2.78 0 00-3.93 0l-.87.86 3.94 3.93.86-.86.13-.14c.96-1.09.91-2.75-.13-3.8zM11.65 3H2.5a.5.5 0 000 1h8.15l1-1zm-3 3H2.5a.5.5 0 000 1h5.15l1-1zm-3 3l-1 1H2.5a.5.5 0 110-1h3.15z",
    fill: primaryFill
  }));
};

export const DraftsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DraftsFilledIcon({}), 'DraftsFilled');

const DraftsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.25 2.82l-9.61 9.6-.12.13a2 2 0 00-.4.76l-1.1 4.06-.02.08a.5.5 0 00.63.53l4.06-1.1.16-.06a2 2 0 00.73-.46l9.6-9.6.13-.15a2.78 2.78 0 00-4.06-3.8zm-8.9 10.31l8.04-8.04 2.52 2.52-8.04 8.04-.1.09-.1.07a1 1 0 01-.25.1l-3.2.87.87-3.2.04-.13a1 1 0 01.22-.32zm12.12-9.6l.11.11c.59.7.55 1.75-.1 2.4l-.87.87-2.52-2.53.86-.86.12-.1c.7-.59 1.75-.55 2.4.1zM11.65 3H2.5a.5.5 0 000 1h8.15l1-1zm-3 3H2.5a.5.5 0 000 1h5.15l1-1zm-4 4l1-1H2.5a.5.5 0 000 1h2.15z",
    fill: primaryFill
  }));
};

export const DraftsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DraftsRegularIcon({}), 'DraftsRegular');

const DragFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c.2 0 .39.08.53.22l1.5 1.5a.75.75 0 01-1.06 1.06l-.22-.22v1.69a.75.75 0 01-1.5 0V4.56l-.22.22a.75.75 0 01-1.06-1.06l1.5-1.5A.75.75 0 0110 2zm2 8a2 2 0 11-4 0 2 2 0 014 0zm-9.78-.53a.75.75 0 000 1.06l1.5 1.5a.75.75 0 001.06-1.06l-.22-.22h1.69a.75.75 0 000-1.5H4.56l.22-.22a.75.75 0 00-1.06-1.06l-1.5 1.5zM10 18c.2 0 .39-.08.53-.22l1.5-1.5a.75.75 0 10-1.06-1.06l-.22.22v-1.69a.75.75 0 00-1.5 0v1.69l-.22-.22a.75.75 0 00-1.06 1.06l1.5 1.5c.14.14.33.22.53.22zm7.78-8.53a.75.75 0 010 1.06l-1.5 1.5a.75.75 0 11-1.06-1.06l.22-.22h-1.69a.75.75 0 010-1.5h1.69l-.22-.22a.75.75 0 011.06-1.06l1.5 1.5z",
    fill: primaryFill
  }));
};

export const DragFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DragFilledIcon({}), 'DragFilled');

const DragRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.65 2.15c.2-.2.5-.2.7 0l2 2a.5.5 0 01-.7.7L10.5 3.71V6.5a.5.5 0 01-1 0V3.7L8.35 4.86a.5.5 0 11-.7-.7l2-2zM10 12a2 2 0 100-4 2 2 0 000 4zm0-1a1 1 0 110-2 1 1 0 010 2zm5.85 1.35l2-2a.5.5 0 000-.7l-2-2a.5.5 0 00-.7.7l1.14 1.15H13.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7zm-5.5 5.5l2-2a.5.5 0 00-.7-.7l-1.15 1.14V13.5a.5.5 0 00-1 0v2.8l-1.15-1.15a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0zm-8.2-7.5a.5.5 0 010-.7l2-2a.5.5 0 11.7.7L3.71 9.5H6.5a.5.5 0 010 1H3.7l1.15 1.15a.5.5 0 01-.7.7l-2-2z",
    fill: primaryFill
  }));
};

export const DragRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DragRegularIcon({}), 'DragRegular');

const DrawImageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v9.08c0 .45.55.68.87.36L5.2 14.1l3.74-3.68a1.5 1.5 0 012.1 0l1.74 1.72 2.31-2.3c.53-.54 1.21-.82 1.9-.85V6a3 3 0 00-3-3H6zm8 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1 0a.5.5 0 11-1 0 .5.5 0 011 0zm-2.73 7.17l1.82-1.81-1.74-1.71a.5.5 0 00-.7 0L5.43 15.3c-.23.23-.01.58.3.47l.32-.11c.7-.26 1.76-.55 2.75-.16.28.12.5.28.68.48.15-.5.42-.95.8-1.32zm.71.7l4.83-4.82a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.22.3c-1.12.33-2.8.23-3.31-.18a1.05 1.05 0 01-.32-1.24c.04-.08-.02-.18-.1-.17-.5.07-.9.25-1.3.43-.6.25-1.16.5-1.98.4a1.7 1.7 0 01-1.33-.82c-.12-.2.15-.4.36-.28.37.18.83.33 1.22.24.25-.05.57-.19.94-.34.88-.37 2-.85 2.86-.5.64.26.59.98.4 1.33-.03.07 0 .16.07.18.27.06.65.1 1.11.09 0-.05.02-.1.03-.14l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const DrawImageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawImageFilledIcon({}), 'DrawImageFilled');

const DrawImageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1 0a.5.5 0 10-1 0 .5.5 0 001 0zM3 6a3 3 0 013-3h8a3 3 0 013 3v3c-.34.02-.68.1-1 .23V6a2 2 0 00-2-2H6a2 2 0 00-2 2v8.83c0 .17.21.26.34.14l.8-.8 1.05-1.03.2-.2 2.56-2.5a1.5 1.5 0 012.1 0l1.75 1.7-.71.71-1.74-1.7a.5.5 0 00-.7 0l-2.76 2.7-1.85 1.83A1.2 1.2 0 013 14.83V6zm.4 11.04c.37.18.83.33 1.22.24.25-.05.57-.19.94-.34.88-.37 2-.85 2.86-.5.64.26.59.98.4 1.33-.03.07 0 .16.07.18.27.06.65.1 1.11.09 0-.05.02-.1.03-.14l.37-1.5c.1-.39.3-.74.58-1.02l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.22.3c-1.12.33-2.8.23-3.31-.18a1.05 1.05 0 01-.32-1.24c.04-.08-.02-.18-.1-.17-.5.07-.9.25-1.3.43-.6.25-1.16.5-1.98.4a1.7 1.7 0 01-1.33-.82c-.12-.2.15-.4.36-.28z",
    fill: primaryFill
  }));
};

export const DrawImageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawImageRegularIcon({}), 'DrawImageRegular');

const DrawShapeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v3c-.69.03-1.37.31-1.9.84l-4.83 4.83a3.2 3.2 0 00-.8 1.31c-.16-.19-.39-.35-.67-.47-.99-.4-2.05-.1-2.75.16a12 12 0 00-.41.15c-.38.19-.72.31-1.01.4A1.2 1.2 0 013.47 16c-.3-.26-.47-.64-.47-1.05v-.93V6zm7.98 9.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.22.3c-1.12.33-2.8.23-3.31-.18a1.05 1.05 0 01-.32-1.24c.04-.08-.02-.18-.1-.17-.5.07-.9.25-1.3.43-.6.25-1.16.5-1.98.4a1.7 1.7 0 01-1.33-.82c-.12-.2.15-.4.36-.28.37.18.83.33 1.22.24.25-.05.57-.19.94-.34.88-.37 2-.85 2.86-.5.64.26.59.98.4 1.33-.03.07 0 .16.07.18.27.06.65.1 1.11.09 0-.05.02-.1.03-.14l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const DrawShapeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawShapeFilledIcon({}), 'DrawShapeFilled');

const DrawShapeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v3c-.34.02-.68.1-1 .23V6a2 2 0 00-2-2H6a2 2 0 00-2 2v9.5a.5.5 0 01-1 0V6zm.4 11.04c.37.18.83.33 1.22.24.25-.05.57-.19.94-.34.88-.37 2-.85 2.86-.5.64.26.59.98.4 1.33-.03.07 0 .16.07.18.27.06.65.1 1.11.09 0-.05.02-.1.03-.14l.37-1.5c.1-.39.3-.74.58-1.02l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.22.3c-1.12.33-2.8.23-3.31-.18a1.05 1.05 0 01-.32-1.24c.04-.08-.02-.18-.1-.17-.5.07-.9.25-1.3.43-.6.25-1.16.5-1.98.4a1.7 1.7 0 01-1.33-.82c-.12-.2.15-.4.36-.28z",
    fill: primaryFill
  }));
};

export const DrawShapeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawShapeRegularIcon({}), 'DrawShapeRegular');

const DrawTextFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.14 10.5H6.86L8.5 5.82l1.64 4.68zm.53 1.5l.33.94 1.18-1.17-2.88-8.2a.85.85 0 00-1.6 0L4.04 14a.75.75 0 001.42.5l.87-2.5h4.34zm5.14-2.45l-4.83 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.92.92 0 00-.03.14 4.6 4.6 0 01-1.1-.1c-.08 0-.1-.1-.07-.17.18-.35.23-1.07-.4-1.33-.87-.35-1.99.13-2.87.5-.37.15-.7.29-.94.34-.4.09-.85-.06-1.22-.24-.21-.11-.48.08-.36.28.22.37.61.74 1.33.83.82.1 1.39-.16 1.97-.41.4-.18.8-.36 1.3-.43.09-.01.15.09.11.17-.15.35-.13.9.32 1.24.52.4 2.19.51 3.31.19l1.22-.31c.39-.1.74-.3 1.02-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const DrawTextFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawTextFilledIcon({}), 'DrawTextFilled');

const DrawTextRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.72 11H6.28L8.5 4.79 10.72 11zm.36 1l.22.64.79-.78-3.03-8.47a.6.6 0 00-1.13 0l-3.9 10.95a.5.5 0 10.94.33L5.92 12h5.16zm4.73-2.45l-4.83 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.92.92 0 00-.03.14 4.6 4.6 0 01-1.1-.1c-.08 0-.1-.1-.07-.17.18-.35.23-1.07-.4-1.33-.87-.35-1.99.13-2.87.5-.37.15-.7.29-.94.34-.4.09-.85-.06-1.22-.24-.21-.11-.48.08-.36.28.22.37.61.74 1.33.83.82.1 1.39-.16 1.97-.41.4-.18.8-.36 1.3-.43.09-.01.15.09.11.17-.15.35-.13.9.32 1.24.52.4 2.19.51 3.31.19l1.22-.31c.39-.1.74-.3 1.02-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const DrawTextRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawTextRegularIcon({}), 'DrawTextRegular');

const DrawerAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H13v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H14V3.5zM6 4h2.2c-.08.32-.15.66-.18 1H6a2 2 0 00-2 2h4.2c.1.35.24.68.4 1H4v3h3.5c.28 0 .5.22.5.5a2 2 0 104 0c0-.28.22-.5.5-.5H16v-.6c.36-.18.7-.4 1-.66V15a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3z",
    fill: primaryFill
  }));
};

export const DrawerAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawerAddFilledIcon({}), 'DrawerAddFilled');

const DrawerAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V5h1.5a.5.5 0 010 1H14v1.5a.5.5 0 01-1 0V6h-1.5a.5.5 0 010-1H13V3.5c0-.28.22-.5.5-.5zM17 9.74V15a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h2.2c-.08.32-.15.66-.18 1H6a2 2 0 00-2 2h4.2c.1.35.24.68.4 1H4v3h3.5c.28 0 .5.22.5.5a2 2 0 104 0c0-.28.22-.5.5-.5H16v-.6c.36-.18.7-.4 1-.66zM14 17a2 2 0 002-2v-3h-3.04a3 3 0 01-5.92 0H4v3c0 1.1.9 2 2 2h8z",
    fill: primaryFill
  }));
};

export const DrawerAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawerAddRegularIcon({}), 'DrawerAddRegular');

const DrawerArrowDownloadFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 5.5a4.5 4.5 0 014-4.47v3.76l-.65-.64a.5.5 0 00-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 00-.7-.7l-.65.64V1.03A4.5 4.5 0 119 5.5zm2 2c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5zM6 4h2.2c-.08.32-.15.66-.18 1H6a2 2 0 00-2 2h4.2c.1.35.24.68.4 1H4v3h3.5c.28 0 .5.22.5.5a2 2 0 104 0c0-.28.22-.5.5-.5H16v-.6c.36-.18.7-.4 1-.66V15a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3z",
    fill: primaryFill
  }));
};

export const DrawerArrowDownloadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawerArrowDownloadFilledIcon({}), 'DrawerArrowDownloadFilled');

const DrawerArrowDownloadRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 5.5a4.5 4.5 0 014-4.47v3.76l-.65-.64a.5.5 0 00-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 00-.7-.7l-.65.64V1.03A4.5 4.5 0 119 5.5zm2 2c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5zm6 2.24c-.3.26-.64.48-1 .66v.6h-3.5a.5.5 0 00-.5.5 2 2 0 11-4 0 .5.5 0 00-.5-.5H4V8h4.6c-.16-.32-.3-.65-.4-1H4c0-1.1.9-2 2-2h2.02c.03-.34.1-.68.19-1H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V9.74zM16 15a2 2 0 01-2 2H6a2 2 0 01-2-2v-3h3.04a3 3 0 005.92 0H16v3z",
    fill: primaryFill
  }));
};

export const DrawerArrowDownloadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawerArrowDownloadRegularIcon({}), 'DrawerArrowDownloadRegular');

const DrawerDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7L14.21 5.5l1.14 1.15a.5.5 0 01-.7.7L13.5 6.21l-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0zM8.21 4H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V9.74c-.3.26-.64.48-1 .66v.6h-3.5a.5.5 0 00-.5.5 2 2 0 11-4 0 .5.5 0 00-.5-.5H4V8h4.6c-.16-.32-.3-.65-.4-1H4c0-1.1.9-2 2-2h2.02c.03-.34.1-.68.19-1z",
    fill: primaryFill
  }));
};

export const DrawerDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawerDismissFilledIcon({}), 'DrawerDismissFilled');

const DrawerDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L13.5 4.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L14.21 5.5l1.14-1.15zM17 9.75c-.3.25-.64.47-1 .65v.6h-3.5a.5.5 0 00-.5.5 2 2 0 11-4 0 .5.5 0 00-.5-.5H4V8h4.6c-.16-.32-.3-.65-.4-1H4c0-1.1.9-2 2-2h2.02c.03-.34.1-.68.19-1H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V9.74zM16 15a2 2 0 01-2 2H6a2 2 0 01-2-2v-3h3.04a3 3 0 005.92 0H16v3z",
    fill: primaryFill
  }));
};

export const DrawerDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawerDismissRegularIcon({}), 'DrawerDismissRegular');

const DrawerPlayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.2 4H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V9.74c-.3.26-.64.48-1 .66v.6h-3.5a.5.5 0 00-.5.5 2 2 0 11-4 0 .5.5 0 00-.5-.5H4V8h4.6c-.16-.32-.3-.65-.4-1H4c0-1.1.9-2 2-2h2.02c.03-.34.1-.68.19-1zm5.3 6a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.76-6.59l2.97 1.65a.5.5 0 010 .88l-2.97 1.65a.5.5 0 01-.74-.44v-3.3a.5.5 0 01.74-.44z",
    fill: primaryFill
  }));
};

export const DrawerPlayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawerPlayFilledIcon({}), 'DrawerPlayFilled');

const DrawerPlayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 9.74V15a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h2.2c-.08.32-.15.66-.18 1H6a2 2 0 00-2 2h4.2c.1.35.24.68.4 1H4v3h3.5c.28 0 .5.22.5.5a2 2 0 104 0c0-.28.22-.5.5-.5H16v-.6c.36-.18.7-.4 1-.66zM14 17a2 2 0 002-2v-3h-3.04a3 3 0 01-5.92 0H4v3c0 1.1.9 2 2 2h8zm-.5-7a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.76-6.59l2.97 1.65a.5.5 0 010 .88l-2.97 1.65a.5.5 0 01-.74-.44v-3.3a.5.5 0 01.74-.44z",
    fill: primaryFill
  }));
};

export const DrawerPlayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawerPlayRegularIcon({}), 'DrawerPlayRegular');

const DrawerSubtractFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2 0a.5.5 0 00-.5-.5h-4a.5.5 0 000 1h4a.5.5 0 00.5-.5zM6 4h2.2c-.08.32-.15.66-.18 1H6a2 2 0 00-2 2h4.2c.1.35.24.68.4 1H4v3h3.5c.28 0 .5.22.5.5a2 2 0 104 0c0-.28.22-.5.5-.5H16v-.6c.36-.18.7-.4 1-.66V15a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3z",
    fill: primaryFill
  }));
};

export const DrawerSubtractFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawerSubtractFilledIcon({}), 'DrawerSubtractFilled');

const DrawerSubtractRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2 0a.5.5 0 00-.5-.5h-4a.5.5 0 000 1h4a.5.5 0 00.5-.5zm1 4.24c-.3.26-.64.48-1 .66v.6h-3.5a.5.5 0 00-.5.5 2 2 0 11-4 0 .5.5 0 00-.5-.5H4V8h4.6c-.16-.32-.3-.65-.4-1H4c0-1.1.9-2 2-2h2.02c.03-.34.1-.68.19-1H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V9.74zM16 15a2 2 0 01-2 2H6a2 2 0 01-2-2v-3h3.04a3 3 0 005.92 0H16v3z",
    fill: primaryFill
  }));
};

export const DrawerSubtractRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrawerSubtractRegularIcon({}), 'DrawerSubtractRegular');

const DrinkBeerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2A2.5 2.5 0 004 4.5v11.75c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75V15h.5a2.5 2.5 0 002.5-2.5v-5A2.5 2.5 0 0015.5 5H15v-.5A2.5 2.5 0 0012.5 2h-6zM15 6h.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5H15V6zM5 4.5C5 3.67 5.67 3 6.5 3h6c.83 0 1.5.67 1.5 1.5V5H5v-.5zM12.5 8v6a.5.5 0 01-1 0V8a.5.5 0 011 0zm-3-.5c.28 0 .5.22.5.5v6a.5.5 0 01-1 0V8c0-.28.22-.5.5-.5zm-2 .5v6a.5.5 0 01-1 0V8a.5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const DrinkBeerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrinkBeerFilledIcon({}), 'DrinkBeerFilled');

const DrinkBeerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 8a.5.5 0 00-1 0v6a.5.5 0 001 0V8zm-3-.5c.28 0 .5.22.5.5v6a.5.5 0 01-1 0V8c0-.28.22-.5.5-.5zm-2 .5a.5.5 0 00-1 0v6a.5.5 0 001 0V8zm-1-6A2.5 2.5 0 004 4.5v11.75c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75V15h.5a2.5 2.5 0 002.5-2.5v-5A2.5 2.5 0 0015.5 5H15v-.5A2.5 2.5 0 0012.5 2h-6zM15 6h.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5H15V6zM5 4.5C5 3.67 5.67 3 6.5 3h6c.83 0 1.5.67 1.5 1.5V5H5v-.5zM5 6h9v10.25c0 .41-.34.75-.75.75h-7.5a.75.75 0 01-.75-.75V6z",
    fill: primaryFill
  }));
};

export const DrinkBeerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrinkBeerRegularIcon({}), 'DrinkBeerRegular');

const DrinkCoffeeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.17 3.97C2.52 3.97 2 4.49 2 5.14V10a6 6 0 0011.92 1H15a3 3 0 100-6h-1a1.17 1.17 0 00-1.17-1.03H3.17zM14 6h1a2 2 0 110 4h-1V6z",
    fill: primaryFill
  }));
};

export const DrinkCoffeeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrinkCoffeeFilledIcon({}), 'DrinkCoffeeFilled');

const DrinkCoffeeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.17 3.97C2.52 3.97 2 4.49 2 5.14V10a6 6 0 0011.92 1H15a3 3 0 100-6h-1a1.17 1.17 0 00-1.17-1.03H3.17zM3 5.14c0-.1.08-.17.17-.17h9.66c.1 0 .17.07.17.17V10a5 5 0 01-10 0V5.14zM14 6h1a2 2 0 110 4h-1V6z",
    fill: primaryFill
  }));
};

export const DrinkCoffeeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrinkCoffeeRegularIcon({}), 'DrinkCoffeeRegular');

const DrinkMargaritaFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.1 2.99a.5.5 0 00-.2-.98l-4.5 1a.5.5 0 00-.38.37l-.29 1.12H4.5A.5.5 0 004 5v3.5A2.5 2.5 0 006.5 11H7v.5a3 3 0 002.5 2.96V17h-2a.5.5 0 000 1h5a.5.5 0 100-1h-2v-2.5-.04A3 3 0 0013 11.5V11h.5A2.5 2.5 0 0016 8.5V5a.5.5 0 00-.5-.5h-3.73l.14-.58 4.2-.93zM10.49 5.5L10.11 7H5V5.5h5.48zM15 7h-3.86l.38-1.5H15V7z",
    fill: primaryFill
  }));
};

export const DrinkMargaritaFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrinkMargaritaFilledIcon({}), 'DrinkMargaritaFilled');

const DrinkMargaritaRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.1 2.99a.5.5 0 00-.2-.98l-4.5 1a.5.5 0 00-.38.37l-.29 1.12H4.5A.5.5 0 004 5v3.5A2.5 2.5 0 006.5 11H7v.5a3 3 0 002.5 2.96V17h-2a.5.5 0 000 1h5a.5.5 0 100-1h-2v-2.54A3 3 0 0013 11.5V11h.5A2.5 2.5 0 0016 8.5V5a.5.5 0 00-.5-.5h-3.73l.14-.58 4.2-.93zM10.49 5.5L10.11 7H5V5.5h5.48zM5 8h4.86l-.84 3.38a.5.5 0 00.97.24l.9-3.62H15v.5c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 00-.5.5v1a2 2 0 11-4 0v-1a.5.5 0 00-.5-.5h-1A1.5 1.5 0 015 8.5V8zm10-1h-3.86l.38-1.5H15V7z",
    fill: primaryFill
  }));
};

export const DrinkMargaritaRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrinkMargaritaRegularIcon({}), 'DrinkMargaritaRegular');

const DrinkToGoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.85 2.15c.2.2.2.5 0 .7L12.71 4h1.62c.32 0 .6.2.7.5l.92 2.5c.18.48-.18 1-.7 1h-.34l-1.43 8.34A2 2 0 0111.51 18H8.5a2 2 0 01-1.97-1.66L5.09 8h-.34a.75.75 0 01-.7-1.01l.92-2.5c.11-.3.39-.49.7-.49h5.65a.5.5 0 01.08-.1l1.75-1.75c.2-.2.5-.2.7 0zM5.11 7h9.78l-.73-2H5.85L5.1 7z",
    fill: primaryFill
  }));
};

export const DrinkToGoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrinkToGoFilledIcon({}), 'DrinkToGoFilled');

const DrinkToGoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.85 2.15c.2.2.2.5 0 .7L12.71 4h1.62c.32 0 .6.2.7.5l.92 2.5c.18.48-.18 1-.7 1h-.34l-1.43 8.34A2 2 0 0111.51 18H8.5a2 2 0 01-1.97-1.66L5.09 8h-.34a.75.75 0 01-.7-1.01l.92-2.5c.11-.3.39-.49.7-.49h5.65a.5.5 0 01.08-.1l1.75-1.75c.2-.2.5-.2.7 0zM6.11 8l1.4 8.17a1 1 0 00.98.83h3.02a1 1 0 00.99-.83L13.9 8H6.1zm-1-1h9.78l-.73-2H5.85L5.1 7z",
    fill: primaryFill
  }));
};

export const DrinkToGoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrinkToGoRegularIcon({}), 'DrinkToGoRegular');

const DrinkWineFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 2a.5.5 0 00-.5.5V8a5 5 0 004.5 5v4h-2a.5.5 0 000 1h5a.5.5 0 000-1h-2v-4-.02A5 5 0 0015 8V2.5a.5.5 0 00-.5-.5h-9zM6 5.5V3h8v2.5H6zm7.45 2.58a3.5 3.5 0 01-2.87 2.87.5.5 0 11-.16-.99 2.5 2.5 0 002.05-2.05.5.5 0 01.98.17z",
    fill: primaryFill
  }));
};

export const DrinkWineFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrinkWineFilledIcon({}), 'DrinkWineFilled');

const DrinkWineRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.45 8.08a.5.5 0 00-.98-.17 2.5 2.5 0 01-2.05 2.05.5.5 0 00.16 1 3.5 3.5 0 002.87-2.88zM5.5 2a.5.5 0 00-.5.5V8a5 5 0 004.5 5v4h-2a.5.5 0 000 1h5a.5.5 0 000-1h-2v-4-.02A5 5 0 0015 8V2.5a.5.5 0 00-.5-.5h-9zM6 5.5V3h8v2.5H6zm0 1h8V8a4 4 0 01-8 0V6.5z",
    fill: primaryFill
  }));
};

export const DrinkWineRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DrinkWineRegularIcon({}), 'DrinkWineRegular');

const DriveTrainFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 2a2 2 0 00-2 2v1h-1.59A1.5 1.5 0 008.6 5H7V4a2 2 0 10-4 0v3a2 2 0 104 0V6h1.59c.15.43.48.76.91.91v6.18a1.5 1.5 0 00-.91.91H7v-1a2 2 0 10-4 0v3a2 2 0 104 0v-1h1.59a1.5 1.5 0 002.82 0H13v1a2 2 0 104 0v-3a2 2 0 10-4 0v1h-1.59a1.5 1.5 0 00-.91-.91V6.9c.43-.15.76-.48.91-.91H13v1a2 2 0 104 0V4a2 2 0 00-2-2z",
    fill: primaryFill
  }));
};

export const DriveTrainFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DriveTrainFilledIcon({}), 'DriveTrainFilled');

const DriveTrainRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4a2 2 0 114 0v1h1.59a1.5 1.5 0 012.82 0H13V4a2 2 0 114 0v3a2 2 0 11-4 0V6h-1.59a1.5 1.5 0 01-.91.91v6.18c.43.15.76.48.91.91H13v-1a2 2 0 114 0v3a2 2 0 11-4 0v-1h-1.59a1.5 1.5 0 01-2.82 0H7v1a2 2 0 11-4 0v-3a2 2 0 114 0v1h1.59c.15-.43.48-.76.91-.91V6.9A1.5 1.5 0 018.59 6H7v1a2 2 0 11-4 0V4zm2-1a1 1 0 00-1 1v3a1 1 0 002 0V4a1 1 0 00-1-1zm10 0a1 1 0 00-1 1v3a1 1 0 102 0V4a1 1 0 00-1-1zM5 12a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm9 1v3a1 1 0 102 0v-3a1 1 0 10-2 0z",
    fill: primaryFill
  }));
};

export const DriveTrainRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DriveTrainRegularIcon({}), 'DriveTrainRegular');

const DropFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.65 2.15c.2-.2.5-.2.7 0 .54.53 1.8 2.06 2.95 3.9 1.13 1.82 2.2 4.05 2.2 5.95 0 1.84-.53 3.35-1.5 4.4a5.3 5.3 0 01-4 1.6c-1.61 0-3-.54-4-1.6A6.29 6.29 0 014.5 12c0-1.9 1.07-4.13 2.2-5.95a25.3 25.3 0 012.95-3.9z",
    fill: primaryFill
  }));
};

export const DropFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DropFilledIcon({}), 'DropFilled');

const DropRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.65 2.15c.2-.2.5-.2.7 0 .54.53 1.8 2.06 2.95 3.9 1.13 1.82 2.2 4.05 2.2 5.95 0 1.84-.53 3.35-1.5 4.4a5.3 5.3 0 01-4 1.6c-1.61 0-3-.54-4-1.6A6.29 6.29 0 014.5 12c0-1.9 1.07-4.13 2.2-5.95a25.3 25.3 0 012.95-3.9zm-2.1 4.43C6.43 8.38 5.5 10.4 5.5 12c0 1.66.47 2.9 1.24 3.72A4.3 4.3 0 0010 17a4.3 4.3 0 003.26-1.28A5.3 5.3 0 0014.5 12c0-1.6-.93-3.62-2.05-5.42A26.85 26.85 0 0010 3.24c-.59.67-1.56 1.9-2.45 3.34z",
    fill: primaryFill
  }));
};

export const DropRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DropRegularIcon({}), 'DropRegular');

const DualScreenFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5.5V4H4zm2 9.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zM10.5 4v12H16a2 2 0 002-2V6a2 2 0 00-2-2h-5.5zm2 9h1a.5.5 0 010 1h-1a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const DualScreenFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenFilledIcon({}), 'DualScreenFilled');

const DualScreenRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 13.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1zM4 4h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2zm5.5 1H4a1 1 0 00-1 1v8a1 1 0 001 1h5.5V5zm1 10H16a1 1 0 001-1V6a1 1 0 00-1-1h-5.5v10z",
    fill: primaryFill
  }));
};

export const DualScreenRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenRegularIcon({}), 'DualScreenRegular');

const DualScreenAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm-.5 7.5c1.33 0 2.55-.47 3.5-1.26V16a2 2 0 01-2 2h-5.5V9.27a5.48 5.48 0 004 1.73zm-5-3.2A5.47 5.47 0 019.02 6H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5.5V7.8zM6 15.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const DualScreenAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenAddFilledIcon({}), 'DualScreenAddFilled');

const DualScreenAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zM17 16v-5.6c.36-.18.7-.4 1-.66V16a2 2 0 01-2 2H4a2 2 0 01-2-2V8c0-1.1.9-2 2-2h5.02c.03.34.1.68.19 1H4a1 1 0 00-1 1v8a1 1 0 001 1h5.5V7.8c.25.54.6 1.04 1 1.47V17H16a1 1 0 001-1zm-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const DualScreenAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenAddRegularIcon({}), 'DualScreenAddRegular');

const DualScreenArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85A.5.5 0 0017 5.5a.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 5H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2zM14.5 11c1.33 0 2.55-.47 3.5-1.26V16a2 2 0 01-2 2h-5.5V9.27a5.48 5.48 0 004 1.73zm-5-3.2A5.47 5.47 0 019.02 6H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5.5V7.8zM6 15.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const DualScreenArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenArrowRightFilledIcon({}), 'DualScreenArrowRightFilled');

const DualScreenArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85A.5.5 0 0017 5.5a.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 5H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2zM17 16v-5.6c.36-.18.7-.4 1-.66V16a2 2 0 01-2 2H4a2 2 0 01-2-2V8c0-1.1.9-2 2-2h5.02c.03.34.1.68.19 1H4a1 1 0 00-1 1v8a1 1 0 001 1h5.5V7.8c.25.54.6 1.04 1 1.47V17H16a1 1 0 001-1zm-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const DualScreenArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenArrowRightRegularIcon({}), 'DualScreenArrowRightRegular');

const DualScreenArrowUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.85-2.35l-2 2a.5.5 0 00.7.7L14 4.71V7.5a.5.5 0 001 0V4.7l1.15 1.15a.5.5 0 00.7-.7l-2-2A.5.5 0 0014.5 3a.5.5 0 00-.35.14zM14.5 11c1.33 0 2.55-.47 3.5-1.26V16a2 2 0 01-2 2h-5.5V9.27a5.48 5.48 0 004 1.73zm-5-3.2A5.47 5.47 0 019.02 6H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5.5V7.8zM6 15.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const DualScreenArrowUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenArrowUpFilledIcon({}), 'DualScreenArrowUpFilled');

const DualScreenArrowUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.85-2.35l-2 2a.5.5 0 00.7.7L14 4.71V7.5a.5.5 0 001 0V4.7l1.15 1.15a.5.5 0 00.7-.7l-2-2A.5.5 0 0014.5 3a.5.5 0 00-.35.14zM17 16v-5.6c.36-.18.7-.4 1-.66V16a2 2 0 01-2 2H4a2 2 0 01-2-2V8c0-1.1.9-2 2-2h5.02c.03.34.1.68.19 1H4a1 1 0 00-1 1v8a1 1 0 001 1h5.5V7.8c.25.54.6 1.04 1 1.47V17H16a1 1 0 001-1zm-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm7.5-.5h-1a.5.5 0 000 1h1a.5.5 0 000-1z",
    fill: primaryFill
  }));
};

export const DualScreenArrowUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenArrowUpRegularIcon({}), 'DualScreenArrowUpRegular');

const DualScreenClockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 3a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1V3.5a.5.5 0 00-.5-.5zm0 8c1.33 0 2.55-.47 3.5-1.26V16a2 2 0 01-2 2h-5.5V9.27a5.48 5.48 0 004 1.73zm-5-3.2A5.47 5.47 0 019.02 6H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5.5V7.8zM6 15.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const DualScreenClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenClockFilledIcon({}), 'DualScreenClockFilled');

const DualScreenClockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 3a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1V3.5a.5.5 0 00-.5-.5zM17 16v-5.6c.36-.18.7-.4 1-.66V16a2 2 0 01-2 2H4a2 2 0 01-2-2V8c0-1.1.9-2 2-2h5.02c.03.34.1.68.19 1H4a1 1 0 00-1 1v8a1 1 0 001 1h5.5V7.8c.25.54.6 1.04 1 1.47V17H16a1 1 0 001-1zm-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const DualScreenClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenClockRegularIcon({}), 'DualScreenClockRegular');

const DualScreenClosedAlertFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 5a3 3 0 016 0v2l1.32 1.12a.5.5 0 01-.32.88h-8a.5.5 0 01-.32-.88L10.5 7V5zm3 6a1.5 1.5 0 01-1.42-1h2.83c-.2.58-.76 1-1.41 1zm-4-4.46l-.97.82A1.5 1.5 0 009.5 10h1.52l.12.33A2.5 2.5 0 0014 11.95V15a2 2 0 01-2 2H6a1 1 0 01-1-1V6a1 1 0 011-1h3.5v1.54z",
    fill: primaryFill
  }));
};

export const DualScreenClosedAlertFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenClosedAlertFilledIcon({}), 'DualScreenClosedAlertFilled');

const DualScreenClosedAlertRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 5a3 3 0 016 0v2l1.32 1.12a.5.5 0 01-.32.88h-8a.5.5 0 01-.32-.88L10.5 7V5zm3 6a1.5 1.5 0 01-1.42-1h2.83c-.2.58-.76 1-1.41 1zM6 6h3.5V5H6a1 1 0 00-1 1v10a1 1 0 001 1h6a2 2 0 002-2v-3.05a2.52 2.52 0 01-1 0V15a1 1 0 01-1 1H6V6z",
    fill: primaryFill
  }));
};

export const DualScreenClosedAlertRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenClosedAlertRegularIcon({}), 'DualScreenClosedAlertRegular');

const DualScreenDesktopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h10a2 2 0 012 2v7a2 2 0 01-2 2h-2v2h1a.5.5 0 010 1h-2v-6a3 3 0 00-3-3H4V4zm6 14H7.5V8H10a2 2 0 012 2v6a2 2 0 01-2 2zM4 8h2.5v10H4a2 2 0 01-2-2v-6c0-1.1.9-2 2-2zm5.5 7a.5.5 0 000 1h.5a.5.5 0 000-1h-.5zm-6 .5c0 .28.22.5.5.5h.5a.5.5 0 000-1H4a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const DualScreenDesktopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenDesktopFilledIcon({}), 'DualScreenDesktopFilled');

const DualScreenDesktopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h10a2 2 0 012 2v7a2 2 0 01-2 2h-2v2h1a.5.5 0 010 1h-2v-4h3a1 1 0 001-1V4a1 1 0 00-1-1H6a1 1 0 00-1 1v3H4V4zm-2 6c0-1.1.9-2 2-2h6a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2v-6zm2-1a1 1 0 00-1 1v6a1 1 0 001 1h2.5V9H4zm6 8a1 1 0 001-1v-6a1 1 0 00-1-1H7.5v8H10zm-1-2h.5a.5.5 0 010 1H9a.5.5 0 010-1zm-5 .5c0-.28.22-.5.5-.5H5a.5.5 0 010 1h-.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DualScreenDesktopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenDesktopRegularIcon({}), 'DualScreenDesktopRegular');

const DualScreenDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L15.21 5.5l1.14-1.15zM14.5 11c1.33 0 2.55-.47 3.5-1.26V16a2 2 0 01-2 2h-5.5V9.27a5.48 5.48 0 004 1.73zm-5-3.2A5.47 5.47 0 019.02 6H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5.5V7.8zM6 15.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const DualScreenDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenDismissFilledIcon({}), 'DualScreenDismissFilled');

const DualScreenDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7L15.21 5.5l1.14-1.15zM17 16v-5.6c.36-.18.7-.4 1-.66V16a2 2 0 01-2 2H4a2 2 0 01-2-2V8c0-1.1.9-2 2-2h5.02c.03.34.1.68.19 1H4a1 1 0 00-1 1v8a1 1 0 001 1h5.5V7.8c.25.54.6 1.04 1 1.47V17H16a1 1 0 001-1zm-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const DualScreenDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenDismissRegularIcon({}), 'DualScreenDismissRegular');

const DualScreenGroupFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 16H16a2 2 0 002-2V6a2 2 0 00-2-2h-5.5v12zm-1-12H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5.5V4z",
    fill: primaryFill
  }));
};

export const DualScreenGroupFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenGroupFilledIcon({}), 'DualScreenGroupFilled');

const DualScreenGroupRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zM3 6a1 1 0 011-1h5.5v10H4a1 1 0 01-1-1V6zm7.5 9V5H16a1 1 0 011 1v8a1 1 0 01-1 1h-5.5z",
    fill: primaryFill
  }));
};

export const DualScreenGroupRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenGroupRegularIcon({}), 'DualScreenGroupRegular');

const DualScreenHeaderFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 16h-5.5V8H18v6a2 2 0 01-2 2zm2-9V6a2 2 0 00-2-2h-5.5v3H18zM9.5 7V4H4a2 2 0 00-2 2v1h7.5zM2 8v6c0 1.1.9 2 2 2h5.5V8H2z",
    fill: primaryFill
  }));
};

export const DualScreenHeaderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenHeaderFilledIcon({}), 'DualScreenHeaderFilled');

const DualScreenHeaderRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm7.5 9V7H3v7a1 1 0 001 1h5.5zm1-8v8H16a1 1 0 001-1V7h-6.5z",
    fill: primaryFill
  }));
};

export const DualScreenHeaderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenHeaderRegularIcon({}), 'DualScreenHeaderRegular');

const DualScreenLockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3v1H14a1 1 0 00-1 1v4a1 1 0 001 1h5a1 1 0 001-1V5a1 1 0 00-1-1h-.5V3a2 2 0 10-4 0zm1 1V3a1 1 0 112 0v1h-2zm1 2.25a.75.75 0 110 1.5.75.75 0 010-1.5zM12 9V6h-1.5v12H16a2 2 0 002-2v-5h-4a2 2 0 01-2-2zM4 6a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5.5V6H4zm2 9.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6 0c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DualScreenLockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenLockFilledIcon({}), 'DualScreenLockFilled');